import {globals, globalUser} from "../modules/globals.js";
import {playSoundEffect} from "./sounds.js";
import {
    getViewRosterData,
    getViewRosterMemberData,
    getViewIndiesData,
    getViewTeamsData,
    getViewManagersData,
    addTeam,
    getAddTeamData,
    addSuperstar,
    releaseTalent,
    getRosterMemberNameData,
    changeRosterMemberName,
    getRosterMemberPronounData,
    getRosterMemberBrandData,
    getRosterMemberGimmickData,
    getRosterMemberAlignmentData,
    changeRosterMemberPronoun,
    changeRosterMemberAlignment,
    changeRosterMemberBrand,
    changeSuperstarGraphic, removeSuperstarGimmick, addSuperstarGimmick, disbandTagTeam
} from "../modules/rosters.js";
import {
    addManagerRelationship,
    addStaffTask, getAddManagerRelationshipData, getAddStaffTaskData, getCompanyBrandNames,
    getCompanySelectData, getCompanySuperstarsData,
    getMakeTradeOfferData, getRemoveManagerRelationshipData, removeManagerRelationship
} from "../modules/companies.js";
import {
    getChampionshipPrestigeIconHtml,
    hideContent,
    getRosterMemberMoraleText,
    getRosterMemberAlignmentHtml,
    getRosterMemberMoraleClass,
    getChampionshipsDisplayName,
    getOvernessLevelText,
    getStarRatingHtml,
    getSuperstarTraitHelpHtml,
    getRosterMemberFatigueClass,
    getSuperstarInjuredText,
    runFuseElementsSearch,
    getGimmickDescription,
    getPointsHtml,
    setRating,
    populateBrandNameSelect,
    makeGameRequest,
    getTimesWord, predicateBy, getFeudPotentialHtml,
} from "./ui-helpers.js";
import {
    toTitleCase,
    commaSeparate,
    getMonthsWord,
    getRandomInt,
    getRandomChoice,
    gameLimits
} from "../modules/helpers.js";
import {
    resetAddSuperstarGraphic,
    showChangeAppearancePageGraphic,
    showRosterMemberPageGraphic,
    showTalentDialogPageGraphic
} from "./graphics.js";
import {
    tradeOfferCompetitorSelectHandler,
    loadCompetitorTradeOfferBox,
    runTradeSuperstarsSearch,
    goBackToTradeOffer, loadTradeSuperstarsSelectPage, getMakeTradeOfferRequest, loadTradeSuperstarInfoPage
} from "./trades.js"
import {getViewRankingsData} from "../modules/rankings.js"
import {
    getAddOrEditBrandRequest, getRemoveBrandRequest, getRunBrandDraftRequest, getSaveYearlyBrandDraftSettingsRequest,
    loadAddBrandPage, loadRunBrandDraftPage,
    loadViewBrandsPage, loadYearlyBrandDraftPage,
    runAddBrandSuperstarsSearch
} from "./brands.js"
import {getViewFactionsData} from "../modules/factions.js"
import {
    getAddFactionMembersRequest,
    getAddFactionRequest,
    getDisbandFactionRequest,
    getRemoveFactionLeaderRequest,
    getRemoveFactionMembersRequest,
    getSetFactionLeaderRequest,
    getViewFactionHtml,
    loadAddFactionMembersPage,
    loadAddFactionPage, loadChangeFactionNamePage,
    loadRemoveFactionMembersPage,
    loadSetFactionLeaderPage,
    showViewFactionDetailsPage,
    updateFactionLeaderSelect
} from "./factions.js"
import {getStartNegotiationData, makeNegotiationOffer, negotiationSendToMainRoster} from "../modules/negotiations.js";
import {traitsData} from "../data/traits.js";
import {personalitiesData} from "../data/personalities.js";
import {checkTutorialStepAction} from "./tutorial.js";

const headerClasses = {
    'Champions': 'roster-champions', 'Main Eventers': 'roster-main-eventers',
    'Upper Midcarders': 'roster-upper-midcarders', 'Lower Midcarders': 'roster-lower-midcarders',
    'Jabronis': 'roster-jabronis', 'Managers': 'roster-managers', 'Tag Teams': 'roster-tag-teams',
    'Trios': 'roster-trios', 'Training Roster': 'roster-training', 'Retired': 'roster-retired',
    'Dead': 'roster-dead'
};

let allowGenerateGimmick = true;

// Event handlers
$(document).ready(function() {
    const $rosterContainer = $('#roster-container');
    const $game = $('#game');

    // View roster company select handler
    $rosterContainer.on('change', '.select-company-for-view-roster', async function () {
        let companyUid = parseInt($(this).find(":selected").attr('data-uid'));
        await loadViewRosterPage(companyUid);
    });

    // Roster section select handler
    $rosterContainer.on('change', '.roster-section-select', function(){

        // Reset filter and search
        $('.roster-search-container').hide();
        $('.roster-members-container').show();
        $('.view-roster-filter').removeClass('selected');
        $(".roster-search-input").val('');

        // Scroll to selected section
        const headerClass = headerClasses[$(this).val()];
        $('.' + headerClass)[0].scrollIntoView();
    });

    // Roster filter handler
    $rosterContainer.on('click', '.view-roster-filter', function(){
        let filterName;
        let filterBrandName;

        // Unselect filter
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
        }
        // Select filter
        else {
            $('.view-roster-filter.selected').removeClass('selected');
            $(this).addClass('selected');
            filterName = $(this).attr('data-value');
            filterBrandName = $(this).attr('data-brand-name');
        }

        applyRosterSearchOrFilter('filter', filterName, filterBrandName);
    });

    // Roster search handler
    $rosterContainer.on('input', '.roster-search-input', function(){
        let searchTerm = $(this).val();
        applyRosterSearchOrFilter('search', searchTerm);
    });

    // Roster member click handler
    $rosterContainer.on('click', '.roster-member', async function () {
        let memberUid = parseInt($(this).attr('data-uid'));
        let memberType = $(this).attr('data-type');
        let competitorUid = parseInt($('.select-company-for-view-roster').find(":selected[data-is-competitor]").attr('data-uid'));
        await loadViewRosterMemberPage(memberUid, memberType, competitorUid, '#roster-container');
    });

    // Back to view roster handler
    const $rosterMemberDetails = $('#roster-member-details');
    $rosterMemberDetails.on('click', '.roster-member-details-back-button', function () {  // Previously #back-to-roster

        let element = $rosterMemberDetails.data('element');

        // Go back to view managers page
        if (element === '#view-managers-container') {
            $('.view-managers-company-select').trigger('change')
        }
        // Go back to view teams page
        else if (element === '#view-teams-container') {
            $('.view-teams-company-select').trigger('change')
        }
        else {
            playSoundEffect('success');
            $rosterMemberDetails.hide();

            // Go back to booking page
            if (element === '#booking-container') {
                if ($('#book-tag-team-menu-button').hasClass('selected')) {
                    $('.tag-match-options').find('.selected').trigger('click')
                }
                else if ($('#book-segment-menu-button').hasClass('selected') || $('#book-singles-menu-button').hasClass('selected')) {
                    $('#booking-menu').find('.selected').trigger('click')
                }
                else {
                    $('.view-available-callup-button').trigger('click')
                }
            }
            // Go back to view roster page
            else {
                $(element).fadeIn();

                // Reload graphic on previous page
                if ($(element).hasClass('talent-offer-box')) {
                    const $talentOfferBoxGraphic = $('.talent-offer-box-graphic');
                    if ($talentOfferBoxGraphic.data('graphic')) {
                        showTalentDialogPageGraphic($talentOfferBoxGraphic, $talentOfferBoxGraphic.data('graphic'))
                    }
                }
                if ($(element).hasClass('talent-request-box')) {
                    const $talentRequestGraphic = $('.talent-request-graphic');
                    if ($talentRequestGraphic.data('graphic')) {
                        showTalentDialogPageGraphic($talentRequestGraphic, $talentRequestGraphic.data('graphic'))
                    }
                }

                // Find roster member element
                let rosterMemberUid = $rosterMemberDetails.data('uid');
                let rosterMemberElement = $('.roster-member[data-uid="' + rosterMemberUid + '"]')[0];

                // Scroll to roster member
                if (rosterMemberElement) {
                    Element.prototype.documentOffsetTop = function () {
                        return this.offsetTop + (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0);
                    };
                    let top = rosterMemberElement.documentOffsetTop() - (window.innerHeight / 2);
                    window.scrollTo(0, top);

                    // Highlight roster member
                    setTimeout(function () {
                        $(rosterMemberElement).addClass("flash-red");
                    }, 0);
                    setTimeout(function () {
                        $(rosterMemberElement).removeClass("flash-red");
                    }, 1500);
                }
            }
        }
    });

    // Load add superstar page
    $('#roster-container, #view-managers-container').on('click', '.add-superstar-menu-button', async function () {
        await loadAddSuperstarPage($(this));
    });

    // Load release superstar page
    $rosterContainer.on('click', '#release-superstar-menu-button', async function () {
        await loadReleaseSuperstarPage();
    });

    // Add superstar cost change
    $('#add-superstar select[name="custom-superstar-workrate"], ' +
        '#add-superstar select[name="custom-superstar-charisma"]').on('change', function() {
        updateCustomSuperstarCost();
    });

    // Show/hide superstar graphic
    $("#add-superstar select[name='superstar-graphic-option']").on('change', function () {
        if ($(this).val() === '0') {
            $('#wrestler-graphic').hide();
            $("#add-superstar").find('.character-creator-controls').hide();
        }
        else if ($(this).val() === '1') {
            $('#wrestler-graphic').show();
            $("#add-superstar").find('.character-creator-controls').show();
        }
    });

    // Select superstar trait
    const $container = $('#container');
    $container.on('click', '.superstar-trait-item-container', function() {
        let $this = $(this);
        selectSuperstarTraitElement($this)
    });

    // Show superstar traits button
    $container.on('click', '.superstar-traits-show-button', function() {
        let $this = $(this);
        if ($this.find('span').text() === 'Show Traits') {

            // Hide open containers
            $('.superstar-trait-items-container:visible').each(function(i, e) {
                $(e).hide();
                $(e).siblings('.superstar-traits-selection-container').find('.superstar-traits-show-button span').text('Show Traits');
                $(e).siblings('.superstar-traits-selection-container').find('i').addClass('fa-angle-down').removeClass('fa-angle-up');
                $(e).siblings('.superstar-traits-selection-container').find('.superstar-traits-information').fadeOut('fast');
            });

            // Show this container
            $this.parent().siblings('.superstar-trait-items-container').fadeIn('fast');
            $this.parent().siblings('.superstar-trait-items-container').scrollTop(0);
            $this.find('span').text('Hide Traits');
            $this.find('i').removeClass('fa-angle-down').addClass('fa-angle-up');
            $this.siblings('.superstar-traits-information').fadeIn('fast');
        }
        else {
            // Hide this container
            $this.parent().siblings('.superstar-trait-items-container').fadeOut('fast');
            $this.find('span').text('Show Traits');
            $this.find('i').addClass('fa-angle-down').removeClass('fa-angle-up');
            $this.siblings('.superstar-traits-information').fadeOut('fast');
        }
    });

    // Add superstar button
    $('#add-superstar #add-superstar-button').on('click', async function () {
        await getAddSuperstarRequest();
    });

    // Release superstar button
    $('#release-superstar').on('click', '#release-superstar-button', async function () {
        await getReleaseSuperstarRequest();
    });

    // Go back to view roster
    $game.on('click', '.back-to-view-roster-button', function () {
        let parentContainer = $(this).closest('.box');
        if (parentContainer.data('element') === 'view-managers-container') {
            $('.view-managers-company-select').trigger('change')
        }
        else {
            $('#view-roster-menu-button').trigger('click');
        }
    });

    // Load change name page
    $rosterMemberDetails.on('click', '#edit-name-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        let type = $rosterMemberDetails.data('type');
        await makeGameRequest(getRosterMemberNameData, {uid: uid, type: type}, showRosterMemberNameData,
            {uid: uid, type: type});
    });

    // Load change pronoun page
    $rosterMemberDetails.on('click', '#edit-pronoun-button', async function () {
        let uid = $('#roster-member-details').data('uid');
        await makeGameRequest(getRosterMemberPronounData, {uid}, showRosterMemberPronounData,
            {uid});
    });

    // Load change appearance page
    $rosterMemberDetails.on('click', '#edit-appearance-button', async function () {
        $rosterMemberDetails.hide();
        let uid = $rosterMemberDetails.data('uid');
        await makeGameRequest(getRosterMemberGimmickData, {uid: uid, getCharacters: false}, showRosterMemberAppearanceData, {uid});
    });

    // Load change alignment page
    $rosterMemberDetails.on('click', '#edit-alignment-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        let type = $rosterMemberDetails.data('type');
        await makeGameRequest(getRosterMemberAlignmentData, {uid: uid, type: type}, showRosterMemberAlignmentData,
            {uid: uid, type: type});
    });

    // Load change brand page
    $rosterMemberDetails.on('click', '#edit-superstar-brand-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        let type = $rosterMemberDetails.data('type');
        await makeGameRequest(getRosterMemberBrandData, {uid: uid, type: type}, showRosterMemberBrandData,
            {uid: uid, type: type});
    });

    // Load change gimmick page
    $rosterMemberDetails.on('click', '#edit-gimmick-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        let $el = $(this);
        await makeGameRequest(getRosterMemberGimmickData, {uid}, showRosterMemberGimmickData, {uid, $el});
    });

    // Select gimmick item
    const $createGimmickContainer = $("#create-gimmick-container");
    $createGimmickContainer.on('click', '.gimmick-selection-item', function () {
        playSoundEffect('success');
        let $this = $(this);
        allowGenerateGimmick = false;

        if ($this.hasClass('selected')) {
            $this.removeClass('selected');
            if ($this.hasClass('character-item')) {
                $('.character-selected').text('');
                $(".personality-item").each(function (i, e) {
                    $(e).removeClass('green red dark-yellow')
                });
                $('.gimmick-times-used').text('');
                $('.gimmick-penalty').text('');
                $('.personality-easy-combinations-unlocked').text('');
                $('.personality-easy-combinations-total').text('');
                $('.personality-hard-combinations-unlocked').text('');
                $('.personality-hard-combinations-total').text('');
                $('.combinations-count-divider').text('');
            }
            else if ($this.hasClass('personality-item')) {
                $('.personality-selected').text('');
            }

            // If nothing selected, show default gimmick label
            if (!$('.character-selected').text() && !$('.personality-selected').text()) {
                $('.default-gimmick-label').show()
            }
        }
        else {
            if (!$(this).hasClass('locked')) {
                $this.addClass('selected');
                // Unselect other options
                if ($this.hasClass('character-item')) {

                    // Add selected option to gimmick display
                    $('.character-selected').text($this.text());
                    $(".character-item").each(function (i, e) {
                        if (!$(e).is($this)) {
                            $(e).removeClass('selected');
                        }
                    });

                    // Add highlighting to unlocked combinations
                    let goodCombinations = $this.data('good-combinations') || [];
                    let badCombinations = $this.data('bad-combinations') || [];
                    let okayCombinations = $this.data('okay-combinations') || [];

                    $(".personality-item").each(function (i, e) {
                        let personalityName = $(e).text();
                        $(e).removeClass('green red dark-yellow');
                        if (goodCombinations.indexOf(personalityName) >= 0) {
                            $(e).addClass('green')
                        }
                        else if (badCombinations.indexOf(personalityName) >= 0) {
                            $(e).addClass('red')
                        }
                        else if (okayCombinations.indexOf(personalityName) >= 0) {
                            $(e).addClass('dark-yellow')
                        }
                    });

                    let timesUsed = $this.data('times-used');
                    if (timesUsed) {
                        let timesUsedText = 'Used {0} {1}'.format(timesUsed, getTimesWord(timesUsed));
                        $('.gimmick-times-used').text(timesUsedText);
                        let penalty = getTimesUsedPenalty(timesUsed);
                        $('.gimmick-penalty').text(penalty);
                    }
                    else {
                        $('.gimmick-times-used').text('');
                        $('.gimmick-penalty').text('');
                    }

                    // Show unlock counts
                    let easyCombinationsTotal = $this.data('easy-combinations-total');
                    let easyCombinationsUnlocked = $this.data('easy-combinations-unlocked');
                    if (easyCombinationsTotal) {
                        $('.personality-easy-combinations-total').text(easyCombinationsTotal);
                        $('.personality-easy-combinations-unlocked').text(easyCombinationsUnlocked);
                        $('.combinations-count-divider').text('/');
                    }
                    else {
                        $('.personality-easy-combinations-total').text('');
                        $('.personality-easy-combinations-unlocked').text('');
                        $('.combinations-count-divider').text('');
                    }

                    let hardCombinationsTotal = $this.data('hard-combinations-total');
                    let hardCombinationsUnlocked = $this.data('hard-combinations-unlocked');
                    if (hardCombinationsTotal) {
                        $('.personality-hard-combinations-total').text(hardCombinationsTotal);
                        $('.personality-hard-combinations-unlocked').text(hardCombinationsUnlocked);
                        $('.combinations-count-divider').text('/');
                    }
                    else {
                        $('.personality-hard-combinations-total').text('');
                        $('.personality-hard-combinations-unlocked').text('');
                        $('.combinations-count-divider').text('');
                    }
                }
                else if ($this.hasClass('personality-item')) {
                    // Add selected option to gimmick display
                    $('.personality-selected').text($this.text());
                    $(".personality-item").each(function (i, e) {
                        if (!$(e).is($this)) {
                            $(e).removeClass('selected');
                        }
                    });
                }

                // Hide default gimmick label
                $('.default-gimmick-label').hide();
            }
        }

        // Update combination result
        updateCombinationText();

        // Update gimmick name text
        updateGimmickNameText();

    });

    // Add custom gimmick name
    $createGimmickContainer.on('input focus', '.gimmick-item-custom-name', function () {
        playSoundEffect('success');
        let $this = $(this);
        allowGenerateGimmick = false;

        if ($this.val()) {
            $('.character-selected').hide();
            $('.personality-selected').hide();
            $('.default-gimmick-label').hide();
            $('.custom-gimmick-value').text($this.val());
        }
        else {
            updateGimmickNameText()
        }

        // Update combination result
        updateCombinationText();
    });

    // Gimmick item filter
    $createGimmickContainer.on('click', '.gimmick-item-filter', function () {
        let val = $(this).text().toLowerCase();
        let selected = $(this).hasClass('selected');
        if ($(this).hasClass('character-item-filter')) {
            // Unselect other options and select this one
            $(".character-item-filter").each(function () {
                $(this).removeClass('selected');
            });
            if (selected) {
                // Select 'All'
                $(".character-item").show()
            }
            else {
                // Select this filter
                $(".character-item").each(function (i, e) {
                    if ($(e).attr('data-tag') === val) {
                        $(e).show()
                    }
                    else {
                        $(e).hide()
                    }
                });
                $(this).addClass('selected');
            }
        }
        else if ($(this).hasClass('personality-item-filter')) {
            $(".personality-item-filter").each(function () {
                $(this).removeClass('selected');
            });
            if (selected) {
                // Select 'All'
                $(".personality-item").show()
            }
            else {
                // Select this filter
                $(".personality-item").each(function (i, e) {
                    if ($(e).attr('data-tag') === val) {
                        $(e).show()
                    }
                    else {
                        $(e).hide()
                    }
                });
                $(this).addClass('selected');
            }
        }
        formatGimmickItemsGrid();
    });

    // Generate gimmick
    $createGimmickContainer.on('click', '#generate-gimmick-button', function () {
        if (allowGenerateGimmick) {
            generateGimmick();
            allowGenerateGimmick = true;
        }
        else {
            notie.confirm({
                text: 'Are you sure?',
                submitCallback: function () {
                    generateGimmick();
                    allowGenerateGimmick = true;
                }
            });
        }
    });

    // Back to roster member button
    $("#change-appearance-container, #create-gimmick-container").on('click', '#back-to-roster-member', function () {
        playSoundEffect('success');
        let graphic = $rosterMemberDetails.data('graphic');
        let match = $rosterMemberDetails.data('match');
        const $el = $('.roster-member-graphic');
        $el.html('');
        showRosterMemberPageGraphic(graphic, $el, match);
        hideContent($());
        $rosterMemberDetails.fadeIn();
    });
    $("#change-alignment-container, #change-pronoun-container, #change-brand-container, #change-name-container").on('click',
        '#back-to-roster-member', function () {
        playSoundEffect('success');
        hideContent($());
        if ($(this).closest('[change-name-container]') && $('#change-name-container').data('type') === 'faction') {
            $('.faction-details-container').fadeIn('fast');
        }
        else {
            $rosterMemberDetails.fadeIn('fast');
        }
    });

    // Change appearance option for edit gimmick/appearance
    const $changeAppearanceContainer = $("#change-appearance-container");
    $createGimmickContainer.on('change', 'input[name="radio-gimmick-appearance-option"]', function () {
        let val = $(this).val();
        if (val === 'change') {
            showChangeAppearancePageGraphic($('#gimmick-graphic'))
        }
        else {
            $('#gimmick-graphic').html('');
            $('#gimmick-graphic').next('.character-creator-controls').hide();
        }
    });
    $changeAppearanceContainer.on('change', 'input[name="radio-change-appearance-option"]', function () {
        let val = $(this).val();
        if (val === 'change') {
            showChangeAppearancePageGraphic($('#change-appearance-graphic'))
        }
        else {
            $('#change-appearance-graphic').html('');
            $('#change-appearance-graphic').next('.character-creator-controls').hide();
        }
    });

    // Create gimmick
    $createGimmickContainer.on('click', '#create-gimmick-button', async function () {
        if (!$('.character-selected').text() && !$('.personality-selected').text() && !$('.custom-gimmick-value').text()) {
            notie.alert({type: 3, text: 'Select a Character and/or Personality or enter a Custom Gimmick.', stay: true});
            return false;
        }
        let character = $('.character-selected').text();
        let personality = $('.personality-selected').text();
        let customGimmickName = $('.custom-gimmick-value').text();
        let appearanceOption = $('input[name="radio-gimmick-appearance-option"]:checked').val();
        let uid = $('#gimmick-graphic').data('uid');
        let superstarName = $('#create-gimmick-container .change-name-input').val();
        let alignment = $('#create-gimmick-container .change-alignment-select').val();

        if (superstarName.length <= 0) {
            notie.alert({type: 3, text: 'Enter a name for the Superstar.', stay: true});
            return false;
        }

        // Get graphic if 'change' Appearance selected
        let graphicData;
        if (appearanceOption === 'change') {
            $('#create-gimmick-graphic-container .share-character').trigger('click').removeClass('selected');
            $('#create-gimmick-graphic-container .share-character-code-container').hide();
            graphicData = $('#create-gimmick-graphic-container .share-character-code-input').val();
        }

        await makeGameRequest(addSuperstarGimmick, {uid, character, personality, customGimmickName,
                appearanceOption, graphicData, superstarName, alignment},
            showAddGimmickData, {personality, character}, false);
    });

    // Remove gimmick
    $createGimmickContainer.on('click', '#remove-gimmick-button', async function () {
        notie.confirm({
            text: 'Are you sure?',
            submitCallback: async function () {
                let uid = $('#roster-member-details').data('uid');
                await makeGameRequest(removeSuperstarGimmick, {uid},
                    showRemoveGimmickData, {}, false);
            }
        });
    });

    // Change name
    $("#change-name-container").on('click', '#change-name-button', async function () {
        const $changeNameContainer = $('#change-name-container');
        let name = $('#change-name-container .change-name-input').val();
        let uid = $changeNameContainer.data('uid');
        let type = $changeNameContainer.data('type');
        let memberName = (type === 'superstar') ? 'Superstar' : 'Team/Faction';

        if (name.length <= 0) {
            notie.alert({type: 3, text: 'Enter a name for the {0}.'.format(memberName), stay: true});
            return false;
        }

        await makeGameRequest(changeRosterMemberName, {uid, type, name},
            showChangeNameData, {type, memberName}, false);
    });

    // Change appearance
    $changeAppearanceContainer.on('click', '#change-appearance-button', async function () {

        let appearanceOption = $('input[name="radio-change-appearance-option"]:checked').val();
        let uid = $('#change-appearance-graphic').data('uid');

        // Get graphic if 'change' Appearance selected
        let graphicData;
        if (appearanceOption === 'change') {
            $('#change-appearance-graphic-container .share-character').trigger('click').removeClass('selected');
            $('#change-appearance-graphic-container .share-character-code-container').hide();
            graphicData = $('#change-appearance-graphic-container .share-character-code-input').val();
        }

        await makeGameRequest(changeSuperstarGraphic, {uid, appearanceOption, graphicData},
            showChangeGraphicData, {appearanceOption}, false);
    });

    // Change alignment
    $("#change-alignment-container").on('click', '#change-alignment-button', async function () {
        const $changeAlignmentContainer = $('#change-alignment-container');
        let alignment = $('#change-alignment-container .change-alignment-select').val();
        let uid = $changeAlignmentContainer.data('uid');
        let type = $changeAlignmentContainer.data('type');
        let memberName = (type === 'superstar') ? 'Superstar' : 'Team';

        await makeGameRequest(changeRosterMemberAlignment, {uid, type, alignment},
            showChangeAlignmentData, {type, memberName}, false);
    });

    // Change pronoun
    $("#change-pronoun-container").on('click', '#change-pronoun-button', async function () {
        let pronoun = $('#change-pronoun-container .change-pronoun-select').val();
        let uid = $('#change-pronoun-container').data('uid');

        if (!pronoun) {
            notie.alert({type: 3, text: 'Select a pronoun.', stay: true});
            return false;
        }

        await makeGameRequest(changeRosterMemberPronoun, {uid, pronoun},
            showChangePronounData, {}, false);
    });

    // Change brand
    $("#change-brand-container").on('click', '#change-brand-button', async function () {
        const $changeBrandContainer = $('#change-brand-container');
        let brandName = $('#change-brand-container .change-brand-select').val();
        let uid = $changeBrandContainer.data('uid');
        let type = $changeBrandContainer.data('type');

        await makeGameRequest(changeRosterMemberBrand, {uid, type, brandName},
            showChangeBrandData, {}, false);
    });

    // Release talent
    $rosterMemberDetails.on('click', '#release-talent-button', async function () {
        notie.confirm({
            text: 'Are you sure?',
            submitCallback: async function () {
                let uid = $('#roster-member-details').data('uid');
                let type = $('#roster-member-details').data('type');
                let memberVerb = (type === 'superstar') ? 'has' : 'have';
                await makeGameRequest(releaseTalent, {uid, type}, showReleaseTalentData,
                    {memberVerb: memberVerb}, false);
            }
        });
    });

    // Disband team
    $rosterMemberDetails.on('click', '.disband-team-button', async function (e) {
        let uid = $rosterMemberDetails.data('uid');
        if (!(globals.currentTutorialStep && globals.currentTutorialStep['action'] === 'disband_team')) {
            notie.confirm({
                text: 'Are you sure?',
                submitCallback: async function () {
                    await makeGameRequest(disbandTagTeam, {uid}, showDisbandTagTeamData, {}, false);
                }
            });
        }
        else {
            await makeGameRequest(disbandTagTeam, {uid}, showDisbandTagTeamData, {}, false);
        }
    });

    // Train talent
    $rosterMemberDetails.on('click', '#train-talent-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        let type = $rosterMemberDetails.data('type');
        let rosterMemberName = $('.roster-member-name').text();
        await loadAddStaffTaskPage(uid, type, rosterMemberName, 'train');
    });

    // Prepare for callup
    $rosterMemberDetails.on('click', '#prepare-for-callup-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        let type = $rosterMemberDetails.data('type');
        let rosterMemberName = $('.roster-member-name').text();
        await loadAddStaffTaskPage(uid, type, rosterMemberName, 'prepare');
    });

    // Reassure talent
    $rosterMemberDetails.on('click', '#reassure-talent-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        let type = $rosterMemberDetails.data('type');
        let rosterMemberName = $('.roster-member-name').text();
        await loadAddStaffTaskPage(uid, type, rosterMemberName, 'reassure');
    });

    // Change talent role
    $rosterMemberDetails.on('click', '#transition-talent-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        let type = $rosterMemberDetails.data('type');
        let rosterMemberName = $('.roster-member-name').text();
        await loadAddStaffTaskPage(uid, type, rosterMemberName, 'transition');
    });

    // Rehab talent
    $rosterMemberDetails.on('click', '#rehab-talent-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        let type = $rosterMemberDetails.data('type');
        let rosterMemberName = $('.roster-member-name').text();
        await loadAddStaffTaskPage(uid, type, rosterMemberName, 'rehab');
    });

    // Unlearn trait
    $rosterMemberDetails.on('click', '#unlearn-talent-trait-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        let type = $rosterMemberDetails.data('type');
        let rosterMemberName = $('.roster-member-name').text();
        await loadAddStaffTaskPage(uid, type, rosterMemberName, 'unlearn trait');
    });

    // Transition to staff
    $rosterMemberDetails.on('click', '#transition-talent-to-staff-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        let type = $rosterMemberDetails.data('type');
        let rosterMemberName = $('.roster-member-name').text();
        await loadAddStaffTaskPage(uid, type, rosterMemberName, 'transition (staff)');
    });

    // Add manager relationship for talent
    $rosterMemberDetails.on('click', '#add-manager-relationship-for-talent-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        await loadAddManagerRelationshipPage(uid);
    });

    // Remove manager relationship for talent
    $rosterMemberDetails.on('click', '#remove-manager-relationship-for-talent-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        await loadRemoveManagerRelationshipPage(uid);
    });

    // Indie search handler
    $("#indie").on('input', '.indie-roster-search-input', function() {
        let searchTerm = $(this).val();
        runIndieRosterSearch(searchTerm);
    });

    // Start negotiation
    $rosterMemberDetails.on('click', '#start-negotiation-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        let type = $rosterMemberDetails.data('type');
        await loadStartNegotiationPage(uid, type);
    });

    // Change offer amount buttons
    let timeout, interval;
    [].forEach.call(document.querySelectorAll('.negotiation-box-offer-plus, .negotiation-box-offer-minus'), function (button) {
        button.addEventListener('mousedown', function () {
            if (button.classList.contains('negotiation-box-offer-plus')) {
                incrementNegotiationOfferAmount();
                timeout = setTimeout(function () {
                    interval = setInterval(function () {
                        incrementNegotiationOfferAmount();
                    }, 50);
                }, 300);
            } else {
                decreaseNegotiationOfferAmount();
                timeout = setTimeout(function () {
                    interval = setInterval(function () {
                        decreaseNegotiationOfferAmount();
                    }, 50);
                }, 300);
            }
        });

        button.addEventListener('mouseup', clearTimers);
        button.addEventListener('mouseleave', clearTimers);

        function clearTimers() {
            clearTimeout(timeout);
            clearInterval(interval);
        }
    });

    // Make negotiation offer
    const $negotiationBox = $('.negotiation-box');
    $negotiationBox.on('click', '#make-negotiation-offer', async function() {
        let uid = $negotiationBox.data('uid');
        let amount = parseInt($negotiationBox.find('.negotiation-box-offer-input').val());
        if (!amount) {
            notie.alert({type: 3, text: "Please enter an offer amount"});
            return false;
        }
        if (amount < 0) {
            notie.alert({type: 3, text: "Please enter an offer amount above 0"});
            return false;
        }
        if (amount > 3000) {
            notie.alert({type: 3, text: "Please enter an offer amount below 3000"});
            return false;
        }
        await getMakeNegotiationOfferRequest(uid, amount);
    });

    // Go back to talent from negotiation
    $negotiationBox.on('click', '.negotiation-box-back-button', function () {
        playSoundEffect('success');
        $negotiationBox.hide();
        $rosterMemberDetails.fadeIn();

        // Reload graphic
        const graphic = $rosterMemberDetails.data('graphic');
        const match = $rosterMemberDetails.data('match');
        const $el = $('.roster-member-graphic');
        $el.html('');
        showRosterMemberPageGraphic(graphic, $el, match);
    });

    // Send to main roster button
    $negotiationBox.on('click', '#negotiation-send-to-main-roster-button', async function() {
        let uid = $negotiationBox.data('uid');
        await getNegotiationSendToMainRosterRequest(uid);
    });

    // Scout talent button
    $rosterMemberDetails.on('click', '#scout-talent-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        let type = $rosterMemberDetails.data('type');
        let rosterMemberName = $('.roster-member-name').text();
        await loadAddStaffTaskPage(uid, type, rosterMemberName, 'scout');
    });

    // Recruit talent button
    $rosterMemberDetails.on('click', '#recruit-talent-button', async function () {
        let uid = $rosterMemberDetails.data('uid');
        let type = $rosterMemberDetails.data('type');
        let rosterMemberName = $('.roster-member-name').text();
        await loadAddStaffTaskPage(uid, type, rosterMemberName, 'recruit');
    });

    // Add staff task button
    const $addStaffTaskContainer = $('#add-staff-task-container');
    $addStaffTaskContainer.on('click', '.add-staff-task-button', async function () {
        let staffUid = parseInt($addStaffTaskContainer.find('.add-staff-task-staff-select').find(':selected').val());
        let talentUid = $addStaffTaskContainer.data('talentUid');
        let talentType = $addStaffTaskContainer.data('talentType');
        let taskName = $addStaffTaskContainer.data('task');
        let skillName = $addStaffTaskContainer.find('.add-staff-task-skill-select').find(':selected').val();
        let traitName = $addStaffTaskContainer.find('.add-staff-task-trait-select').find(':selected').val();
        let roleName = $addStaffTaskContainer.find('.add-staff-task-role-select').find(':selected').val();
        await getAddStaffTaskRequest(talentUid, talentType, staffUid, taskName, skillName, traitName, roleName);
    });

    // Add staff task back button
    $addStaffTaskContainer.on('click', '.add-staff-task-back-button', function () {
        hideContent($());
        if ($('#add-staff-task-container').data('talentType') === 'staff') {
            $(".staff-member-details").fadeIn('slow');
        }
        else {
            $("#roster-member-details").fadeIn('slow');
        }
    });

    // View teams company select handler
    const $viewTeamsContainer = $('#view-teams-container');
    $viewTeamsContainer.on('change', '.view-teams-company-select', async function () {
        let companyUid = parseInt($(this).find(":selected").attr('data-uid'));
        await loadViewTeamsPage(companyUid);
    });

    // Team click handler
    $viewTeamsContainer.on('click', '.view-teams-item', async function () {
        if ($(this).hasClass('disabled')) {
            return false;
        }
        let memberUid = parseInt($(this).attr('data-uid'));
        let memberType = 'tagTeam';
        let competitorUid = parseInt($('.view-teams-company-select').find(":selected[data-is-competitor]").attr('data-uid'));
        await loadViewRosterMemberPage(memberUid, memberType, competitorUid, '#view-teams-container');
    });

    // Add team menu button
    $viewTeamsContainer.on('click', '#add-team-menu-button', async function () {
        await loadAddTeamPage();
    });

    $game.on('change', 'select[name="tag-team-type-option"]', function () {
        let val = $(this).val();
        if (val === 'trio') {
            $(this).parent().parent().find('.add-team-third-superstar-select').parent().removeClass('display-none')
        }
        else {
            $(this).parent().parent().find('.add-team-third-superstar-select').parent().addClass('display-none')
        }
    });

    // Add team
    $('#add-team').on('click', '#add-team-button', async function () {
        await getAddTeamRequest();
    });

    // Add team tutorial step checks
    $(".add-team-first-superstar-select").on('change', function () {
        if ($(this).val() === 'Brandon Gray') {
            checkTutorialStepAction('select_team_first_superstar');
        }
    });
    $(".add-team-second-superstar-select").on('change', function () {
        if ($(this).val() === 'Benjamin Dread') {
            checkTutorialStepAction('select_team_second_superstar');
        }
    });

    // Go back to view teams
    $game.on('click', '.back-to-view-teams-button', function () {
        $('.view-teams-company-select').trigger('change');
    });

    // View managers company select handler
    const $viewManagersContainer = $('#view-managers-container');
    $viewManagersContainer.on('change', '.view-managers-company-select', async function () {
        let companyUid = parseInt($(this).find(":selected").attr('data-uid'));
        await loadViewManagersPage(companyUid);
    });

    // Manager click handler
    $viewManagersContainer.on('click', '.view-managers-item', async function () {
        if ($(this).hasClass('disabled')) {
            return false;
        }
        let memberUid = parseInt($(this).attr('data-uid'));
        let memberType = 'superstar';
        let competitorUid = parseInt($('.view-managers-company-select').find(":selected[data-is-competitor]").attr('data-uid'));
        await loadViewRosterMemberPage(memberUid, memberType, competitorUid, '#view-managers-container');
    });

    // Show 'add manager relationship' page
    $viewManagersContainer.on('click', '.add-manager-relationship-menu-button', async function () {
        await loadAddManagerRelationshipPage();
    });

    // Show 'remove manager relationship' page
    $viewManagersContainer.on('click', '.remove-manager-relationship-menu-button', async function () {
        await loadRemoveManagerRelationshipPage();
    });

    // Add talent select for 'add/remove manager relationship' page
    const $addManagerRelationshipAndRemoveManagerRelationship = $('#add-manager-relationship, #remove-manager-relationship');
    $addManagerRelationshipAndRemoveManagerRelationship.on('click', '.manager-relationship-add-talent-select-button', function () {
        // Get existing talent selects
        let parentBox = $(this).closest('.box');
        let talentSelects = parentBox.find('select[name="talent-select"]');

        // Check for maximum talent selects
        if (talentSelects.length >= 15) {
            notie.alert({type: 3, text: 'You cannot select more than 15 talent to manage'});
            return false;
        }

        // Clone talent select, add remove button
        let talentSelectHtml = '<div>' + talentSelects.eq(0).clone().prop('outerHTML') +
            '<button type="button" class="manager-relationship-remove-talent-select-button button retro-button styled-select-button font-bold margin-left-6">' +
            '<i class="fa fa-minus"></i>' +
            '</button></div>';

        // Add talent select after last one
        talentSelects.last().parent().after(talentSelectHtml);
    });

    // Remove talent select for 'add manager relationship' page
    $addManagerRelationshipAndRemoveManagerRelationship.on('click', '.manager-relationship-remove-talent-select-button', function () {
        $(this).parent().remove();
    });

    // Add manager relationship
    $('#add-manager-relationship').on('click', '#add-manager-relationship-button', async function () {
        await getAddManagerRelationshipRequest();
    });

    // Remove manager relationship
    $('#remove-manager-relationship').on('click', '#remove-manager-relationship-button', async function () {
        await getRemoveManagerRelationshipRequest();
    });

    // Go back to view managers
    $game.on('click', '.back-to-view-managers-button', function () {
        $('.view-managers-company-select').trigger('change');
    });

    // Make trade offer competitor select handler
    const $tradeOfferContainer = $(".trade-offer-container");
    $tradeOfferContainer.on('change', '.trade-offer-competitor-select', function () {
        tradeOfferCompetitorSelectHandler($(this));
    });

    // Get available trade superstars
    $tradeOfferContainer.on('click', '.trade-offer-superstar-item', async function () {
        let parent = $('.trade-offer-container');

        // Select company and superstar slot
        parent.find('.trade-offer-superstar-item').removeClass('current-selection');
        $(this).addClass('current-selection');
        parent.find('.trade-offer-superstars-container').removeClass('current-selection');
        $(this).closest('.trade-offer-superstars-container').addClass('current-selection');

        // Load available superstars
        let companyUid = parseInt($(this).closest('.trade-offer-company-container').attr('data-company-uid'));
        await loadTradeSuperstarsSelectPage(companyUid);
    });

    // Show superstar info when clicking on available trade superstar
    $tradeOfferContainer.on('click', '.trade-offer-available-superstar-item', async function() {
        if ($(this).hasClass('disabled')) {
            return false;
        }
        let uid = parseInt($(this).attr('data-uid'));
        $('.trade-offer-container').find('.trade-offer-available-superstar-item').removeClass('selected');
        $(this).addClass('selected');
        await loadTradeSuperstarInfoPage(uid);
    });

    // Select available trade superstar
    $tradeOfferContainer.on('click', '.select-trade-superstar-button', function() {

        let parent = $('.trade-offer-container');

        // Get selected superstar
        let selectedSuperstar = $('.trade-offer-available-superstar-item.selected');
        if (selectedSuperstar.length <= 0) {
            notie.alert({type: 3, text: "Please select a superstar"});
            return false;
        }

        // Check if superstar already added
        let selectedSuperstarUid = selectedSuperstar.attr('data-uid');
        let superstarsContainer = parent.find('.trade-offer-superstars-container.current-selection');
        let superstarElement = superstarsContainer.find('.trade-offer-superstar-item[data-uid="' + selectedSuperstarUid + '"]');
        if (superstarElement.length > 0) {
            notie.alert({type: 3, text: "That superstar has already been selected"});
            return false;
        }

        // Check if superstar is eligible
        if (selectedSuperstar.attr('data-is-champion') === 'true') {
            notie.alert({type: 3, text: "Champions cannot be traded"});
            return false;
        }
        if (selectedSuperstar.attr('data-on-trade-deal') === 'true') {
            notie.alert({type: 3, text: "Superstars already on trade deals cannot be traded"});
            return false;
        }
        if (selectedSuperstar.attr('data-contract-months-remaining') !== 'null') {
            notie.alert({type: 3, text: "Superstars leaving the company cannot be traded"});
            return false;
        }
        if (selectedSuperstar.attr('data-booked') === 'true') {
            notie.alert({type: 3, text: "Superstars already booked for the next event cannot be traded"});
            return false;
        }
        if (selectedSuperstar.attr('data-part-of-trade-offer') === 'true') {
            notie.alert({type: 3, text: "That superstar is already involved in a trade offer"});
            return false;
        }
        if (selectedSuperstar.attr('data-is-owner') === 'true') {
            notie.alert({type: 3, text: "Owners cannot be traded"});
            return false;
        }
        if (selectedSuperstar.attr('data-pow-star') === 'true') {
            notie.alert({type: 3, text: '\"You can\'t trade that talent away!\" - Hank Hughes'});
            return false;
        }

        // Get slot to add superstar to. Select first empty slot if empty slot clicked.
        let superstarName = selectedSuperstar.find('.trade-offer-available-superstar-name').text();
        let superstarSlot = superstarsContainer.find('.trade-offer-superstar-item.current-selection');
        if (!superstarSlot.attr('data-uid')) {
            superstarSlot = superstarsContainer.find('.trade-offer-superstar-item:not([data-uid])').eq(0);
        }

        // Add superstar to slot
        superstarSlot.text(superstarName);
        superstarSlot.attr('data-uid', selectedSuperstarUid);
        superstarSlot.removeClass('light-grey');

        goBackToTradeOffer();
    });

    // Remove trade superstar
    $tradeOfferContainer.on('click', '.remove-trade-superstar-button', function() {
        let parent = $('.trade-offer-container');

        // Reset slot
        let superstarsContainer = parent.find('.trade-offer-superstars-container.current-selection');
        let selectedSlot = superstarsContainer.find('.trade-offer-superstar-item.current-selection');
        selectedSlot.text('Empty');
        selectedSlot.removeAttr('data-uid');
        selectedSlot.addClass('light-grey');

        goBackToTradeOffer();
    });

    // Make trade offer
    $tradeOfferContainer.on('click', '.make-trade-offer-button', async function () {
        let offeredSuperstarsUids = [];
        let requestedSuperstarsUids = [];
        let $tradeOfferContainer = $('.trade-offer-container');
        $tradeOfferContainer.find('.trade-offer-offered-superstar').each(function(i, e) {
            let offeredSuperstarUid = parseInt($(e).attr('data-uid'));
            if (offeredSuperstarUid) {
                offeredSuperstarsUids.push(offeredSuperstarUid)
            }
        });
        $tradeOfferContainer.find('.trade-offer-requested-superstar').each(function(i, e) {
            let requestedSuperstarUid = parseInt($(e).attr('data-uid'));
            if (requestedSuperstarUid) {
                requestedSuperstarsUids.push(requestedSuperstarUid)
            }
        });

        // Validate
        if (offeredSuperstarsUids.length <= 0 || requestedSuperstarsUids.length <= 0) {
            notie.alert({type: 3, text: "Please select at least 1 superstar to trade from each company"});
            return false;
        }

        let duration = parseInt($tradeOfferContainer.find('.trade-offer-duration-select').val());
        let companyUid = parseInt($tradeOfferContainer.find('.trade-offer-receiver-company').attr('data-company-uid'));
        await getMakeTradeOfferRequest(offeredSuperstarsUids, requestedSuperstarsUids, duration, companyUid);
    });

    // Back to trade offer
    $tradeOfferContainer.on('click', '.trade-offer-back-button', function () {
        goBackToTradeOffer();
    });

    // Trade search
    $tradeOfferContainer.on('input', '.trade-offer-search-input', function(){
        runTradeSuperstarsSearch();
    });

    // Roster rankings company/period select handler
    const $rosterRankingsContainer = $('#roster-rankings-container');
    $rosterRankingsContainer.off('change', '.select-company-for-roster-rankings, .roster-rankings-period-select');
    $rosterRankingsContainer.on('change', '.select-company-for-roster-rankings, .roster-rankings-period-select', async function () {
        let companyUid = parseInt($('.select-company-for-roster-rankings').find(":selected").attr('data-uid'));
        let period = $('.roster-rankings-period-select').val();
        await loadViewRankingsPage(companyUid, period);
    });

    // Roster rankings filter handler
    $rosterRankingsContainer.on('click', '.roster-rankings-filter', function(){
        let parent = $(this).parent();
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
        }
        else {
            parent.find('.roster-rankings-filter').removeClass('selected');
            $(this).addClass('selected');
        }
        applyRosterRankingsFilter();
    });

    // View brands company select handler
    const $viewBrandsContainer = $('#view-brands-container');
    $viewBrandsContainer.on('change', '.view-brands-company-select', async function () {
        let companyUid = parseInt($(this).find(":selected").attr('data-uid'));
        await loadViewBrandsPage(companyUid);
    });

    // Show add brand info container
    $viewBrandsContainer.on('click', '.add-brand-menu-button', function () {
        // Check for story
        if (globals.game.story === 'passion' || globals.game.story === 'mars') {
            notie.alert({type: 3, text: "You cannot add Brands in this story"});
            return false;
        }
        // Check for max brands
        if ($("#view-brands-container").find('.view-brands-item').length >= 3) {
            notie.alert({type: 3, text: "You cannot have more than 3 brands."});
            return false;
        }

        // Show add brand info
        hideContent($());
        $('.add-brand-info-container').hide().fadeIn();
    });

    // Show add brand page
    $('.add-brand-info-container').on('click', '.continue-to-add-brand-button', async function () {
        await loadAddBrandPage();
    });

    // Select add brand superstars/championships/events
    const $addBrandContainer = $('.add-brand-container');
    $addBrandContainer.on('click', '.brand-selection-item', function () {
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected')
        }
        else {
            $(this).addClass('selected')
        }

        if ($(this).parent().hasClass('add-brand-selection-superstars')) {
            // Update superstars selected
            let brandSuperstarsSelected = $(this).parent().find('.brand-selection-item.selected');
            let selectedNames = Array.from(brandSuperstarsSelected, function (el) {
                return $(el).find('.brand-selection-item-name').text()
            });
            let superstarsSelected = (selectedNames.length > 0) ? commaSeparate(selectedNames) : '';
            $('.add-brand-selection-superstars-selected').text(superstarsSelected);
        }
    });

    // Add brand superstar search
    $addBrandContainer.on('input', '.add-brand-superstar-search-input', function() {
        runAddBrandSuperstarsSearch();
    });

    // Show brand name preview
    $('.add-brand-name').on('input', function() {
       $('.add-brand-preview').text($(this).val())
    });

    // Change brand name preview color
    $('.add-brand-color').on('move.spectrum change', function (e, tinycolor) {
        let brandColor = (tinycolor) ? tinycolor.toHexString() : '';
        $('.add-brand-color').val(brandColor);
        $('.add-brand-preview').css('color', brandColor)
    });

    // Add brand button
    $addBrandContainer.on('click', '.add-brand-button', async function () {
        await getAddOrEditBrandRequest();
    });

    // Edit brand button
    $addBrandContainer.on('click', '.edit-brand-button', async function () {
        await getAddOrEditBrandRequest(true);
    });

    // Show run draft page
    $viewBrandsContainer.on('click', '.run-brand-draft-menu-button', async function () {
        await loadRunBrandDraftPage();
    });

    // Show yearly draft page
    $viewBrandsContainer.on('click', '.yearly-brand-draft-menu-button', async function () {
        await loadYearlyBrandDraftPage();
    });

    // Run brand draft
    const $runBrandDraftContainer = $('.run-brand-draft-container');
    $runBrandDraftContainer.on('click', '.run-brand-draft-button', async function () {
        await getRunBrandDraftRequest();
    });

    // Save yearly brand draft settings
    const $yearlyBrandDraftContainer = $('.yearly-brand-draft-container');
    $yearlyBrandDraftContainer.on('click', '.yearly-brand-draft-save-button', async function () {
        await getSaveYearlyBrandDraftSettingsRequest();
    });

    // Change draft cost based on type
    $runBrandDraftContainer.on('click', 'input[type="radio"][name="run-brand-draft-type-option"]', function () {
        let value = $(this).val();
        let cost;
        if (value === 'full') {
            cost = 100;
        }
        else if (value === 'shuffle') {
            cost = 50;
        }
        $('.run-brand-draft-cost').text(cost);
    });

    // Change draft info based on draft type
    $('.run-brand-draft-container, .yearly-brand-draft-container').on('click', 'input[type="radio"][name="run-brand-draft-type-option"], ' +
        'input[type="radio"][name="yearly-brand-draft-type-option"]', function () {
        let value = $(this).val();
        if (value === 'full') {
            $(this).parent().siblings('.brand-draft-info').find('.brand-draft-info-content').text(
                'A Full Draft removes all superstars from their current brands. It also resets each brand\'s ' +
                'overness.')
        }
        else if (value === 'shuffle') {
            $(this).parent().siblings('.brand-draft-info').find('.brand-draft-info-content').text(
                'A Brand Shuffle lets you move superstars between brands and keeps the remaining superstars on their ' +
                'current brands.')
        }
    });

    // Show/hide yearly draft options
    $yearlyBrandDraftContainer.on('click', 'input[value="run_yearly_draft"]', function () {
        let value = $(this).prop('checked');
        if (value) {
            $('.yearly-brand-draft-options-container').show()
        }
        else {
            $('.yearly-brand-draft-options-container').hide()
        }
    });

    // Select brands for draft
    $(".run-brand-draft-container, .yearly-brand-draft-container").on('click', '.brand-selection-item', function () {
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected')
        }
        else {
            $(this).addClass('selected')
        }
    });

    // Remove brand
    $('.brand-details-container').on('click', '.remove-brand-button', async function () {
        notie.confirm({
            text: 'Are you sure?',
            submitCallback: async function () {
                let brandUid = $('.brand-details-container').data('brandUid');
                await getRemoveBrandRequest(brandUid);
            }
        });
    });

    // Go back to view brands
    $game.on('click', '.back-to-view-brands-button', function () {
       hideContent($());
       $('#view-brands-container').fadeIn('slow');
    });

    // Go back to brand details
    $game.on('click', '.back-to-brand-details-button', function () {
       hideContent($());
       $('.brand-details-container').fadeIn('slow');
    });

    const $viewFactionsContainer = $('#view-factions-container');
    const $factionsDetailsContainer = $('.faction-details-container');

    // View factions company select handler
    $viewFactionsContainer.on('change', '.view-factions-company-select', async function () {
        let companyUid = parseInt($(this).find(":selected").attr('data-uid'));
        await loadViewFactionsPage(companyUid);
    });

    // Back to view factions button
    $game.on('click', '.back-to-view-factions-button', function () {
        // Go back to booking page
        if ($factionsDetailsContainer.data('element') === '#booking-container') {
            if ($('#book-tag-team-menu-button').hasClass('selected')) {
                $('.tag-match-options').find('.selected').trigger('click')
            }
            else {
                $('#booking-menu').find('.selected').trigger('click')
            }
        }
        // Go back to view factions
        else {
            $('.view-factions-company-select').trigger('change');
        }
    });

    // Add faction page
    $viewFactionsContainer.on('click', '.add-faction-menu-button', async function () {
        await loadAddFactionPage();
    });

    // Update faction leader select
    $('.add-faction-container, #segment-items-container').on('change', '.select-faction-member', function () {
        if ($(this).closest('.add-faction-container').length > 0) {
            updateFactionLeaderSelect($('.add-faction-container'))
        }
        if ($(this).closest('.segment-item-container[data-consequence="create-faction"]').length > 0) {
            updateFactionLeaderSelect($(this).closest('.segment-item-container[data-consequence="create-faction"]'))
        }
    });

    // Add faction member selects
    const $factionContainers = $('.add-faction-members-container, .remove-faction-members-container, .add-faction-container, #segment-items-container');
    $factionContainers.on('click',
        '.add-faction-member-select-button', function () {

            // Get existing faction member selects
            let parentBox = $(this).closest('.box, .segment-item-container');
            let factionMemberSelects = parentBox.find('.select-faction-member');

            // Check for maximum faction member selects
            if (factionMemberSelects.length >= gameLimits.maxFactionSuperstars) {
                notie.alert({type: 3, text: `You cannot select more than ${gameLimits.maxFactionSuperstars} faction members`});
                return false;
            }

            // Clone faction member select, add remove button
            let factionMemberSelectHtml = '<div class="margin-bottom-6">' + factionMemberSelects.eq(0).clone().prop('outerHTML') +
                '<button type="button" class="remove-faction-member-select-button button retro-button styled-select-button font-bold margin-left-6">' +
                '<i class="fa fa-minus"></i>' +
                '</button></div>';

            // Add faction member select after last one
            factionMemberSelects.last().parent().after(factionMemberSelectHtml);

            // Update faction leader select
            if ($(this).closest('.add-faction-container').length > 0) {
                updateFactionLeaderSelect($('.add-faction-container'))
            }
            if ($(this).closest('.segment-item-container[data-consequence="create-faction"]').length > 0) {
                updateFactionLeaderSelect($(this).closest('.segment-item-container[data-consequence="create-faction"]'))
            }
        }
    );

    // Remove faction member selects
    $factionContainers.on('click',
        '.remove-faction-member-select-button', function () {
            let addFactionContainerParent = $(this).closest('.add-faction-container');
            let segmentItemContainerParent = $(this).closest('.segment-item-container[data-consequence="create-faction"]');
            $(this).parent().remove();

            // Update faction leader select
            if (addFactionContainerParent.length > 0) {
                updateFactionLeaderSelect(addFactionContainerParent)
            }
            if (segmentItemContainerParent.length > 0) {
                updateFactionLeaderSelect(segmentItemContainerParent)
            }
        }
    );

    // Add faction
    $('.add-faction-container').on('click', '.add-faction-button', async function () {
        await getAddFactionRequest();
    });

    // Disband faction
    $factionsDetailsContainer.on('click', '.disband-faction-button', async function () {
        notie.confirm({
            text: 'Are you sure?',
            submitCallback: async function () {
                await getDisbandFactionRequest();
            }
        });
    });

    // Add faction members page
    $factionsDetailsContainer.on('click', '.add-faction-members-menu-button', async function () {
        await loadAddFactionMembersPage();
    });

    // Add faction members
    $('.add-faction-members-container').on('click', '.add-faction-members-button', async function () {
        await getAddFactionMembersRequest();
    });

    // Remove faction members page
    $factionsDetailsContainer.on('click', '.remove-faction-members-menu-button', async function () {
        await loadRemoveFactionMembersPage();
    });

    // Remove faction members
    $('.remove-faction-members-container').on('click', '.remove-faction-members-button', async function () {
        await getRemoveFactionMembersRequest();
    });

    // Remove faction leader
    $factionsDetailsContainer.on('click', '.remove-faction-leader-button', async function () {
        await getRemoveFactionLeaderRequest();
    });

    // Set faction leader page
    $factionsDetailsContainer.on('click', '.set-faction-leader-menu-button', async function () {
        await loadSetFactionLeaderPage();
    });

    // Set faction leader
    $('.set-faction-leader-container').on('click', '.set-faction-leader-button', async function () {
        await getSetFactionLeaderRequest();
    });

    // Change faction name page
    $factionsDetailsContainer.on('click', '.change-faction-name-button', async function () {
        await loadChangeFactionNamePage();
    });

    // Back to faction details button
    $game.on('click', '.back-to-faction-details-button', function () {
        hideContent($());
        $('.faction-details-container').fadeIn('fast');
    });
});

async function loadViewRosterPage(companyUid) {  // Previously get_roster_list

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get view roster data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let viewRosterData = await getViewRosterData(companyUid);

    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) {
        companySelectData = await getCompanySelectData();
    }
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show company select
    if (!companyUid) {
        addCompaniesDataToSelectElement(companySelectData, $('.select-company-for-view-roster'));
    }
    // Show view roster data
    hideContent($());
    showViewRosterPageData(viewRosterData, companyUid);
}

function showViewRosterPageData(data, companyUid) {

    let rosterMembersContainer = $(".roster-members-container");
    let rosterSearchContainer = $(".roster-search-container");

    // Reset ui
    rosterMembersContainer.html('').hide();
    rosterSearchContainer.html('').hide();

    // Add headers
    addViewRosterPageHeaders(headerClasses, rosterMembersContainer);

    // Add sections
    addViewRosterPageChampionships(data["championships"], rosterMembersContainer);
    addViewRosterPageMainRosterSuperstars(data["superstars"], headerClasses);
    addViewRosterPageManagers(data["managers"]);
    addViewRosterPageTagTeams(data["tagTeams"], headerClasses);
    addViewRosterPageTrainingSuperstars(data["trainingSuperstars"]);
    addViewRosterPageRetiredSuperstars(data["retiredSuperstars"]);
    addViewRosterPageDeadSuperstars(data["deadSuperstars"]);

    // Add default order
    $('.roster-members-container').find('.roster-member, .future-superstar, .superstar-select-champion').each(
        function (i, e) {
            $(e).attr('data-default-order', i);
        });

    // Show roster size
    let rosterSizeClass = '';
    if (data['rosterSize'] > data['rosterCapacity']) {
        rosterSizeClass = 'light-red';
    }
    else if (data['rosterSize'] === data['rosterCapacity']) {
        rosterSizeClass = 'dark-yellow';
    }
    else {
        rosterSizeClass = 'light-green';
    }
    $('.roster-size-container').removeClass('light-red dark-yellow light-green').addClass(rosterSizeClass)
        .html('<span class="roster-size-number">' + data['rosterSize'] + '</span>' + '/' + data['rosterCapacity']);

    // Add custom brand filters
    $('.view-roster-filter.brand-filter').remove();
    let rosterFilterNoBrand = $('.view-roster-filter[data-value="no-brand"]');
    if (data['brandNames'].length > 0) {
        data['brandNames'].forEach(function (rosterBrandName) {
            let rosterBrandFilterHtml = '<button type="button" class="view-roster-filter brand-filter ' +
                'button retro-button condensed light-button-background" data-value="custom-brand" ' +
                'data-brand-name="' + rosterBrandName.replace(/"/g, "&quot;") + '">' +
                rosterBrandName + '</button> ';
            rosterFilterNoBrand.before(rosterBrandFilterHtml);
        });
        rosterFilterNoBrand.show();
    }
    else {
        rosterFilterNoBrand.hide();
    }

    // Reset search, select dropdown, filters
    $(".roster-search-input").val('');
    $('.roster-section-select').val('Champions');
    $('.view-roster-filter').removeClass('selected');
    $('.view-roster-filter:contains("All")').addClass('selected');

    // Show roster container
    rosterMembersContainer.show();
    $("#roster-container").fadeIn('slow').removeClass('display-none');
    rosterMembersContainer.scrollTop(0);

    // Tutorial action check
    checkTutorialStepAction('click_view_roster');
    if (companyUid) {
        setTimeout(function () {
            checkTutorialStepAction('select_view_roster_company');
        }, 100);
    }
}

function addViewRosterPageHeaders(headerClasses, rosterMembersContainer) {
    for (const [index, header] of Object.keys(headerClasses).entries()) {
        let headerClass = headerClasses[header];
        let marginTop = (index === 0) ? '' : 'margin-top-25 ';
        rosterMembersContainer.append('<div class="margin-bottom-15 font-bold ' + marginTop + headerClass + '">' +
            '<div class="light-grey margin-bottom-7">' + header + '</div>' +
            '</div>');
    }
}

function addViewRosterPageChampionships(championshipsData, rosterMembersContainer) {
    let championshipsSelector = rosterMembersContainer.find('.roster-champions');
    championshipsData.forEach(function (item) {
        let championHtml = getRosterChampionshipHtml(item);
        championshipsSelector.append(championHtml);
    });
    checkAndAddRosterSectionNoneText(championshipsData, championshipsSelector);
}

function addViewRosterPageMainRosterSuperstars(superstarsData, headerClasses) {
    // Add superstars to respective sections
    for (const rank of ['Main Eventer', 'Upper Midcarder', 'Lower Midcarder', 'Jabroni']) {
        const rankClass = headerClasses[rank + 's'];
        const rankElement = $('.' + rankClass);
        let rankSuperstars = superstarsData.filter(x => x.rank === rank);
        let rankHtml = '';
        rankSuperstars.forEach(function (superstar) {
            rankHtml += getRosterSuperstarHtml(superstar, rankClass);
        });
        rankElement.append(rankHtml);
        checkAndAddRosterSectionNoneText(rankSuperstars, rankElement);
    }
}

function addViewRosterPageManagers(managersData) {
    let managersSelector = $('.roster-managers');
    managersData.forEach(function (superstar) {
        let managerHtml = getRosterSuperstarHtml(superstar, 'roster-managers');
        managersSelector.append(managerHtml);
    });
    checkAndAddRosterSectionNoneText(managersData, managersSelector);
}

function addViewRosterPageTagTeams(tagTeamsData, headerClasses) {
    // Add tag teams and trios
    for (const section of ['Tag Teams', 'Trios']) {
        const sectionClass = headerClasses[section];
        const sectionElement = $('.' + sectionClass);
        let sectionItems = tagTeamsData.filter(x => {
            return (section === 'Tag Teams') ? !x.trio : x.trio;
        });
        sectionItems.forEach(function (sectionItem) {
            sectionElement.append('<div class="margin-bottom-7"><span data-type="tagTeam" data-container="' + sectionClass + '"' +
                ' data-uid="' + sectionItem['uid'] + '" class="col1 roster-member opacity-hover">'
                + sectionItem['name'] + '</span>' +
                '<span class="col2 grey">' + sectionItem['superstars'].join(' - ') + '</span></div>');
        });
        checkAndAddRosterSectionNoneText(sectionItems, sectionElement);
    }
}

function addViewRosterPageTrainingSuperstars(trainingSuperstarsData) {
    let trainingSelector = $('.roster-training');
    // Sort by future superstars last
    trainingSuperstarsData.sort((a, b) => {
        return a.future - b.future || a.yearToAppearIn - b.yearToAppearIn;
    });
    trainingSuperstarsData.forEach(function (superstar) {
        let superstarClass = '';
        let information = '';
        let rosterMemberClass = ' roster-member opacity-hover';
        if (superstar['future']) {
            superstarClass = ' grey';
            information = `Future Superstar (Year ${superstar['yearToAppearIn']})`;
            rosterMemberClass = ' future-superstar';
        }
        trainingSelector.append('<div class="margin-bottom-7"><span data-container="roster-training" ' +
            'data-type="training-superstar" data-uid="' + superstar['uid'] + '"' +
            ' class="col1 ' + rosterMemberClass + superstarClass + '">' +
            superstar['name'] + '</span>' +
            '<span class="col2 grey">' + information + '</span>' +
            '</div>');
    });
    checkAndAddRosterSectionNoneText(trainingSuperstarsData, trainingSelector);
}

function addViewRosterPageRetiredSuperstars(retiredSuperstarsData) {
    let retiredSelector = $('.roster-retired');
    retiredSuperstarsData.forEach(function (superstar) {
        let hallOfFamer = '';
        if (superstar['hallOfFamer']) {
            hallOfFamer = '<span class="gold margin-right-5">Hall of Famer</span>'
        }
        let inTrainingRoster = '';
        if (superstar['inTrainingRoster']) {
            inTrainingRoster = '<span class="grey">(Training)</span>'
        }
        retiredSelector.append('<div class="margin-bottom-7"><span data-type="superstar" data-container="roster-retired"' +
            ' data-uid="' + superstar['uid'] + '" class="col1 roster-member opacity-hover">' +
            superstar['name'] + '</span>' +
            '<span class="col2">' + hallOfFamer + inTrainingRoster + '</span>' +
            '</div>');
    });
    checkAndAddRosterSectionNoneText(retiredSuperstarsData, retiredSelector);
}

function addViewRosterPageDeadSuperstars(deadSuperstarsData) {
    let deadSelector = $('.roster-dead');
    deadSuperstarsData.forEach(function (superstar) {
        deadSelector.append('<div class="margin-bottom-7"><span data-type="superstar" data-container="roster-dead"' +
            ' data-uid="' + superstar['uid'] + '" class="col1 roster-member opacity-hover">' +
            superstar['name'] + '</span>' +
            '</div>');
    });
    checkAndAddRosterSectionNoneText(deadSuperstarsData, deadSelector);
}

function checkAndAddRosterSectionNoneText(items, element) {
    if (items.length <= 0) {
        element.append(
            '<span class="col1 margin-bottom-5 high-light-grey">None</span>'
        );
    }
}

function getRosterSuperstarHtml(superstar, dataContainerName) {

    // Define variables
    let injuredText = null;
    let suspendedText = null;
    let appearanceText = null;
    let unhappyText = null;
    let faceOfTheCompanyText = null;

    let name = superstar['name'];

    // Fotc
    if (superstar['faceOfTheCompany']) {
        name += '<i class="fa fa-star medium-blue margin-left-5 top--1px"></i>';
    }
    else {
        if (superstar['faceOfTheCompanyCounter'] > 0) {
            let monthsLeft = (6 - parseInt(superstar['faceOfTheCompanyCounter']));
            if (monthsLeft === 1) {
                faceOfTheCompanyText = monthsLeft + ' month to becoming a Face of the Company';
            }
            else {
                faceOfTheCompanyText = monthsLeft + ' months to becoming a Face of the Company';
            }
        }
    }

    // Appearances
    if (superstar['appearances'] !== undefined) {
        if (superstar['appearances'] === 1) {
            appearanceText = superstar['appearances'] + ' appearance left';
        }
        else {
            appearanceText = superstar['appearances'] + ' appearances left';
        }
    }

    // Injured
    if (superstar['injured'] !== undefined) {
        injuredText = getSuperstarInjuredText(superstar)
    }

    // Suspension months
    if (superstar['suspensionMonths'] > 0) {
        if (superstar['suspensionMonths'] !== '1') {
            suspendedText = 'Suspended for ' + superstar['suspensionMonths'] + ' months';
        }
        else {
            suspendedText = 'Suspended for ' + superstar['suspensionMonths'] + ' month';
        }
    }

    // Unhappy
    if (superstar['unhappy'] !== undefined) {
        if (superstar['unhappy']) {
            unhappyText = 'Unhappy';
        }
    }

    // Join info, remove null values
    const infoText = [injuredText, suspendedText, unhappyText, appearanceText, faceOfTheCompanyText].filter(
        function (val) {
            return val;
        })
        .join(', ');

    // Get brand name
    let brandName = superstar['brandName'];
    if (brandName) {
        brandName = brandName.replace(/"/g, "&quot;")
    }

    // Get data attributes
    let dataAlignment = ' data-alignment="' + superstar['alignment'] + '"';
    let dataPronoun = ' data-pronoun="' + superstar['pronoun'] + '"';
    let dataBrandName = ' data-brand-name="' + brandName + '"';

    // Get filter classes
    let filterClasses = '';
    if (appearanceText) {
        filterClasses += 'part-timer ';
    }
    if (unhappyText) {
        filterClasses += 'unhappy ';
    }
    if (injuredText) {
        filterClasses += 'injured ';
    }

    // Get color class
    let colorClass = '';
    if (unhappyText) {
        colorClass = 'puke-green '
    }
    else if (appearanceText) {
        colorClass = 'blue '
    }
    else if (injuredText || suspendedText) {
        colorClass = 'dark-red '
    }

    // Return html
    return '<div class="margin-bottom-7">' +
            '<span data-type="superstar" data-uid="' + superstar['uid'] + '" data-container="' + dataContainerName + '" ' +
            'class="col1 ' + colorClass + filterClasses +
            'roster-member opacity-hover"' + dataAlignment + dataPronoun + dataBrandName + '>' +
                name +
            '</span>' +
            '<span class="col2 grey">' + infoText + '</span>' +
        '</div>';
}

function getRosterChampionshipHtml(championship) {

    // Get champion name and class
    let championName = championship['championName'];
    let championClass = 'roster-member opacity-hover gold';
    if (!championName) {
        championName = 'Vacant';
        championClass = 'medium-light-grey';
    }

    // Get match contract info
    let event = '';
    if (championship['matchContract']) {
        event = ' (' + championship['event'] + ')';
    }

    // Get brand name
    let brandName = championship['brandName'];
    if (brandName) {
        brandName = brandName.replace(/"/g, "&quot;")
    }

    // Get prestige icon
    let prestigeIcon = getChampionshipPrestigeIconHtml(championship['prestige']);

    // Get data attributes
    let dataBrandName = ' data-brand-name="' + brandName + '"';
    let dataType = (championship['tagTeam'] || championship['trio']) ? 'tagTeam' : 'superstar';

    // Return html
    return '<div class="margin-bottom-7">' +
        '<span data-type="' + dataType + '" data-uid="' + championship['championUid'] + '" data-container="roster-champions" ' +
        'class="superstar-select-champion col1 ' + championClass + '"' + dataBrandName + '>' +
            championName +
        '</span>' +
        '<span class="col2">' +
            championship['name'] + event + ' ' + prestigeIcon +
        '</span>' +
        '</div>';
}

function addCompaniesDataToSelectElement(data, selectElement) {
    // Reset select
    selectElement.find('option').remove().end();

    // Add options
    data.forEach(function (company) {
        let isCompetitorAttribute = (company['isCompetitor']) ? ' data-is-competitor="true"' : '';
        selectElement.append(
            '<option data-uid="' + company['uid'] + '"' + isCompetitorAttribute + '>' +
                company['name'] +
            '</option>'
        );
    });
}

function getTalentFilterResults(rosterElement, filterName, filterBrandName) {
    // Filter roster elements by classes / data attributes
    let elements;
    elements = rosterElement.filter(function (e) {
        if (['part-timer', 'unhappy', 'injured'].indexOf(filterName) >= 0) {
            return $(e).hasClass(filterName)
        }
        else if (['he', 'she', 'they'].indexOf(filterName) >= 0) {
            return $(e).attr('data-pronoun') === filterName
        }
        else if (['face', 'heel'].indexOf(filterName) >= 0) {
            return $(e).attr('data-alignment') === filterName
        }
        else if (filterName === 'neutral') {
            return $(e).attr('data-alignment') === 'null' || $(e).attr('data-alignment') === ''
        }
        else if (filterName === 'no-brand') {
            return $(e).attr('data-brand-name') === 'null'
        }
        else if (filterName === 'custom-brand') {
            return $(e).attr('data-brand-name') === filterBrandName
        }
    });
    return elements;
}

function applyRosterSearchOrFilter(type, term, brandTerm) {

    // Define selectors
    const $resultsContainer = $('.roster-search-container');
    const $rosterContainer = $('.roster-members-container');
    const $allMembersContainer = $resultsContainer.add($rosterContainer);
    const $noRosterResultsElement = $('.no-roster-results');

    // Get all roster elements
    let rosterElements = $allMembersContainer.find('.roster-member, .future-superstar, .superstar-select-champion').toArray();

    // Reset elements to default containers, sorted by default order
    rosterElements.sort(function (a, b) {
        return parseInt($(a).attr('data-default-order')) - parseInt($(b).attr('data-default-order'));
    });
    rosterElements.forEach(function (e) {
        const elementContainerName = $(e).attr('data-container');
        const elementContainer = $('.' + elementContainerName);
        elementContainer.append($(e).parent());
    });
    $('.roster-filter-champions').remove();

    // Don't show champions for search
    if (type === 'search') {
        rosterElements = $(rosterElements).filter(':not(.superstar-select-champion)').toArray();
    }

    // Run filter/search
    if (term) {
        let results;
        if (type === 'search') {
            results = runFuseElementsSearch(rosterElements, term, ['textContent']);
        }
        else {
            results = getTalentFilterResults(rosterElements, term, brandTerm);
        }

        // Show results if found
        if (results.length > 0) {

            // Show champions section if champions are present (for brands)
            let championsPresent = results.some(function(e) {
                return $(e).hasClass('superstar-select-champion');
            });
            if (championsPresent) {
                $resultsContainer.append($('<div class="margin-bottom-15 roster-filter-champions">' +
                    '<div class="light-grey margin-bottom-7">Champions</div></div>'));
            }

            // Add results to $resultsContainer
            results.forEach(function (e) {
                if ($(e).hasClass('superstar-select-champion')) {
                    $resultsContainer.find('.roster-filter-champions').append($(e).parent())
                }
                else {
                    $resultsContainer.append($(e).parent());
                }
            });
            $('.no-roster-search-results').hide();
            $noRosterResultsElement.hide();
        }
        // Otherwise show 'no results found'
        else {
            if ($noRosterResultsElement.length > 0) {
                $noRosterResultsElement.show()
            }
            else {
                $resultsContainer.append('<div class="no-roster-results font-bold margin-left-5 light-grey ' +
                    'margin-top-2">No Results Found</div>')
            }
        }
        $resultsContainer.show();
        $rosterContainer.hide();
    }
    // Show default containers if empty search/filter term
    else {
        $resultsContainer.hide();
        $rosterContainer.show();
    }

    if (type === 'search') {
        // Reset filters
        $('.view-roster-filter').removeClass('selected');
    }
    else {
        // Reset search
        $(".roster-search-input").val('');
    }

    $rosterContainer.scrollTop(0);
    $rosterContainer[0].scrollIntoView();
}

function runIndieRosterSearch(term) {

    // Define selectors
    const $availableIndie = $('.available-indie');
    const $unavailableIndie = $('.unavailable-indie');
    const $noAvailableIndieSearchResults = $('.no-available-indie-search-results');
    const $noUnavailableIndieSearchResults = $('.no-unavailable-indie-search-results');
    const $rosterMembersContainer = $('.roster-members-container');
    const $resultsContainer = $('.indie-search-container');
    const $rosterContainers = $('.available-indie, .unavailable-indie');
    const $allMembersContainer = $resultsContainer.add($rosterContainers);

    // Get all roster elements
    let rosterElements = $allMembersContainer.find('.roster-member');

    // Move all members to results container
    rosterElements.toArray().forEach(function (e) {
        $resultsContainer.append(e);
    });

    // Run search
    if (term.length > 0) {
        let searchResults = runFuseElementsSearch(rosterElements, term, ['dataset.name']);

        // Sort search results by order
        searchResults.sort(function (a, b) {
            return (parseFloat($(a).attr('data-order')) - parseFloat($(b).attr('data-order')));
        });

        // Show search results if found
        searchResults.forEach(function (e) {
            const elementContainerName = $(e).attr('data-container');
            const elementContainer = $('.' + elementContainerName);
            elementContainer.append(e);
        });

        // Show no results found
        if ($availableIndie.find('.roster-member').length <= 0) {
            if ($noAvailableIndieSearchResults.length > 0) {
                $noAvailableIndieSearchResults.show()
            }
            else {
                $availableIndie.append('<div class="no-available-indie-search-results inner-box-item disabled light-grey ' +
                    '">No Results Found</div>')
            }
        }
        else {
            $noAvailableIndieSearchResults.hide()
        }
        if ($unavailableIndie.find('.roster-member').length <= 0) {
            if ($noUnavailableIndieSearchResults.length > 0) {
                $noUnavailableIndieSearchResults.show();
            }
            else {
                $unavailableIndie.append('<div class="no-unavailable-indie-search-results inner-box-item disabled light-grey ' +
                    '">No Results Found</div>')
            }
        }
        else {
            $noUnavailableIndieSearchResults.hide();
        }

        // Hide empty container text
        $('.no-unavailable-indie-talent-present').hide();
        $('.no-available-indie-talent-present').hide();
    }
    else {
        // Move back to original containers, sorted by order
        rosterElements.sort(function (a, b) {
            return (parseFloat($(a).attr('data-order')) - parseFloat($(b).attr('data-order')));
        });
        rosterElements.toArray().forEach(function (e) {
            const elementContainerName = $(e).attr('data-container');
            const elementContainer = $('.' + elementContainerName);
            elementContainer.append(e);
        });

        // Hide no results found
        $noAvailableIndieSearchResults.hide();
        $noUnavailableIndieSearchResults.hide();

        // Show empty container text
        $('.no-unavailable-indie-talent-present').show();
        $('.no-available-indie-talent-present').show();
    }

    $rosterMembersContainer.scrollTop(0);
    $rosterMembersContainer[0].scrollIntoView();
}

async function loadViewRosterMemberPage(memberUid, memberType, competitorUid, previousElement) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get view roster member data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let viewRosterMemberData = await getViewRosterMemberData({uid: memberUid, type: memberType,
        companyUid: competitorUid});
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show view roster member data
    hideContent($());
    const hideInfo = !!(competitorUid);
    showViewRosterMemberPageData(viewRosterMemberData, memberUid, memberType, hideInfo,
        viewRosterMemberData['scoutLevel'], previousElement);

    // Tutorial action check
    if (viewRosterMemberData['nextTutorialState']) {
        globals.game.tutorialState = viewRosterMemberData['nextTutorialState']
    }
}

function showViewRosterMemberPageData(data, memberUid, memberType, hideInfo, scoutLevel, previousElement, indieRoster = false,
                                      indieUnavailableRoster = false) {  // Previously showSuperstarDetails

    // Define selectors
    const $rosterMemberDetails = $('#roster-member-details');
    const $rosterMemberStatus = $('.roster-member-status');
    const $rosterMemberAge = $('.roster-member-age');
    const $rosterMemberPronoun = $('.roster-member-pronoun');
    const $rosterMemberCharisma = $('.roster-member-charisma');
    const $rosterMemberWorkrate = $('.roster-member-workrate');
    const $rosterMemberAlignment = $('.roster-member-alignment');
    const $rosterMemberOverness = $('.roster-member-overness');
    const $rosterMemberMorale = $('.roster-member-morale');
    const $rosterMemberFatigue = $('.roster-member-fatigue');
    const $rosterMemberGimmick = $('.roster-member-gimmick');
    const $rosterMemberTraits = $('.roster-member-traits');
    const $rosterMemberInformation = $('.roster-member-information');
    const $rosterMemberBrand = $('.roster-member-brand');
    const $rosterMemberTournamentsWon = $('.roster-member-tournaments-won');
    const $rosterMemberChampionships = $('.roster-member-championships');
    const $rosterMemberStats = $('.roster-member-stats');
    const $rosterMemberAvailable = $('.roster-member-available');
    const $editNameButton = $('#edit-name-button');
    const $editAlignmentButton = $('#edit-alignment-button');
    const $releaseTalentButton = $('#release-talent-button');
    const $disbandTeamButton = $('.disband-team-button');
    const $editSuperstarBrandButton = $('#edit-superstar-brand-button');
    const $transitionTalentButton = $('#transition-talent-button');
    const $unlearnTalentTraitButton = $('#unlearn-talent-trait-button');

    // Set data attributes
    $rosterMemberDetails.data('uid', memberUid);
    $rosterMemberDetails.data('type', memberType);
    $rosterMemberDetails.data('element', previousElement);

    // If competitor or indie talent, show info based on scout level
    const showLevel1Info = (!hideInfo || scoutLevel >= 1);
    const showLevel2Info = (!hideInfo || scoutLevel >= 2);
    const showLevel3Info = (!hideInfo || scoutLevel >= 3);
    const noInfoHtml = '<span class="light-grey">???</span>';

    // Name
    $('.roster-member-name').text(data['name']);

    // Popularity/rank
    if (showLevel2Info) {
        $('.roster-member-popularity').html(data['popularity']);
    }
    else {
        if (showLevel1Info) {
            $('.roster-member-popularity').html(data['rank']);
        }
        else {
            $('.roster-member-popularity').html(noInfoHtml)
        }
    }

    // Age
    if (showLevel1Info) {
        let age = Math.round(data['age']);
        $rosterMemberAge.text(age);
    }
    else {
        $rosterMemberAge.html(noInfoHtml)
    }

    // Pronoun
    if (data['pronoun'] !== undefined) {
        if (!data['pronoun']) {
            // For teams with mixed pronouns
            data['pronoun'] = 'they'
        }
        $rosterMemberPronoun.text(toTitleCase(data['pronoun']))
    }
    else {
        $rosterMemberPronoun.html(noInfoHtml)
    }

    // Alignment
    if (showLevel3Info) {
        let rosterMemberAlignmentHtml = getRosterMemberAlignmentHtml(data);
        $rosterMemberAlignment.html(rosterMemberAlignmentHtml);
    }
    else {
        $rosterMemberAlignment.html(noInfoHtml);
    }

    // Overness
    if (showLevel3Info) {
        let overnessText = '';
        let hotStaleText;
        if (data['hot']) {
            overnessText = '<img alt="Hot" src="static/www/static/hot_icon.png" class="fire-image margin-left-5"/>';
            hotStaleText = 'Being Over boosts a Superstar\'s Attributes (Workrate, Charisma), their Popularity ' +
                'changes, the changes in their Gimmicks effectiveness ' +
                ' and the chance to have Hot Matches, Segments and Feuds.';
        }
        else if (data['stale']) {
            overnessText = '<img alt="Stale" src="static/www/static/stale_icon.png" class="fire-image margin-left-5"/>';
            hotStaleText = 'Becoming Stale lowers the ratings of a Superstar\'s Segments, ' +
                ' their Popularity gains and the chance to have Hot Matches, Segments and Feuds.';
        }

        let overness = Math.round(data['overness']);
        let overnessHtml;
        if (data['hot'] || data['stale']) {
            overnessHtml =
                '<span class="help-text" title="' + hotStaleText + '">' +
                overness + '%' + overnessText +
                '</span>'
        }
        else {
            overnessHtml =
                '<span class="help-text" title="' + getOvernessLevelText(data['overness']) + '">' +
                overness + '%' +
            '</span>'

        }
        $rosterMemberOverness.html(overnessHtml);
    }
    else {
        $rosterMemberOverness.html(noInfoHtml)
    }

    // Morale
    if (showLevel2Info) {
        let morale = Math.round(data['morale']);
        let moraleClass = getRosterMemberMoraleClass(data['morale']);
        let moraleText = getRosterMemberMoraleText(data['morale']);
        let moraleHtml =
            '<span>' +
                '<span class="margin-right-5">' +
                    '<span class="' + moraleClass + '">' + moraleText + '</span>' +
                '</span>' +
                '<span class="light-grey">(' + morale + '%' + ')</span>' +
            '</span>';
        $rosterMemberMorale.html(moraleHtml);
    }
    else {
        $rosterMemberMorale.html(noInfoHtml)
    }

    // Fatigue
    if (showLevel2Info) {
        let fatigueHtml = '<span class="' + getRosterMemberFatigueClass(data['fatigue']) + ' help-text" ' +
            'title="Fatigue affects the chance of getting injured">' +
            data['fatigue'] + '%' +
            '</span>';
        $rosterMemberFatigue.html(fatigueHtml);
    }
    else {
        $rosterMemberFatigue.html(noInfoHtml)
    }

    // Charisma
    if (showLevel2Info) {

        let charismaHtml;
        let originalCharisma;
        if (memberType === 'tagTeam') {
            charismaHtml = getStarRatingHtml(data['charisma'], 'charisma-purple', 3);
        }
        else {
            originalCharisma = (data['hot']) ? data['charisma'] - 1 : data['charisma'];

            charismaHtml = '<i class="fa fa-star"></i>'.repeat(originalCharisma);
            if (data['hot']) {
                charismaHtml += '<i class="fa fa-star hot-color"></i>'
            }

            if (data['charisma'] < 3) {
                charismaHtml += '<i class="fa fa-star star-under"></i>'.repeat(3 - data['charisma']);
            }
        }
        charismaHtml = '<span role="text" aria-label="' + data['charisma'] + ' star charisma' + '">' + charismaHtml + '</span>';
        $rosterMemberCharisma.html(charismaHtml);

        if (memberType !== 'tagTeam') {
            // Progress
            let baseXp;
            let nextXp;
            switch (originalCharisma) {
                case 1:
                    baseXp = 0;
                    nextXp = 100;
                    break;
                case 2:
                    baseXp = 100;
                    nextXp = 300;
                    break;
                case 3:
                    nextXp = 300;
                    break;
            }

            let xpToLevel = '';
            let progress = 100;
            if (originalCharisma < 3) {
                progress = ((data['charismaXp'] - baseXp) /
                    (nextXp - baseXp)) * 100;
                xpToLevel = '{0} XP to Level {1}'.format(nextXp - Math.round(data['charismaXp']), originalCharisma + 1);
            }
            else {
                xpToLevel = 'Max Level'
            }
            if (progress > 100) {
                progress = 100
            }
            else if (progress <= 0) {
                progress = 1
            }

            let charismaProgress =
                '<div class="display-block margin-bottom-3 margin-top-5">' +
                '<div class="display-inline-block font-0p925em dark-grey">' +
                xpToLevel +
                '</div>' +
                '</div>' +
                '<div class="progress-under compact help-text" title="' + Math.round(data['charismaXp']) + ' / ' + nextXp + ' XP">' +
                '<div class="progress compact charisma-purple-background" style="width:' + progress + '%">' + '</div>' +
                '</div>';
            $('.roster-member-charisma-progress').html(charismaProgress);
        }
        else {
            $('.roster-member-charisma-progress').html('');
        }
    }
    else {
        $rosterMemberCharisma.html('???');
        $('.roster-member-charisma-progress').html('');
    }

    // Workrate
    if (showLevel2Info) {

        let workrateHtml;
        let originalWorkrate;
        if (memberType === 'tagTeam') {
            workrateHtml = getStarRatingHtml(data['workrate'], 'workrate-blue', 3);
        }
        else {
            originalWorkrate = (data['hot']) ? data['workrate'] - 1 : data['workrate'];

            workrateHtml = '<i class="fa fa-star"></i>'.repeat(originalWorkrate);
            if (data['hot']) {
                workrateHtml += '<i class="fa fa-star hot-color"></i>'
            }
            if (data['workrate'] < 3) {
                workrateHtml += '<i class="fa fa-star star-under"></i>'.repeat(3 - data['workrate']);
            }
        }
        workrateHtml = '<span role="text" aria-label="' + data['workrate'] + ' star workrate' + '">' + workrateHtml + '</span>';
        $rosterMemberWorkrate.html(workrateHtml);

        if (memberType !== 'tagTeam') {
            // Progress
            let baseXp;
            let nextXp;
            switch (originalWorkrate) {
                case 1:
                    baseXp = 0;
                    nextXp = 100;
                    break;
                case 2:
                    baseXp = 100;
                    nextXp = 300;
                    break;
                case 3:
                    nextXp = 300;
                    break;
            }

            let xpToLevel = '';
            let progress = 100;
            if (originalWorkrate < 3) {
                progress = ((data['workrateXp'] - baseXp) /
                    (nextXp - baseXp)) * 100;
                xpToLevel = '{0} XP to Level {1}'.format(nextXp - Math.round(data['workrateXp']), originalWorkrate + 1);
            }
            else {
                xpToLevel = 'Max Level'
            }
            if (progress > 100) {
                progress = 100
            }
            else if (progress <= 0) {
                progress = 1
            }
            let workrateProgress =
                '<div class="display-block margin-bottom-3 margin-top-5">' +
                '<div class="display-inline-block font-0p925em dark-grey">' +
                xpToLevel +
                '</div>' +
                '</div>' +
                '<div class="progress-under compact help-text" title="' + Math.round(data['workrateXp']) + ' / ' + nextXp + ' XP">' +
                '<div class="progress compact workrate-blue-background" style="width:' + progress + '%">' + '</div>' +
                '</div>';
            $('.roster-member-workrate-progress').html(workrateProgress);
        }
        else {
            $('.roster-member-workrate-progress').html('');
        }
    }
    else {
        $rosterMemberWorkrate.html('???');
        $('.roster-member-workrate-progress').html('');
    }

    // Face of the Company
    let fotc = '';
    if (showLevel3Info) {
        if (data['faceOfTheCompany']) {
            fotc = '<span class="light-grey margin-left-5 help-text" title="Face of the Company.">' +
                '<i class="fa fa-star medium-blue"></i>' +
                '</span>';
        }
        else if (data['faceOfTheCompanyCounter'] > 0) {
            fotc = '<span class="light-grey margin-left-5 help-text" title="Face of the Company progress in months">' +
                '<i class="fa fa-star medium-blue"></i> ' +
                String(parseInt(data['faceOfTheCompanyCounter'])) +
                '/6' +
                '</span>';
        }
        $('.roster-member-popularity').html(data['popularity'] + fotc);
    }

    // Status
    let statusText = '';
    if (data['fullTimeManager']) {
        statusText = 'Manager'
    }
    else {
        if (data['appearances'] !== null && data['appearances'] !== undefined) {
            // Show 'months' instead of 'appearances' if on trade deal
            let appearancesWord;
            if (data['activeEffect'] === 'traded') {
                appearancesWord = getMonthsWord(data['appearances']);
            }
            else {
                appearancesWord = (data['appearances'] === 1) ? 'app.' : 'apps.';
            }
            statusText = '{0} {1}'.format(data['appearances'], appearancesWord);
            // Add text for active effects
            if (data['activeEffect'] === 'traded') {
                statusText += ' (Trade Deal)'
            }
            else if (data['activeEffect'] === 'retirement_return') {
                statusText += ' (Retirement Return)'
            }
            if (data['partTimer']) {
                statusText =
                    '<span class="help-text" title="Part-timer appearances are used up in ' +
                    'Matches but not in Segments">' + statusText + '</span>'
            }
        }
        else {
            if (data['retired']) {
                statusText = 'Retired'
            }
            else {
                statusText = 'Full time'
            }
        }
        if (data['activeEffect'] === 'in_training') {
            statusText += ' (Training)'
        }
    }
    if (statusText) {
        $rosterMemberStatus.html(statusText);
    }
    else {
        $rosterMemberStatus.html(noInfoHtml);
    }

    // Information
    let info = [];
    if (showLevel3Info && data['cyborg']) {
        let cyborgHtml = '<span class="grey-blue">Cyborg</span>';
        info.push(cyborgHtml);
    }
    if (data['retired']) {
        let retiredHtml = ' <span class="help-text" title="Retired Superstars can be booked in Legends, Retired ' +
            'and Manager Segments or as part of a Faction">Retired</span>';
        info.push(retiredHtml);
    }
    if (showLevel2Info && data['hallOfFamer']) {
        let hofHtml = ' <span class="gold">Hall of Famer</span>';
        info.push(hofHtml);
    }
    if (data['dead']) {
        let deadHtml = '<span class="dead">Dead</span>';
        info.push(deadHtml);
    }

    // Team/faction members
    if (memberType === 'tagTeam') {
        let tagTeamSuperstars = data['superstars'].slice(0, -1).join(', ') + ' and ' + data['superstars'].slice(-1);
        let tagTeamSuperstarsHtml = '<span class="medium-grey">{0}</span>'.format(tagTeamSuperstars);
        info.push(tagTeamSuperstarsHtml);
    }
    if (data['teams'] && data['teams'].length > 0) {
        let teamWord = (data['teams'].length === 1) ? 'Team' : 'Teams';
        let teamHtml = '<span class="medium-grey">{0}</span> ({1})'.format(commaSeparate(data['teams']), teamWord);
        info.push(teamHtml);
    }
    if (data['factions'] && data['factions'].length > 0) {
        let factionHtml = '<span class="medium-grey">{0}</span> (Faction)'.format(commaSeparate(data['factions']));
        info.push(factionHtml);
    }

    // Manager/managed talent
    if (globalUser.paid) {
        if (data['managedTalentNames'] && data['managedTalentNames'].length > 0) {
            let managerHtml = '<span class="medium-grey">Managing {0}</span>'.format(commaSeparate(data['managedTalentNames']));
            info.push(managerHtml);
        }
        if (data['managerNames'] && data['managerNames'].length > 0) {
            let managerWord = (data['managerNames'].length === 1) ? 'Manager' : 'Managers';
            let managerHtml = '<span class="medium-grey">{0}</span> ({1})'.format(commaSeparate(data['managerNames']), managerWord);
            info.push(managerHtml);
        }
    }

    // One match appearance
    if (data['activeEffect'] === 'one_match_appearance') {
        info.push('One Match Appearance');
    }

    // Show injured and suspended if not retired or dead
    if (showLevel2Info && !data['retired'] && !data['dead']) {
        if (data['injured'] > 0) {
            let injuredText = getSuperstarInjuredText(data);
            let injuredHtml = '<span class="dark-red line-height-1p4">' + injuredText + '</span>';
            info.push(injuredHtml);
        }
        if (data['suspensionMonths'] > 0) {
            let suspendedText;
            if (data['suspensionMonths'] === '1') {
                suspendedText = 'Suspended for ' + data['suspensionMonths'] + ' month';
            }
            else {
                suspendedText = 'Suspended for ' +
                    data['suspensionMonths'] +
                    ' months';
            }
            let suspendedHtml = '<span class="dark-red">' + suspendedText + '</span>';
            info.push(suspendedHtml);
        }
    }

    // Contract months remaining
    let contractMonthsRemainingHtml = '';
    if (data['contractMonthsRemaining']) {
        let contractMonthsRemainingWord = getMonthsWord(data['contractMonthsRemaining']);
        contractMonthsRemainingHtml = '<span class="puke-green">{0} {1} to leave</span>'.format(data['contractMonthsRemaining'], contractMonthsRemainingWord);
        info.push(contractMonthsRemainingHtml);
    }

    // Join info together
    info = $.grep(info, Boolean).join(", ");
    $rosterMemberInformation.html('');
    if (info.length > 0) {
        $rosterMemberInformation.html(
            '<div class="margin-bottom-5">' +
            info +
            '</div>'
        );
    }

    // Show/hide attributes
    $rosterMemberAge.parent().show();
    $rosterMemberPronoun.parent().show();
    $rosterMemberStatus.parent().show();
    $rosterMemberCharisma.parent().show();
    $rosterMemberWorkrate.parent().show();
    $rosterMemberAlignment.parent().show();
    $rosterMemberOverness.parent().show();
    $rosterMemberMorale.parent().show();
    $rosterMemberFatigue.parent().show();
    $rosterMemberGimmick.parent().show();
    $rosterMemberTraits.parent().show();
    $rosterMemberInformation.show();
    $rosterMemberBrand.parent().show();

    // Championships
    $rosterMemberChampionships.html('');
    if (data['championships'] && data['championships'].length > 0) {
        let championshipNames = getChampionshipsDisplayName(data['championships'], true);
        $rosterMemberChampionships.html(
            '<div class="margin-bottom-5">' +
            championshipNames +
            '</div>'
        );
    }

    // Stats
    $rosterMemberStats.html('').show();
    if (data['stats']) {
        const statsHtml = getViewRosterMemberStatsHtml(data['stats']);
        $rosterMemberStats.html(
            '<div>' +
            '<div class="display-block dark-grey font-1p125em blue">Talent Stats</div>' +
            statsHtml +
            '</div>'
        );
    }
    else if ((memberType === 'superstar' || memberType === 'tagTeam') && !indieRoster && !globalUser.paid) {
        // Show JoW Paid text
        let div = '';
        div += '<div class="margin-top-15">';
        div += '<span class="display-block light-grey">Talent Stats are only available in JoW Paid. View stats like ' +
            'Win/Loss Records, Championship Reigns, Average Match Rating and more.</span>';
        $rosterMemberStats.html(
            '<div>' +
            '<div class="display-block dark-grey font-1p125em blue">Talent Stats</div>' +
            div +
            '</div>'
        );
        $rosterMemberStats.addClass('disabled');
    }
    else {
        $rosterMemberStats.hide();
    }

    // Tournaments won
    $rosterMemberTournamentsWon.html('');
    if (data['tournamentsWon'] && data['tournamentsWon'].length > 0) {
        let tournamentsWonText = '';
        if (data['tournamentsWon'].length > 1) {
            tournamentsWonText =
                '<span class="cyan">' +
                data['tournamentsWon'].slice(0, -1).join(', ') +
                '</span>' +
                ' and ' +
                '<span class="cyan">' +
                data['tournamentsWon'].slice(-1) +
                '</span>';
        }
        else {
            tournamentsWonText =
                '<span class="cyan">' +
                data['tournamentsWon'][0] +
                '</span>';
        }
        $rosterMemberTournamentsWon.html(
            '<div class="margin-bottom-5">Winner of ' +
            tournamentsWonText +
            '</div>'
        );
    }

    // Graphic if present
    let matchData = null;
    let graphicData;
    if (memberType === 'tagTeam') {
        // Show team graphics if present
        if (data['graphics']) {
            matchData = {'type': 'tag', 'largerTag': data['graphics'].length};
        }
        graphicData = data['graphics'];
    }
    else {
        graphicData = [data['graphic']];
    }

    $('.roster-member-graphic').html('');
    let el = $rosterMemberDetails.find('.roster-member-graphic');
    showRosterMemberPageGraphic(graphicData, el, matchData);
    $rosterMemberDetails.data('graphic', graphicData);
    $rosterMemberDetails.data('match', matchData);

    // Gimmick
    if (showLevel3Info) {
        let gimmickData = '<span class="medium-grey">None</span>';
        if (data['gimmick']) {
            gimmickData = getGimmickDescription(data['gimmick']);
            $('#edit-gimmick-button').text('Change Gimmick');
            $('.create-gimmick-label').text('Change Gimmick');
            $('#create-gimmick-button').text('Change');
        }
        else {
            $('#edit-gimmick-button').text('Create Gimmick');
            $('.create-gimmick-label').text('Create Gimmick');
            $('#create-gimmick-button').text('Create');
        }
        $rosterMemberGimmick.html(gimmickData);
    }
    else {
        $rosterMemberGimmick.html(noInfoHtml);
    }
    // Hide gimmick for tagTeam
    if (memberType === 'tagTeam') {
        $rosterMemberGimmick.parent().hide();
    }

    // Traits
    if (showLevel3Info) {
        let traitHtml = '<span class="medium-grey">None</span>';
        if (data['traits'].length > 0) {
            traitHtml = '';
            data['traits'].forEach((x) => {
                traitHtml += getViewRosterMemberTraitHtml(x)
            });
        }
        $rosterMemberTraits.html(traitHtml);
    }
    else {
        $rosterMemberTraits.html(noInfoHtml);
    }

    // Brand
    let brandName = '<span class="medium-grey">None</span>';
    if (data['brandName']) {
        brandName = data['brandName'];
    }
    $rosterMemberBrand.html(brandName);
    // Hide brand for indie talent
    if (indieRoster) {
        $rosterMemberBrand.parent().hide();
    }

    // Show/hide buttons
    $('#train-talent-workrate-button').hide();
    $('#train-talent-charisma-button').hide();
    $editNameButton.show();
    $editAlignmentButton.show();
    $releaseTalentButton.show();
    $disbandTeamButton.hide();
    $editSuperstarBrandButton.show();

    if (memberType === 'superstar') {
        $('#edit-gimmick-button').show();
        $('#edit-appearance-button').show();
        $('#train-talent-button').show();
        $('#reassure-talent-button').show();
        $('#edit-pronoun-button').show();

        // Show transition button and proper text
        if (globalUser.paid) {
            $transitionTalentButton.show();
            if (data['fullTimeManager']) {
                $transitionTalentButton.text('Transition To Superstar');
                $('#add-manager-relationship-for-talent-button').show();
                $('#remove-manager-relationship-for-talent-button').show();
            }
            else {
                $transitionTalentButton.text('Transition To Manager');
                $('#add-manager-relationship-for-talent-button').hide();
                $('#remove-manager-relationship-for-talent-button').hide();
            }
        }
        else {
            $transitionTalentButton.hide();
            $('#add-manager-relationship-for-talent-button').hide();
            $('#remove-manager-relationship-for-talent-button').hide();
        }

        // Show rehab button if injured
        if (data['injured'] > 0) {
            $('#rehab-talent-button').show();
        }
        else {
            $('#rehab-talent-button').hide();
        }

        // Show unlearn traits button if any present
        if (data['canUnlearnTraits'] && data['canUnlearnTraits'].length > 0) {
            $unlearnTalentTraitButton.show();
            $unlearnTalentTraitButton.data('canUnlearnTraits', data['canUnlearnTraits']);
        }
        else {
            $unlearnTalentTraitButton.hide();
        }

        // Show transition to staff button if retired
        if (data['retired']) {
            $('#transition-talent-to-staff-button').show();
        }
        else {
            $('#transition-talent-to-staff-button').hide();
        }
    }
    else {
        $('#edit-gimmick-button').hide();
        $('#edit-appearance-button').hide();
        $('#train-talent-button').hide();
        $('#reassure-talent-button').hide();
        $transitionTalentButton.hide();
        $('#rehab-talent-button').hide();
        $('#transition-talent-to-staff-button').hide();
        $unlearnTalentTraitButton.hide();
        $('#add-manager-relationship-for-talent-button').hide();
        $('#remove-manager-relationship-for-talent-button').hide();
        $('#edit-pronoun-button').hide();
    }

    if (!globalUser.paid) {
        $editSuperstarBrandButton.hide();
    }

    if (globals.game.story === 'mars') {
        $editNameButton.hide();
        $('#edit-pronoun-button').hide();
    }

    if (globals.game.story === 'mars' || globals.game.story === 'passion') {
        $editSuperstarBrandButton.hide();
    }

    if (memberType === 'tagTeam') {
        $disbandTeamButton.show();
    }

    // Indie buttons
    if (indieRoster) {
        $('#edit-gimmick-button').hide();
        $('#edit-appearance-button').hide();
        $('#train-talent-button').hide();
        $('#reassure-talent-button').hide();
        $transitionTalentButton.hide();
        $('#rehab-talent-button').hide();
        $('#transition-talent-to-staff-button').hide();
        $unlearnTalentTraitButton.hide();
        $('#add-manager-relationship-for-talent-button').hide();
        $('#remove-manager-relationship-for-talent-button').hide();
        if (indieUnavailableRoster) {
            $('#scout-talent-button').show();
            $('#recruit-talent-button').show();
            $('#start-negotiation-button').hide();
        }
        else {
            $('#scout-talent-button').hide();
            $('#recruit-talent-button').hide();
            $('#start-negotiation-button').show();
        }
        $editNameButton.hide();
        $editAlignmentButton.hide();
        $('#edit-pronoun-button').hide();
        $editSuperstarBrandButton.hide();
        $releaseTalentButton.hide();
        $disbandTeamButton.hide();
    }
    else {
        $('#scout-talent-button').hide();
        $('#recruit-talent-button').hide();
        $('#start-negotiation-button').hide();
    }

    // Training superstar buttons and info
    if (memberType === 'training-superstar') {
        $('#prepare-for-callup-button').show();
        $rosterMemberAvailable.text((data['available']) ? 'Yes' : 'No');
        $rosterMemberAvailable.parent().show();
        $editSuperstarBrandButton.hide();
    }
    else {
        $('#prepare-for-callup-button').hide();
        $rosterMemberAvailable.parent().hide();
    }

    // Hide buttons for competitor talent
    if (data['competitorTalent']) {
        $('#prepare-for-callup-button').hide();
        $rosterMemberAvailable.parent().hide();
        $('#scout-talent-button').hide();
        $('#recruit-talent-button').hide();
        $('#start-negotiation-button').show();
        $('#edit-gimmick-button').hide();
        $('#edit-appearance-button').hide();
        $('#train-talent-button').hide();
        $('#reassure-talent-button').hide();
        $transitionTalentButton.hide();
        $('#rehab-talent-button').hide();
        $('#transition-talent-to-staff-button').hide();
        $unlearnTalentTraitButton.hide();
        $('#add-manager-relationship-for-talent-button').hide();
        $('#remove-manager-relationship-for-talent-button').hide();
        $editNameButton.hide();
        $editAlignmentButton.hide();
        $('#edit-pronoun-button').hide();
        $editSuperstarBrandButton.hide();
        $releaseTalentButton.hide();
        $disbandTeamButton.hide();
    }

    $rosterMemberDetails.fadeIn();
    $rosterMemberDetails[0].scrollIntoView();
    $rosterMemberStats.scrollTop(0);

    // Tutorial action check
    checkTutorialStepAction('click_view_teams_item');
    checkTutorialStepAction('click_roster_superstar');
}

function getViewRosterMemberTraitHtml(trait) {
    let html = '';
    // For teams, get trait name with superstar name
    if (typeof trait === 'object') {
         html += '<div class="superstar-trait-color">' + getSuperstarTraitHelpHtml(trait['name']) +
             '<span class="margin-left-5 light-grey">(' + trait['superstar'] + ')</span>' +
             '</div>';
    }
    // For superstars, get trait name
    else {
        html += '<div class="superstar-trait-color">' + getSuperstarTraitHelpHtml(trait) + '</div>';
    }
    return html;
}

function getViewRosterMemberStatsHtml(stats) {
    let html = '';

    // Win/loss
    let winningPercentage = '';
    if (stats['winPercentage'] !== null) {
        winningPercentage = '({0}%)'.format(stats['winPercentage'])
    }
    let winLossRecord = '{0}-{1} <span class="margin-left-2 light-grey">{2}</span>'.format(stats['wins'], stats['losses'], winningPercentage);
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Win/Loss Record</span>';
    html += '<span class="display-block dark-grey">' + winLossRecord +
        '</span>';
    html += '</div>';

    // Winning/losing streak
    let winningLosingStreak = '{0}-{1}'.format(stats['winningStreak'], stats['losingStreak']);
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Winning/Losing Streak</span>';
    html += '<span class="display-block dark-grey">' + winningLosingStreak +
        '</span>';
    html += '</div>';

    // Current Feuds
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Current Feuds</span>';
    stats['currentFeuds'].forEach(function (feud) {
        let participantNames = commaSeparate(feud['opponents']);
        let hype = '<span class="faded-red-light"><i class="fa fa-bolt margin-left-8 margin-right-5"></i>' + feud['hype'] + '</span>';
        let text = 'vs ' + participantNames + '<span class="faded-red-light margin-left-8">' + feud['name'] + '</span>' + hype;
        html += '<span class="display-block dark-grey margin-bottom-8">' + text +
            '</span>';
    });
    if (stats['currentFeuds'].length < 1) {
        html += '<span class="display-block dark-grey">None</span>';
    }
    html += '</div>';

    // Average match rating
    let averageMatchRating = 'None';
    if (stats['averageMatchRating'] !== undefined) {
        averageMatchRating = stats['averageMatchRating'];
    }
    if (stats['averageMatchRating'] !== undefined) {
        html += '<div class="margin-top-15">';
        html += '<span class="display-block blue margin-bottom-2">Average Match Rating</span>';
        html += '<span class="display-block dark-grey">' + averageMatchRating +
            '<i class="fa fa-star margin-left-3"></i>' +
            '</span>';
        html += '</div>';
    }

    // Recent Matches
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Recent Matches</span>';
    stats['recentMatches'].forEach(function (match) {
        html += getTalentStatsMatchHtml(match, true, true)
    });
    if (stats['recentMatches'].length < 1) {
        html += '<span class="display-block dark-grey">None</span>';
    }
    html += '</div>';

    // Greatest Match
    let greatestMatch = 'None';
    if (stats['greatestMatch'] !== undefined) {
        greatestMatch = getTalentStatsMatchHtml(stats['greatestMatch'], true, false);
    }
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Greatest Match</span>';
    html += '<span class="display-block dark-grey">' + greatestMatch +
        '</span>';
    html += '</div>';

    // Biggest Rival
    let biggestRival = 'None';
    if (stats['biggestRival'] !== undefined) {
        biggestRival = stats['biggestRival']
    }
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Biggest Rival</span>';
    html += '<span class="display-block dark-grey">' + biggestRival +
        '</span>';
    html += '</div>';

    // Championship reigns
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Championship Reigns</span>';
    stats['championshipReigns'].forEach(function (reign) {
        html += getTalentStatsChampionshipReignHtml(reign)
    });
    if (stats['championshipReigns'].length < 1) {
        html += '<span class="display-block dark-grey">None</span>';
    }
    html += '</div>';

    // Awards Won
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Awards Won</span>';
    stats['awardsWon'].forEach(function (award) {
        let trophy = '';
        switch (award['award']) {
            case 0:
                trophy = 'trophy_icon_trash';
                break;
            case 1:
                trophy = 'trophy_icon_bronze';
                break;
            case 2:
                trophy = 'trophy_icon_silver';
                break;
            case 3:
                trophy = 'trophy_icon_gold';
                break;
        }
        html += '<span class="display-block dark-grey margin-bottom-8 line-height-27px">' +
            '<img alt="Trophy" src="static/www/static/' + trophy + '.png" class="trophy-image margin-right-8"/>' +
            award['name'] + '</span>';
    });
    if (stats['awardsWon'].length < 1) {
        html += '<span class="display-block dark-grey">None</span>';
    }
    html += '</div>';

    // Rankings history
    if (stats['yearlyRankingsHistory'].length > 0) {
        html += '<div class="margin-top-15">';
        html += '<span class="display-block blue margin-bottom-3">Top 50 History (Top 10 Only)</span>';
        stats['yearlyRankingsHistory'].forEach(function (rankingHistory) {
            let trophyHtml = (rankingHistory['rank'] === 1) ? '<img alt="Trophy" src="static/www/static/trophy_icon_gold.png" class="trophy-image margin-right-8"/>' : '';
            let rankingText = 'No. {0} <span class="grey margin-left-3">{1}</span>'.format(rankingHistory['rank'], rankingHistory['year']);
            html += '<span class="display-block dark-grey margin-bottom-5">' +
                trophyHtml + rankingText +
                '</span>';
        });
        html += '</div>';
    }

    // Event Streaks
    html += '<div class="margin-top-15">';
    html += '<span class="display-block blue margin-bottom-2">Event Streaks</span>';
    stats['eventStreaks'].forEach(function (streak) {
        let streakClass = 'bronze';
        if (streak['length'] < 5) {
            streakClass = 'bronze'
        }
        else if (streak['length'] < 10) {
            streakClass = 'gold-light'
        }
        else if (streak['length'] < 20) {
            streakClass = 'faded-red'
        }
        else {
            streakClass = 'obsidian'
        }
        let streakText = '<span class="{0}">{1}-0</span> at {2}'.format(streakClass, streak['length'], streak['event']);
        html += '<span class="display-block dark-grey margin-bottom-5">' + streakText +
            '</span>';
    });
    if (stats['eventStreaks'].length < 1) {
        html += '<span class="display-block dark-grey">None</span>';
    }
    html += '</div>';

    return html;
}

function getTalentStatsMatchHtml(match, showRating, showMatchResult) {
    let rating = setRating(match['rating']);

    let condensedSuperstars = match['opponents'].slice(0, 5);
    if (match['opponents'].length > 5) {
        let remainingSuperstars = match['opponents'].length - 5;
        let othersText = (remainingSuperstars > 1) ? 'others' : 'other';
        condensedSuperstars.push('{0} {1}'.format(remainingSuperstars, othersText));
    }
    let opponents = commaSeparate(condensedSuperstars);

    let ratingHtml = '';
    if (showRating) {
        ratingHtml = '<span class="display-block margin-top-3 margin-bottom-20">' + rating + '</span>'
    }

    let matchResult = '';
    if (showMatchResult) {
        switch (match['win']) {
            case true:
                matchResult = '<span class="green">W</span> ';
                break;
            case false:
                matchResult = '<span class="red">L</span> ';
                break;
        }
    }
    let text = '{0}vs {1} <span class="light-grey margin-left-2">{2}</span>'.format(matchResult, opponents, match['event'])
    return '<span class="display-block dark-grey margin-bottom-8">' + text + ratingHtml +
        '</span>';
}

function getTalentStatsChampionshipReignHtml(reign) {

    let endDate = (reign['endDate'] !== null) ? reign['endDate'] : 'Present';
    let period = '{0} - {1}'.format(reign['startDate'], endDate);
    let defensesWord = (reign['defenses'] === 1) ? 'Defense' : 'Defenses';
    let defenses = '{0} {1}'.format(reign['defenses'], defensesWord);
    let lengthWord = (reign['length'] === 1) ? 'Month' : 'Months';
    let length = '{0} {1}'.format(reign['length'], lengthWord);
    let name = '{0}'.format(reign['name']);

    let text = '<span class="gold">' + name + '</span>' +
            '<span class="margin-left-8">' + period + '</span>' +
            '<span class="light-grey margin-left-8">' + defenses + '</span>';

    return '<span class="display-block dark-grey margin-bottom-12">' + text +
        '</span>';
}

async function loadViewIndiesPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get view indies data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let viewIndiesData = await getViewIndiesData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show view indies data
    hideContent($());
    showViewIndiesPageData(viewIndiesData);
}

function showViewIndiesPageData(data) {
    // Get data
    let availableRoster = data['available'];
    let unavailableRoster = data['unavailable'];
    let scoutLevel = data['scoutLevel'];

    // Define selectors
    const $indie = $('#indie');
    const $availableIndie = $('.available-indie');
    const $unavailableIndie = $('.unavailable-indie');

    // Show available roster members
    $availableIndie.html('');
    if (availableRoster.length > 0) {

        availableRoster.forEach(function (rosterMember, i) {

            let objClass = getViewIndiesElementBorderClass(availableRoster, i);
            let name = getViewIndiesElementFormattedName(rosterMember);

            // Show interested
            let interested = '';
            let titleHtml = '';
            let helpClass = '';
            if (rosterMember['interested']) {
                interested = ' interested';
                titleHtml = ' title="This talent is interested in joining our company, which means they can be signed for a lower cost."';
                helpClass = ' help-text'
            }

            let new_div = '<span class="font-bold roster-member inner-box-item compact' +
                interested + objClass + helpClass + '"' + titleHtml +
                ' data-name="' + rosterMember['name'].replace(/"/g, "&quot;") + '" data-order="' + i + '" data-container="available-indie" ' +
                'data-type="' + rosterMember['type'] + '" data-uid="' + rosterMember['uid'] + '">' +
                name + '</span>';

            $availableIndie.append(new_div);
        })
    }
    else {
        $availableIndie.append('<span class="light-grey inner-box-item disabled no-available-indie-talent-present">' +
            'No Talent Present</span>')
    }

    // Show unavailable roster members
    $unavailableIndie.html('');
    if (unavailableRoster.length > 0) {

        unavailableRoster.forEach(function (rosterMember, i) {

            let objClass = getViewIndiesElementBorderClass(unavailableRoster, i);
            let name = getViewIndiesElementFormattedName(rosterMember);

            let new_div = '<span class="font-bold roster-member inner-box-item compact ' + objClass +
                '" data-name="' + rosterMember['name'].replace(/"/g, "&quot;") + '" data-order="' + i + '" data-container="unavailable-indie" ' +
                'data-type="' + rosterMember['type'] + '" data-uid="' + rosterMember['uid'] + '">' +
                name + '</span>';

            $unavailableIndie.append(new_div);
        })
    }
    else {
        $unavailableIndie.append('<span class="light-grey inner-box-item disabled no-unavailable-indie-talent-present">' +
            'No Talent Present</span>')
    }

    $indie.fadeIn();
    $availableIndie.scrollTop(0);
    $unavailableIndie.scrollTop(0);
    $(".indie-roster-search-input").val('');
    $('.indie-search-container').html('');

    // Roster member click handler
    $indie.off('click', '.roster-member');
    $indie.on('click', '.roster-member', function (event) {
        showIndieRosterMemberPage($(event.target), availableRoster, unavailableRoster, scoutLevel)
    });

    // Tutorial action check
    checkTutorialStepAction('click_view_indies_menu_button');
}

function getViewIndiesElementBorderClass(roster, i) {
    let objClass = '';
    if (roster.length % 2 === 0) {
        if ((i === roster.length - 1 || i === roster.length - 2)) {
            objClass = ' border-bottom-0'
        }
    }
    else {
        if (i === roster.length - 1) {
            objClass = ' border-bottom-0'
        }
    }
    return objClass;
}

function getViewIndiesElementFormattedName(rosterMember) {
    let name = rosterMember['name'];
    if (name.length > 18) {
        name = name.slice(0, 18) + '.';
        // Remove space if just before shortening period
        if (name.substr(-2) === ' .') {
            name = name.slice(0, 18 - 1) + '.'
        }
    }
    return name;
}

function showIndieRosterMemberPage($el, availableRoster, unavailableRoster, scoutLevel) {
    // Get roster member data
    let memberUid = parseInt($el.attr('data-uid'));
    let memberType = $el.attr('data-type');
    let rosterMemberData = availableRoster.concat(unavailableRoster).filter(function (s) {
        return s['uid'] === memberUid;
    })[0];
    let presentInUnavailableRoster = unavailableRoster.indexOf(rosterMemberData) >= 0;

    // Lower scout level for unavailable roster member
    if (presentInUnavailableRoster) {
        scoutLevel -= 1
    }

    // Show roster member data
    hideContent($());
    showViewRosterMemberPageData(rosterMemberData, memberUid, memberType, true, scoutLevel, '#indie',
        true, presentInUnavailableRoster);

    // Tutorial action check
    checkTutorialStepAction('click_indie_roster_member');
}

async function loadViewTeamsPage(companyUid) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get view teams data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let viewTeamsData = await getViewTeamsData(companyUid);

    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) {
        companySelectData = await getCompanySelectData();
    }
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show company select
    if (!companyUid) {
        addCompaniesDataToSelectElement(companySelectData, $('.view-teams-company-select'));
    }
    // Show view teams data
    hideContent($());
    showViewTeamsPageData(viewTeamsData);
}

function showViewTeamsPageData(data) {
    const $viewTeamsItemsContainer = $(".view-teams-items-container");
    $viewTeamsItemsContainer.html('');

    // Show teams
    data.forEach(function (team) {

        let teamType = (team['trio']) ? 'Trio' : 'Tag Team';

        let div =
            '<div class="view-teams-item" data-name="' + team['name'].replace(/"/g, "&quot;") + '" data-uid="' + team['uid'] + '">' +
                '<div class="margin-bottom-6">' +
                    '<span>' + team['name'] + '</span>' +
                    '<span class="float-right light-grey">' +
                        teamType +
                    '</span>' +
                '</div>' +
                '<div class="medium-light-grey">' +
                    commaSeparate(team['superstars']) +
                '</div>' +
            '</div>';

        $viewTeamsItemsContainer.append(div);
    });

    if (data.length === 0) {
        let div =
            '<div class="view-teams-item disabled">' +
                '<div>' +
                    '<span class="grey">No Teams present</span>' +
                '</div>' +
            '</div>';

        $viewTeamsItemsContainer.append(div);
    }

    $("#view-teams-container").fadeIn('slow');
    $viewTeamsItemsContainer.scrollTop(0);

    // Tutorial action check
    checkTutorialStepAction('click_view_teams');
}

async function loadViewManagersPage(companyUid) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get view managers data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let viewManagersData = await getViewManagersData(companyUid);

    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) {
        companySelectData = await getCompanySelectData();
    }
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show company select
    if (!companyUid) {
        addCompaniesDataToSelectElement(companySelectData, $('.view-managers-company-select'));
    }
    // Show view managers data
    hideContent($());
    showViewManagersPageData(viewManagersData);
}

function showViewManagersPageData(data){
    const $viewManagersItemsContainer = $(".view-managers-items-container");
    $viewManagersItemsContainer.html('');

    // Show managers
    data.forEach(function (manager) {

        // Get charisma
        let originalCharisma = (manager['hot']) ? manager['charisma'] - 1 : manager['charisma'];
        let charismaHtml = '<i class="fa fa-star"></i>'.repeat(originalCharisma);
        if (manager['hot']) {
            charismaHtml += '<i class="fa fa-star hot-color"></i>'
        }
        if (manager['charisma'] < 3) {
            charismaHtml += '<i class="fa fa-star star-under"></i>'.repeat(3 - manager['charisma']);
        }

        // Get managed talent names
        let managedSuperstarsHtml;
        if (manager['managedTalentNames'].length > 0) {
            managedSuperstarsHtml = '<div class="light-grey">Managing {0}</div>'.format(commaSeparate(manager['managedTalentNames']))
        }
        else {
            managedSuperstarsHtml = '<div class="medium-light-grey">No talent assigned</div>'
        }

        // Get full time manager
        let fullTimeManagerHtml = '';
        if (!manager['fullTimeManager']) {
            fullTimeManagerHtml = '<div class="medium-light-grey margin-top-5">Non full-time manager</div>'
        }

        // Get html
        let html =
            '<div class="view-managers-item" data-uid="' + manager['uid'] + '">' +
                '<div class="margin-bottom-6">' +
                    '<span>' + manager['name'] + '</span>' +
                    '<span class="float-right font-16px charisma-purple help-text" title="Manager Charisma">' +
                        charismaHtml +
                    '</span>' +
                '</div>' +
                '<div>' +
                    managedSuperstarsHtml +
                    fullTimeManagerHtml +
                '</div>' +
            '</div>';

        $viewManagersItemsContainer.append(html);
    });

    if (data.length === 0) {
        let div =
            '<div class="view-managers-item disabled">' +
                '<div>' +
                    '<span class="grey">No Managers present</span>' +
                '</div>' +
            '</div>';

        $viewManagersItemsContainer.append(div);
    }

    $("#view-managers-container").fadeIn('slow');
    $viewManagersItemsContainer.scrollTop(0);
}

async function loadMakeTradeOfferPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get make trade offer data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let makeTradeOfferData = await getMakeTradeOfferData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show make trade offer data
    showMakeTradeOfferPageData(makeTradeOfferData);
}

function showMakeTradeOfferPageData(data) {
    if (data['competitors'].length > 0) {
        let $tradeOfferContainer = $('.trade-offer-container');

        // Add competitors select and user company name
        let companySelector = $('.trade-offer-competitor-select');
        addCompaniesDataToSelectElement(data['competitors'], companySelector);
        $tradeOfferContainer.find('.trade-offer-sender-company-name').text(data['userCompanyName']);

        // Load first competitor
        loadCompetitorTradeOfferBox($tradeOfferContainer, data['competitors'][0]['uid'], data['competitors'][0]['name'])
    }
    else {
        playSoundEffect('error');
        notie.alert({type: 3, text: 'There are no companies available to trade with', stay: true});
    }
}

async function loadViewRankingsPage(companyUid, period = 'current') {

    if (globals.requestRunning) {
        return;
    }

    // Get view roster rankings data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let viewRosterRankingsData = await getViewRankingsData(companyUid, period);

    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) {
        companySelectData = await getCompanySelectData();
    }
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show company select
    if (!companyUid) {
        addCompaniesDataToSelectElement(companySelectData, $('.select-company-for-roster-rankings'));
    }
    // Select 'current' period (for first load)
    if (period === 'current') {
        $('.roster-rankings-period-select').val('current');
    }
    // Show view roster rankings data
    showViewRankingsPageData(viewRosterRankingsData);
}

function showViewRankingsPageData(data) {
    if (!data['error']) {
        hideContent($());
        playSoundEffect('success');

        // Show rankings data
        displayRosterRankingsData(data['rankingData']);

        // Add custom brand filters
        $('.roster-rankings-filter.brand-filter').remove();
        if (data['brandNames'].length > 0) {
            data['brandNames'].forEach(function (rosterBrandName) {
                let rosterBrandFilterHtml = '<button type="button" class="roster-rankings-filter brand-filter ' +
                    'button retro-button condensed light-button-background" data-value="custom-brand" ' +
                    'data-brand-name="' + rosterBrandName.replace(/"/g, "&quot;") + '">' +
                    rosterBrandName + '</button> ';
                $('.roster-rankings-brand-filters').append(rosterBrandFilterHtml);
            });
        }

        // Apply 'singles' and 'he' filters
        $('.roster-rankings-filter').removeClass('selected');
        $('.roster-rankings-filter[data-value="superstar"]').addClass('selected');
        $('.roster-rankings-filter[data-value="he"]').addClass('selected');
        applyRosterRankingsFilter();
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-paid') {
            notie.alert({type: 3, text: 'Roster Rankings are only available in JoW Paid.'});
        }
    }
}

function displayRosterRankingsData(data) {
    let rosterRankingsDataContainer = $('.roster-rankings-data-container');
    rosterRankingsDataContainer.html('');

    // Show ranking items
    let rankingsHtml = '';
    data.forEach(function (ranking, i) {

        let highlightClasses = (i + 1 <= 10) ? ' menu-header-color font-1p125em' : '';
        let numberHtml = '<span class="display-inline-block roster-rankings-number grey' + highlightClasses + '">' + (i + 1) + '</span>';
        let winLossHtml = '<span class="display-inline-block font-1p125em">{0}<span class="margin-left-2 margin-right-2">-</span>{1}</span>'.format(ranking['wins'], ranking['losses']);
        let championshipNamesHtml = Array.from(ranking['championships'], function (x) {
            return '<span class="gold">' + x + '</span>';
        });
        let brandName = ranking['brandName'];
        if (brandName) {
            brandName = brandName.replace(/"/g, "&quot;")
        }
        let html =
            '<div class="roster-rankings-item font-century-gothic" data-pronoun="' + ranking['pronoun'] +
            '" data-type="' + ranking['type'] + '" data-brand-name="' + brandName + '">' +
            '<div>' +
            '<div class="roster-rankings-column-number">' + numberHtml + '</div>' +
            '<div class="roster-rankings-column-name">' +
                '<div class="line-height-1p4">' + ranking['name'] + '</div>' +
                '<div class="line-height-1p4">' +
                    '<div class="margin-top-3 grey">' + commaSeparate(championshipNamesHtml) + '</div>' +
                '</div>' +
            '</div>' +
            '<div class="roster-rankings-column-data">' +
                winLossHtml +
            '</div>' +
            '<div class="clear"></div>' +
            '</div>' +
            '</div>';

        rankingsHtml += html;
    });

    $("#roster-rankings-container").fadeIn('slow');
    rosterRankingsDataContainer.html(rankingsHtml);
    rosterRankingsDataContainer.scrollTop(0);
}

function applyRosterRankingsFilter() {

    // Define selectors
    const $typeFilter = $('.roster-rankings-type-filters').find('.roster-rankings-filter.selected');
    const $pronounFilter = $('.roster-rankings-pronoun-filters').find('.roster-rankings-filter.selected');
    const $brandFilter = $('.roster-rankings-brand-filters').find('.roster-rankings-filter.selected');
    const $rosterRankingsDataContainer = $('.roster-rankings-data-container');

    // Show items that pass both filters
    $rosterRankingsDataContainer.find('.roster-rankings-item').each(function (i, x) {
        if (($typeFilter.length <= 0 || $(x).attr('data-type') === $typeFilter.attr('data-value')) &&
            ($pronounFilter.length <= 0 || $(x).attr('data-pronoun') === $pronounFilter.attr('data-value')) &&
            ($brandFilter.length <= 0 || $(x).attr('data-brand-name') === $brandFilter.attr('data-brand-name'))) {
            $(x).show()
        } else {
            $(x).hide()
        }
    });

    // Show/hide 'no talent found' element
    const visibleElements = $rosterRankingsDataContainer.find('.roster-rankings-item:visible');
    const $noRosterRankingsFilterResults = $('.no-roster-rankings-filter-results');
    if (visibleElements.length <= 0) {
        if ($noRosterRankingsFilterResults.length > 0) {
            $noRosterRankingsFilterResults.show();
        } else {
            $rosterRankingsDataContainer.append('<div class="no-roster-rankings-filter-results font-bold margin-left-8 light-grey">' +
                'No Talent Found</div>')
        }
    } else {
        $noRosterRankingsFilterResults.hide();
    }

    // Show numbers
    visibleElements.each(function (i, e) {
        const $rosterRankingsNumber = $(e).find('.roster-rankings-number');
        $rosterRankingsNumber.text(i + 1);
        if (i + 1 <= 10) {
            $rosterRankingsNumber.addClass('menu-header-color font-1p125em')
        } else {
            $rosterRankingsNumber.removeClass('menu-header-color font-1p125em')
        }
    });

    $rosterRankingsDataContainer.scrollTop(0);
}

async function loadViewFactionsPage(companyUid) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get view factions data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let viewFactionsData = await getViewFactionsData(companyUid);

    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) {
        companySelectData = await getCompanySelectData();
    }
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show company select
    if (!companyUid) {
        addCompaniesDataToSelectElement(companySelectData, $('.view-factions-company-select'));
    }
    // Show view factions data
    hideContent($());
    showViewFactionsPageData(viewFactionsData);
}

function showViewFactionsPageData(data) {
    const $viewFactionsItemsContainer = $(".view-factions-items-container");
    const $viewFactionsContainer = $('#view-factions-container');
    $viewFactionsItemsContainer.html('');

    // Show factions
    data.forEach(function (faction) {
        let viewFactionHtml = getViewFactionHtml(faction);
        $viewFactionsItemsContainer.append(viewFactionHtml);
    });

    // Show empty text if no factions
    if (data.length === 0) {
        let div =
            '<div class="view-factions-item disabled">' +
                '<div>' +
                    '<span class="grey">No Factions present</span>' +
                '</div>' +
            '</div>';

        $viewFactionsItemsContainer.append(div);
    }

    $viewFactionsContainer.fadeIn('slow');
    $viewFactionsItemsContainer.scrollTop(0);

    // Faction click handler
    $viewFactionsContainer.off('click', '.view-factions-item');
    $viewFactionsContainer.on('click', '.view-factions-item', function () {
        if ($(this).hasClass('disabled')) {
            return false;
        }
        let factionUid = parseInt($(this).attr('data-uid'));
        let factionData = data.filter(function (obj) {
            return obj.uid === factionUid;
        })[0];
        let isCompetitorFaction = $('.view-factions-company-select').find(":selected[data-is-competitor]").length > 0;
        showViewFactionDetailsPage(factionData, isCompetitorFaction);
    });
}

async function loadStartNegotiationPage(uid, type) {
    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getStartNegotiationData(uid, type);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showStartNegotiationPageData(data, type);
}

function showStartNegotiationPageData(data, type) {
    if (!data['error']) {
        playSoundEffect('success');
        hideContent($());
        displayNegotiation(data);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-found') {
            notie.alert({
                type: 3,
                text: "This {0} could not be found".format(toTitleCase(type))
            });
        }
        else if (data['error'] === 'capacity') {
            notie.alert({
                type: 3, text: "You do not have enough space in your roster. Release superstars " +
                    "or raise your Company Reputation to increase roster capacity."
            });
        }
        else if (data['error'] === 'on-trade') {
            notie.alert({type: 3, text: 'This talent is on trade and cannot be negotiated with right now'})
        }
    }
}

function displayNegotiation(data) {
    let parent = $('.negotiation-box');
    parent.data('uid', data['uid']);

    // Attempts remaining
    parent.find('.negotiation-box-attempts-remaining i.fa-times').show();
    parent.find('.negotiation-box-attempts-remaining i.fa-check').hide();
    if (data['status'] === 'accepted_by_talent') {
        parent.find('.negotiation-box-attempts-remaining i.fa-check').show();
        parent.find('.negotiation-box-attempts-remaining i.fa-times').hide();
    }
    else {
        let attemptsRemainingIcons = parent.find('.negotiation-box-attempts-remaining i.fa-times');
        attemptsRemainingIcons.addClass('light-grey').removeClass('red');
        attemptsRemainingIcons.slice(0, 3 - data['attemptsRemaining']).addClass('red').removeClass('light-grey');
    }

    // Name and graphic of talent
    parent.find('.negotiation-box-name').text(data['name']);
    showTalentDialogPageGraphic($('.negotiation-box-graphic'), data['graphic']);

    parent.find('.negotiation-box-dialog-content').text(data['dialog']).hide().fadeIn('fast');

    // Add default offer of staff estimate
    parent.find('.negotiation-box-offer-input').val(parseInt(data['scoutOfferAmountEstimate']));

    // Show offer info
    let infoHtml = '';
    if (data['status'] === 'negotiating') {
        let staffHtml = '';
        if (data['scoutName']) {
            staffHtml = 'Your Scout, ' + data['scoutName'] + ','
        }
        else {
            staffHtml = 'Your Staff'
        }
        let estimateWord = getScoutEstimateWord(data['scoutLevel']);
        infoHtml = staffHtml + ' gives a ' + estimateWord + ' estimate of' +
            '<span class="blue margin-left-5 margin-right-2">' +
            ' <img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-2"> ' +
            data['scoutOfferAmountEstimate'] + '</span>' +
            ' for ' + data['name'] +
            '\'s value.</span>';
    }
    else if (data['status'] === 'accepted_by_talent') {
        let staffHtml = '';
        if (data['talentManagerName']) {
            staffHtml = 'Your Talent Manager, ' + data['talentManagerName'] + ','
        }
        else {
            staffHtml = 'Your Staff'
        }
        infoHtml = staffHtml + ' is finalizing the deal. It should be complete next month.'
    }
    else if (data['status'] === 'rejected_by_talent') {
        let offerMonthsWord = getMonthsWord(data['monthsToRemove']);
        infoHtml = data['name'] + ' will not take any more offers from us for the next {0} {1}.'.format(data['monthsToRemove'], offerMonthsWord)
    }
    else if (data['status'] === 'rejected_by_company') {
        let offerMonthsWord = getMonthsWord(data['monthsToRemove']);
        infoHtml = data['receiverCompanyName'] + ' have blocked any further offers to ' + data['name'] + ' for the next {0} {1}.'.format(data['monthsToRemove'], offerMonthsWord)
    }
    const $otherOffers = $('.negotiation-box-other-offers');
    if (data['otherOffers'].length > 0) {
        $otherOffers.html('<div>' + data['name'] +
            ' is also negotiating with ' + commaSeparate(data['otherOffers'])  + '.</div>');
        $otherOffers.show();
    }
    else {
        $otherOffers.html('');
        $otherOffers.hide();
    }
    parent.find('.negotiation-box-info').html(infoHtml);

    // Send to main roster button
    if (data['status'] === 'accepted_by_talent' && !data['sendToMainRoster']) {
        parent.find('#negotiation-send-to-main-roster-button').show()
    }
    else {
        parent.find('#negotiation-send-to-main-roster-button').hide()
    }

    if (data['status'] === 'negotiating') {
        parent.find('#make-negotiation-offer').show();
        parent.find('.negotiation-box-offer-container').show();
        parent.find('.negotiation-box-other-offers').show();
    }
    else {
        parent.find('#make-negotiation-offer').hide();
        parent.find('.negotiation-box-offer-container').hide();
        if (data['status'] === 'rejected_by_talent') {
            parent.find('.negotiation-box-other-offers').hide();
        }
    }

    parent.fadeIn('fast');
}

function getScoutEstimateWord(level) {
    switch (level) {
        case null:
            return 'crude';
        case 1:
            return 'rough';
        case 2:
            return 'decent';
        case 3:
            return 'good';
    }
}

function incrementNegotiationOfferAmount() {
    const $negotiationBoxOfferInput = $('.negotiation-box-offer-input');
    let offerInputValue = parseInt($negotiationBoxOfferInput.val());
    if (offerInputValue < 3000) {
        $negotiationBoxOfferInput.val(offerInputValue + 25)
    }
}

function decreaseNegotiationOfferAmount() {
    const $negotiationBoxOfferInput = $('.negotiation-box-offer-input');
    let offerInputValue = parseInt($negotiationBoxOfferInput.val());
    if (offerInputValue > 0) {
        $negotiationBoxOfferInput.val(offerInputValue - 25)
    }
}

async function getMakeNegotiationOfferRequest(uid, amount) {
    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await makeNegotiationOffer(uid, amount);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showMakeNegotiationOfferData(data);
}

function showMakeNegotiationOfferData(data) {
    if (!data['error']) {
        playSoundEffect('success');
        displayNegotiationOfferResult(data);
        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-enough-points') {
            notie.alert({type: 3, text: 'You do not have enough Creative Points to make that offer'})
        }
        if (data['error'] === 'not-found') {
            notie.alert({type: 3, text: 'This negotiation could not be found. Please try again.'})
        }
        if (data['error'] === 'not-negotiating') {
            notie.alert({type: 3, text: 'You can no longer make offers in this negotiation'})
        }
    }
}

async function getNegotiationSendToMainRosterRequest(uid) {
    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await negotiationSendToMainRoster(uid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showNegotiationSendToMainRosterData(data);
}

function showNegotiationSendToMainRosterData(data) {
     if (!data['error']) {
        playSoundEffect('success');
        $('.negotiation-box').find('#negotiation-send-to-main-roster-button').hide();
        let notieText = 'Talent will be sent to the Main Roster';
        if (data['acceleratedTrainingFacility']) {
            notieText += ' for no extra cost due to the Accelerated Training Facility'
        }
        notie.alert({
            type: 4, text: notieText
        });
        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-enough-points') {
            notie.alert({type: 3, text: 'You do not have enough Creative Points.'})
        }
        if (data['error'] === 'already-set') {
            notie.alert({type: 3, text: 'This talent has already been set to be sent to the Main Roster.'})
        }
        if (data['error'] === 'not-found') {
            notie.alert({type: 3, text: 'This negotiation could not be found. Please try again.'})
        }
    }
}

function displayNegotiationOfferResult(data) {
    let $negotiationBox = $('.negotiation-box');
    $negotiationBox.find('.negotiation-box-dialog-content').text(data['dialog']).hide().fadeIn('fast');

    if (data['offerRejected']) {
        let icon = $negotiationBox.find('.negotiation-box-attempts-remaining i.fa-times.light-grey').first();
        icon.addClass('red').removeClass('light-grey');

        if (data['negotiationRejected']) {
            let infoHtml = data['name'] + ' will not take any more offers from us.';
            $negotiationBox.find('.negotiation-box-info').html(infoHtml);
            $negotiationBox.find('#make-negotiation-offer').hide();
            $negotiationBox.find('.negotiation-box-offer-container').hide();
            $negotiationBox.find('.negotiation-box-other-offers').hide();
        }
    }
    if (data['offerAccepted']) {
        $negotiationBox.find('.negotiation-box-attempts-remaining i.fa-check').show();
        $negotiationBox.find('.negotiation-box-attempts-remaining i.fa-times').hide();

        let staffHtml = '';
        if (data['talentManagerName']) {
            staffHtml = 'Your Talent Manager, ' + data['talentManagerName'] + ','
        }
        else {
            staffHtml = 'Your Staff'
        }
        let infoHtml;
        if (data['companyName']) {
            infoHtml = staffHtml + ' will finalize the deal with ' + data['companyName'] +
            ' by next month.';
        }
        else {
            infoHtml = staffHtml + ' will finalize the deal by next month.';
        }

        $negotiationBox.find('.negotiation-box-info').html(infoHtml);
        $negotiationBox.find('#make-negotiation-offer').hide();
        $negotiationBox.find('#negotiation-send-to-main-roster-button').show();
        $negotiationBox.find('.negotiation-box-offer-container').hide();
    }
}

async function loadAddStaffTaskPage(talentUid, talentType, talentName, task) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getAddStaffTaskData(talentUid, task);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showAddStaffTaskPageData(data, talentUid, talentType, talentName, task);
}

function showAddStaffTaskPageData(data, talentUid, talentType, talentName, task) {
    if (!data['error']) {
        playSoundEffect('success');
        hideContent($());
        let $addStaffTaskContainer = $("#add-staff-task-container");

        // Get task name and staff role
        let taskName;
        let staffRole;
        if (task === 'unlearn trait' || task === 'transition (staff)') {
            staffRole = 'Staff';
        }
        else {
            staffRole = toTitleCase(data['role'].replace(/_/g, " "));
        }

        if (task === 'unlearn trait') {
            taskName = 'Unlearn Trait For {0}'.format(talentName);
        }
        else {
            taskName = '{0} {1}'.format(toTitleCase(task), talentName);
        }

        $addStaffTaskContainer.find('.add-staff-task-name').text(taskName);
        $addStaffTaskContainer.find('.add-staff-task-role').text(staffRole + ' To Assign');

        // Add top role info
        if (data['topRolesData'] && data['topRolesData'].length > 0) {
            let rolesData = [];
            data['topRolesData'].forEach(function(roleData) {
                rolesData.push('{0} ({1})'.format(toTitleCase(roleData['role'].replace(/_/g, " ")), roleData['boostNames'].join(', ')))
            });
            let roleInfoHtml = 'Your Staff believes that {0} will be best suited as a {1}.'.format(talentName, commaSeparate(rolesData, 'or'));
            $('.transition-to-staff-role-info').text(roleInfoHtml).show();
        }
        else {
            $('.transition-to-staff-role-info').hide();
        }

        // Populate staff select
        let staffMemberSelect = $addStaffTaskContainer.find('.add-staff-task-staff-select');
        let staffOptions = '';
        data['availableStaffMembers'].forEach(function (staff) {
            // Show roles if showing all staff
            let staffOptionRole = '';
            if (task === 'unlearn trait' || task === 'transition (staff)') {
                staffOptionRole = ' ' + toTitleCase(staff['role'].replace(/_/g, " "))
            }
            staffOptions += '<option value="' + staff['uid'] + '">' + staff['name'] + ' (Lvl ' + staff['level'] + staffOptionRole + ')</option>'
        });
        staffMemberSelect.html(staffOptions);

        // Show/hide selects
        $addStaffTaskContainer.find('.add-staff-task-trait-select').parent().hide();
        $addStaffTaskContainer.find('.add-staff-task-skill-select').parent().hide();
        $addStaffTaskContainer.find('.add-staff-task-role-select').parent().hide();
        if (task === 'train') {
            $addStaffTaskContainer.find('.add-staff-task-skill-select').parent().show();
            $addStaffTaskContainer.find('.add-staff-task-skill-select').val('workrate');
        }
        else if (task === 'unlearn trait') {
            $addStaffTaskContainer.find('.add-staff-task-trait-select').parent().show();
            // Populate trait select
            let traitOptions = '';
            let superstarTraits = $('#unlearn-talent-trait-button').data('canUnlearnTraits');
            superstarTraits.forEach(function (trait) {
                traitOptions += '<option>' + trait + '</option>'
            });
            $addStaffTaskContainer.find('.add-staff-task-trait-select').html(traitOptions);
        }
        else if (task === 'transition (staff)') {
            $addStaffTaskContainer.find('.add-staff-task-role-select').parent().show();
            $addStaffTaskContainer.find('.add-staff-task-role-select').val('producer');
        }

        // Show/hide info
        let addStaffTaskInfo = getAddStaffTaskInfo(task);
        if (addStaffTaskInfo) {
            $addStaffTaskContainer.find('.add-staff-task-info-text').html(addStaffTaskInfo);
            $addStaffTaskContainer.find('.add-staff-task-info').show();
        }
        else {
            $addStaffTaskContainer.find('.add-staff-task-info').hide();
        }

        // Show cost
        let cost = 10;
        if (task === 'transition (staff)') {
            cost = 50
        }
        $addStaffTaskContainer.find('.add-staff-task-cost').text(cost);

        // Set data
        $addStaffTaskContainer.data('talentUid', talentUid);
        $addStaffTaskContainer.data('talentType', talentType);
        $addStaffTaskContainer.data('task', task);

        $addStaffTaskContainer.fadeIn('slow').removeClass('display-none');
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'no-staff-member') {
            let errorText;
            if (task === 'unlearn trait') {
                errorText = 'You need to have a Staff Member available to unlearn traits for talent';
            }
            else if (task === 'transition (staff)') {
                errorText = 'You need to have a Staff Member (besides a Doctor) available to transition talent to staff';
            }
            else {
                errorText = 'You need to have a {0} available on your staff to {1} talent'.format(toTitleCase(data['role'].replace(/_/g, " ")), task);
            }
            if (!globals.game['paid']) {
                errorText += ' (JoW Paid)'
            }
            notie.alert({type: 3, text: errorText});
        }
    }
}

async function getAddStaffTaskRequest(talentUid, talentType, staffUid, taskName, skillName, traitName, roleName,
                                      replace) {
    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await addStaffTask(talentUid, talentType, staffUid, taskName, skillName, traitName, roleName, replace);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    await showAddStaffTaskData(data, talentUid, talentType, staffUid, taskName, skillName, traitName, roleName);
}

async function showAddStaffTaskData(data, talentUid, talentType, staffUid, taskName, skillName, traitName, roleName) {
    if (!data['error']) {
        playSoundEffect('success');

        let taskNameDisplay = (taskName === 'unlearn trait') ? 'unlearn a trait for ' : taskName;
        notie.alert({
            type: 4,
            text: '{0} has been assigned to {1} {2}'.format(data['staffMemberName'], taskNameDisplay, data['talentName']),
            stay: true
        });

        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        setTimeout(function () {
            $("#add-staff-task-container").hide();
            if (taskName === 'transition (talent)') {
                $("#view-company-staff-menu-button").trigger('click');
            }
            else {
                $('.roster-member-details-back-button').trigger('click')
            }
        }, 1200);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-paid') {
            notie.alert({
                type: 3,
                text: 'You can only add Staff tasks in JoW Paid.'
            });
        }
        if (data['error'] === 'talent-not-found') {
            notie.alert({
                type: 3,
                text: 'The selected talent could not be found. Please try again.'
            });
        }
        if (data['error'] === 'staff-not-found') {
            notie.alert({
                type: 3,
                text: 'The selected staff could not be found. Please try again.'
            });
        }
        if (data['error'] === 'not-enough-points') {
            notie.alert({
                type: 3, text: 'You do not have enough Creative Points to add this task'
            });
        }
        if (data['error'] === 'task-present') {
            // Confirm task replacement
            notie.confirm({
                text: '{0} is already working on {1}. Do you want to replace that task with this one?'.format(data['staffMemberName'], data['currentTask']),
                submitCallback: async function () {
                    await getAddStaffTaskRequest(talentUid, talentType, staffUid, taskName, skillName, traitName, roleName, true);
                },
                cancelText: 'No'
            });
        }
        if (data['error'] === 'negotiating-buyout') {
            notie.alert({
                type: 3,
                text: '{0} is already working on {1}.'.format(data['staffMemberName'], data['currentTask'])
            });
        }
        if (data['error'] === 'no-task') {
            notie.alert({
                type: 3,
                text: 'That task could not be added. Please try again.'
            });
        }
        if (data['error'] === 'trainer-level-2') {
            notie.alert({
                type: 3,
                text: 'This task can only be performed by a Level 2 Trainer or above.'
            });
        }
        if (data['error'] === 'leaving-talent') {
            notie.alert({
                type: 3,
                text: data['talentName'] + ' has decided to leave the company and cannot be worked on.'
            });
        }
        if (data['error'] === 'high-morale-talent') {
            notie.alert({
                type: 3,
                text: data['talentName'] + '\'s morale is already high.'
            });
        }
        if (data['error'] === 'task-already-present') {
            notie.alert({
                type: 3,
                text: '{0} is already working on {1}. Please cancel that task first.'.format(data['otherStaff'], data['otherStaffTask'])
            });
        }
        if (data['error'] === 'short-injury') {
            notie.alert({
                type: 3,
                text: data['talentName'] + '\'s injury is not severe enough to benefit from rehab.'
            });
        }
        if (data['error'] === 'non-injury') {
            notie.alert({
                type: 3,
                text: data['talentName'] + '\'s injury cannot benefit from rehab (it might be a kayfabe injury or an injury that was set when the game started)'
            });
        }
        if (data['error'] === 'doctor-level-2') {
            notie.alert({
                type: 3,
                text: 'This task can only be performed by a Level 2 Doctor or above.'
            });
        }
        if (data['error'] === 'medical-facility-level-2') {
            notie.alert({
                type: 3,
                text: 'You need to have a Developed (Level 2) Medical Facility to rehab talent.'
            });
        }
        if (data['error'] === 'trait-not-found') {
            notie.alert({
                type: 3,
                text: 'The selected trait could not be found. Please try again.'
            });
        }
        if (data['error'] === 'cannot-unlearn-trait') {
            notie.alert({
                type: 3,
                text: 'The selected trait cannot be unlearned.'
            });
        }
        if (data['error'] === 'wrong-staff-role-to-unlearn') {
            notie.alert({
                type: 3,
                text: 'The selected trait can only be unlearned by a {0}.'.format(toTitleCase(data['staffRoleToUnlearn'].replace(/_/g, " ")))
            });
        }
        if (data['error'] === 'trade-talent') {
            notie.alert({
                type: 3,
                text: data['talentName'] + ' is on trade and cannot be transitioned to staff.'
            });
        }
        if (data['error'] === 'wrong-staff-role-to-transition') {
            notie.alert({
                type: 3,
                text: 'The selected role requires a {0} to work on the transition.'.format(toTitleCase(roleName.replace(/_/g, " ")))
            });
        }
        if (data['error'] === 'different-existing-staff-role') {
            notie.alert({
                type: 3,
                text: '{0} is only interested in transitioning back to a {1}.'.format(data['talentName'], toTitleCase(data['existingRole'].replace(/_/g, " ")))
            });
        }
        if (data['error'] === 'max-roles') {
            notie.alert({
                type: 3, text: "Your {0} Facility only allows a maximum of {1} {2}s (including transitioning superstars).".format(data['facilityName'], data['numberOfRoles'], toTitleCase(roleName.replace(/_/g, " ")))
            });
        }
        if (data['error'] === 'task-assigned-to-self') {
            notie.alert({
                type: 3, text: "Staff cannot work on themselves. Please select someone else."
            });
        }
        if (data['error'] === 'no-superstar-object-present') {
            notie.alert({
                type: 3, text: "Only staff who were previously superstars can be transitioned back."
            });
        }
        if (data['error'] === 'mars') {
            notie.alert({
                type: 3, text: "You cannot transition talent to staff in Wrestling on Mars."
            });
        }
        if (data['error'] === 'passion') {
            notie.alert({
                type: 3, text: "You cannot transition talent to staff in Passion of Wrestling."
            });
        }
        if (data['error'] === 'role-requirement-failed') {
            notie.alert({
                type: 3, text: "{0} does not have the necessary skills to become a {1} ({2}).".format(data['talentName'], roleName.replace(/_/g, " "), data['requirementName'])
            });
        }
        if (data['error'] === 'transition-declined') {
            notie.alert({
                type: 3, text: "{0} is not interested in transitioning to staff at this point ({1}).".format(data['talentName'], data['declinedReason'])
            });
        }
    }
}

function getAddStaffTaskInfo(task) {
    if (task === 'unlearn trait') {
        return 'Unlearning a Trait takes 6 months and requires Staff with a specific role related to the Trait. The chance of success depends on the skill of the Staff Member.'
    }
    else if (task === 'transition (staff)') {
        return 'Transitioning to Staff takes 2 months. Transitioned Superstars cannot be used as Talent unless they are transitioned back.'
    }
    else if (task === 'train') {
        return 'Training takes 3 months.'
    }
    else if (task === 'reassure') {
        return 'Reassuring takes 1 month.'
    }
    else if (task === 'transition') {
        return 'Transitioning takes 1 month.'
    }
    else if (task === 'scout') {
        return 'Scouting takes 1 month.'
    }
    else if (task === 'recruit') {
        return 'Recruiting takes 1 month.'
    }
    else if (task === 'prepare') {
        return 'Preparing for callups takes 1-2 months, depending on the level of the Staff Member.'
    }
    else if (task === 'rehab') {
        return 'Rehab is assigned for the duration of the injury.'
    }
    else if (task === 'transition (talent)') {
        return 'Transitioning to Talent takes 2 months.'
    }
    else {
        return ''
    }
}

async function loadAddManagerRelationshipPage(uid, checkBrandExclusivity) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getAddManagerRelationshipData(checkBrandExclusivity);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showAddManagerRelationshipPageData(data, uid);
}

function showAddManagerRelationshipPageData(data, uid) {
    // Populate manager select
    let managerSelect = $('#add-manager-relationship .add-manager-relationship-manager-select');
    let managerOptionsHtml = '';
    managerOptionsHtml += '<option selected disabled value>Select Manager</option>';

    // Put full time managers and superstars into optgroups
    let fullTimeManagersOptions = '';
    let superstarsOptions = '';
    data['managerSelections'].forEach(function (manager) {
        let managerOptionHtml = '<option value="' + manager['uid'] + '">' + manager['name'] + '</option>';
        if (manager['fullTimeManager']) {
            fullTimeManagersOptions += managerOptionHtml
        } else {
            superstarsOptions += managerOptionHtml
        }
    });
    managerOptionsHtml += '<optgroup label="Full-time Managers">' + fullTimeManagersOptions + '</optgroup>';
    managerOptionsHtml += '<optgroup label="Superstars">' + superstarsOptions + '</optgroup>';
    managerSelect.html(managerOptionsHtml);

    // Populate talent select
    let talentSelect = $('#add-manager-relationship .add-manager-relationship-talent-select');
    talentSelect.slice(1).parent().remove();  // Remove extra talent selects
    let talentOptions = '';
    talentOptions += '<option selected disabled value>Select Talent</option>';
    data['talentSelections'].forEach(function (talent) {
        talentOptions += '<option value="' + talent['uid'] + '" data-type="' + talent['type'] + '">' + talent['name'] + '</option>'
    });
    talentSelect.html(talentOptions);

    // Select uid if present
    if (uid && managerSelect.find("option[value='" + uid + "']").length > 0) {
        managerSelect.val(uid)
    }

    $("#add-manager-relationship").fadeIn('slow').removeClass('display-none');
}

async function loadRemoveManagerRelationshipPage(uid) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getRemoveManagerRelationshipData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showRemoveManagerRelationshipPageData(data, uid);
}

function showRemoveManagerRelationshipPageData(data, uid) {
    // Populate manager select
    let managerSelect = $('#remove-manager-relationship .remove-manager-relationship-manager-select');
    let managerOptionsHtml = '';
    data['managerSelections'].forEach(function (manager) {
        managerOptionsHtml += '<option value="' + manager['uid'] + '">' + manager['name'] + '</option>'

    });
    managerSelect.html(managerOptionsHtml);

    // Remove extra talent selects
    let talentSelect = $('#remove-manager-relationship .remove-manager-relationship-talent-select');
    talentSelect.slice(1).parent().remove();

    // Show manager talent upon remove manager select
    const $removeManagerRelationship = $('#remove-manager-relationship');
    $removeManagerRelationship.off('change', '.remove-manager-relationship-manager-select');
    $removeManagerRelationship.on('change', '.remove-manager-relationship-manager-select', function () {
        // Get selected manager data
        let el = $(this);
        let selectedManagerData = data['managerSelections'].filter(function (managerSelection) {
            return managerSelection['uid'] === parseInt(el.val());
        })[0];

        // Remove extra talent selects
        talentSelect = $('#remove-manager-relationship .remove-manager-relationship-talent-select');
        talentSelect.slice(1).parent().remove();

        // Populate talent select
        let talentOptions = '';
        talentOptions += '<option selected disabled value>Select Talent</option>';
        selectedManagerData['talentData'].forEach(function (talent) {
            talentOptions += '<option value="' + talent['uid'] + '">' + talent['name'] + '</option>'
        });
        talentSelect.html(talentOptions);
    });

    // Select first manager if present
    if (data['managerSelections'].length > 0) {
        managerSelect.val(managerSelect.find('option:first').val()).trigger('change');
    }
    // Otherwise add disabled values
    else {
        managerSelect.html('<option selected disabled value>Select Manager</option>');
        talentSelect.html('<option selected disabled value>Select Talent</option>');
    }

    // Select uid if present
    if (uid && managerSelect.find("option[value='" + uid + "']").length > 0) {
        managerSelect.val(uid).trigger('change')
    }

    $("#remove-manager-relationship").fadeIn('slow').removeClass('display-none');
}

async function getAddManagerRelationshipRequest() {

    if (globals.requestRunning) {
        return;
    }

    let parent = $('#add-manager-relationship');

    // Get uid for manager
    let managerUid = parseInt(parent.find('.add-manager-relationship-manager-select').find(':selected').val());

    // Get talent selects that have a value selected
    let talentSelects = parent.find('.add-manager-relationship-talent-select').filter(function (i, x) {
        return $(x).val();
    });

    // Get uid and type for talent
    let talentData = Array.from(talentSelects, function(el) {
        let elSelectedOption = $(el).find(':selected');
        return {'uid': parseInt(elSelectedOption.val()), 'type': elSelectedOption.attr('data-type')}
    });

    // Validate
    if (!managerUid) {
        notie.alert({type: 3, text: "Select a manager to be assigned to talent"});
        return false;
    }
    if (talentData.length <= 0) {
        notie.alert({type: 3, text: "Select talent to be assigned to the manager"});
        return false;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await addManagerRelationship(managerUid, talentData);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showAddManagerRelationshipData(data);
}

function showAddManagerRelationshipData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        let html = '<span class="display-block">Assigned {0} to manage {1}</span>'.format(data['managerName'], commaSeparate(data['managedSuperstarsNames']));
        notie.alert({type: 4, text: html, stay: true});

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Update unread messages
        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }

        // Go back to view managers
        setTimeout(function () {
            $('#view-managers-menu-button').trigger('click');
        }, 1000);

    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-enough-points') {
            notie.alert({type: 3, text: "You do not have enough Creative Points to add a manager relationship."});
        }
        if (data['error'] === 'manager-not-found') {
            notie.alert({type: 3, text: "The selected manager could not be found. Please try again."});
        }
        if (data['error'] === 'talent-not-found') {
            notie.alert({type: 3, text: "One of the selected talent could not be found. Please try again."});
        }
        if (data['error'] === 'maximum-superstars') {
            notie.alert({type: 3, text: "A manager cannot manage more than 15 superstars."});
        }
        if (data['error'] === 'manager-present') {
            notie.alert({type: 3, text: "{0} already has a manager present.".format(data['superstarName'])});
        }
        if (data['error'] === 'managing-self') {
            notie.alert({type: 3, text: "Superstars cannot manage themselves."});
        }
        if (data['error'] === 'managing-full-time-manager') {
            notie.alert({type: 3, text: "Full-time managers cannot be managed."});
        }
    }
}

async function getRemoveManagerRelationshipRequest() {

    if (globals.requestRunning) {
        return;
    }

    let parent = $('#remove-manager-relationship');

    // Get uid for manager
    let managerUid = parseInt(parent.find('.remove-manager-relationship-manager-select').find(':selected').val());

    // Get talent selects that have a value selected
    let talentSelects = parent.find('.remove-manager-relationship-talent-select').filter(function (i, x) {
        return $(x).val();
    });

    // Get uid for talent
    let talentData = Array.from(talentSelects, function(el) {
        let elSelectedOption = $(el).find(':selected');
        return {'uid': parseInt(elSelectedOption.val())}
    });

    // Validate
    if (talentData.length <= 0) {
        notie.alert({type: 3, text: "Select talent to be removed from the manager"});
        return false;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await removeManagerRelationship(managerUid, talentData);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showRemoveManagerRelationshipData(data);
}

function showRemoveManagerRelationshipData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        let html = '<span class="display-block">Removed {0} from {1}</span>'.format(commaSeparate(data['removedSuperstarsNames']), data['managerName']);
        notie.alert({type: 4, text: html, stay: true});

        // Go back to view managers
        setTimeout(function () {
            $('#view-managers-menu-button').trigger('click');
        }, 1000);

    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'manager-not-found') {
            notie.alert({type: 3, text: "The selected manager could not be found. Please try again."});
        }
        if (data['error'] === 'talent-not-found') {
            notie.alert({type: 3, text: "One of the selected talent could not be found. Please try again."});
        }
        if (data['error'] === 'not-manager') {
            notie.alert({type: 3, text: "{0} is not managed by this manager.".format(data['superstarName'])});
        }
    }
}

async function loadAddTeamPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getAddTeamData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showAddTeamPageData(data);
}

function showAddTeamPageData(data) {
    const $addTeam = $("#add-team");

    // Reset inputs
    $addTeam.find('select[name="tag-team-type-option"]').val('tag-team').trigger('change');
    $addTeam.find('.add-team-superstar-select').html('');
    $addTeam.find('input').val('');

    let superstarSelects = $('#add-team .add-team-superstar-select');
    superstarSelects.html('');

    // Populate participant select
    let optionsHtml = '';
    optionsHtml += '<option selected disabled>Select Superstar</option>';
    data.forEach(function (superstar) {
        optionsHtml += '<option value="' + superstar.replace(/"/g, "&quot;") + '">' + superstar + '</option>'
    });

    superstarSelects.html(optionsHtml);

    $addTeam.fadeIn('slow').removeClass('display-none');

    // Tutorial action check
    checkTutorialStepAction('click_add_team_menu_button');
}

async function getAddTeamRequest() {

    if (globals.requestRunning) {
        return;
    }

    let name = $("#add-team input[name=team-name]").val();
    let firstSuperstar = $("#add-team .add-team-first-superstar-select").val();
    let secondSuperstar = $("#add-team .add-team-second-superstar-select").val();
    let thirdSuperstar = $("#add-team .add-team-third-superstar-select").val();
    let teamType = $("#add-team select[name=tag-team-type-option]").val();

    // Validate
    if (name.length <= 0) {
        notie.alert({type: 3, text: "Enter a name for the Team"});
        return false;
    }
    if (!firstSuperstar) {
        notie.alert({type: 3, text: "Select the first Superstar"});
        return false;
    }
    if (!secondSuperstar) {
        notie.alert({type: 3, text: "Select the second Superstar"});
        return false;
    }
    if (teamType === 'trio' && !thirdSuperstar) {
        notie.alert({type: 3, text: "Select the third Superstar"});
        return false;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await addTeam(name, firstSuperstar, secondSuperstar, thirdSuperstar, teamType);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showAddTeamData(data);
}

function showAddTeamData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        let html = '<span class="display-block">' +
            "Added {0} ({1}) to the Roster!".format(data['tagTeamName'], data['tagTeamType']) +
            '</span>';
        notie.alert({
            type: 4, text: html,
            stay: true
        });

        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Tutorial action check
        if (data['nextTutorialState']) {
            globals.game.tutorialState = data['nextTutorialState']
        }

        // Update unread messages
        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }

        // Tutorial action check
        checkTutorialStepAction('add_team');

        // Go back to view teams
        setTimeout(function () {
            $('#view-teams-menu-button').trigger('click');
        }, 800);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-found') {
            notie.alert({type: 3, text: 'One of the selected Superstars could not be found. Please try again.'})
        }
        else if (data['error'] === 'already-present') {
            notie.alert({type: 3, text: 'A Team with that name already exists'})
        }
        else if (data['error'] === 'faction-already-present') {
            notie.alert({type: 3, text: 'A Faction with that name already exists'})
        }
        else if (data['error'] === 'duplicate-superstars') {
            notie.alert({type: 3, text: 'Superstars cannot tag with themselves'})
        }
        else if (data['error'] === 'already-in-tag-team') {
            notie.alert({
                type: 3,
                text: data['superstarName'] + ' is already in a ' + data['tagTeamType']
            })
        }
        else if (data['error'] === 'not-enough-points') {
            notie.alert({type: 3, text: 'You do not have enough Creative Points to add a Team'})
        }
    }
}

async function loadAddSuperstarPage($el) {

    if (globals.requestRunning) {
        return;
    }
    if (globals.game.story === 'passion') {
        notie.alert({type: 3, text: "You cannot add custom superstars or managers in Passion of Wrestling"});
        return false;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getCompanyBrandNames();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showAddSuperstarPageData(data, $el);
}

function showAddSuperstarPageData(data, $el) {
    // Add select data
    let brandNameSelect = $('#add-superstar select[name="custom-superstar-brand"]');
    populateBrandNameSelect(data, brandNameSelect);

    let parentContainer = $el.closest('.box');
    let addSuperstarElement = $('#add-superstar');

    let $graphic = $('#wrestler-graphic');
    $graphic.html('').show();
    resetAddSuperstarGraphic($graphic);

    addSuperstarElement.fadeIn('slow').removeClass('display-none');
    addSuperstarElement.find('.character-creator-controls').show();

    // Reset inputs
    addSuperstarElement.find('input').val('');
    addSuperstarElement.find('select[name="custom-superstar-pronoun"]').val('he');
    addSuperstarElement.find('select[name="custom-superstar-charisma"], ' +
        'select[name="custom-superstar-workrate"]').val('1');
    addSuperstarElement.find('select[name="custom-superstar-alignment-select"]').val('');
    addSuperstarElement.find('select[name="superstar-graphic-option"]').val('1').trigger('change');
    addSuperstarElement.find('select[name="custom-superstar-part-timer"]').val('0');
    addSuperstarElement.find('.add-superstar-cost').text('100');
    addSuperstarElement.find('.superstar-traits-selection-text').text('None').removeClass('superstar-trait-color');
    addSuperstarElement.find('.superstar-trait-item-container').removeClass('selected');
    addSuperstarElement.find('.superstar-trait-items-container').hide();
    addSuperstarElement.find('.superstar-traits-information').text('Select a trait to display its details here').hide();
    addSuperstarElement.find('.superstar-traits-show-button').find('span').text('Show Traits');
    addSuperstarElement.find('.superstar-traits-show-button').find('i').addClass('fa-angle-down').removeClass('fa-angle-up');
    if (parentContainer[0].id === 'view-managers-container') {
        addSuperstarElement.find('select[name="custom-superstar-full-time-manager"]').val('1');
    }
    else {
        addSuperstarElement.find('select[name="custom-superstar-full-time-manager"]').val('0');
    }

    if (globalUser.paid) {
        addSuperstarElement.find('select[name="custom-superstar-full-time-manager"]').parent().show();
        addSuperstarElement.find('select[name="custom-superstar-brand"]').parent().show();
    }
    else {
        addSuperstarElement.find('select[name="custom-superstar-full-time-manager"]').parent().hide();
        addSuperstarElement.find('select[name="custom-superstar-brand"]').parent().hide();
    }

    addSuperstarElement.data('element', parentContainer[0].id);
}

async function loadReleaseSuperstarPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getCompanySuperstarsData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showReleaseSuperstarPageData(data);
}

function showReleaseSuperstarPageData(data) {
    let div = $('#release-superstar .select-superstar-all');
    div.html('');
    $.each(data, function () {
        div.append($("<option />").val(this.value).text(this.name).data('uid', this.uid));
    });
    $("#release-superstar").fadeIn('slow').removeClass('display-none');
}

async function getAddSuperstarRequest() {

    if (globals.requestRunning) {
        return;
    }

    let parent = $('#add-superstar');
    let name = parent.find("input[name='name']").val();
    let age = parseInt(parent.find("input[name='age']").val());
    let pronoun = parent.find("select[name='custom-superstar-pronoun']").val();
    let alignment = parent.find("select[name='custom-superstar-alignment-select']").val();
    let partTimer = parent.find("select[name='custom-superstar-part-timer']").val() === '1';
    let charisma = parseInt(parent.find("select[name='custom-superstar-charisma']").val());
    let workrate = parseInt(parent.find("select[name='custom-superstar-workrate']").val());
    let fullTimeManager = parent.find("select[name='custom-superstar-full-time-manager']").val() === '1';
    let brandName = parent.find("select[name='custom-superstar-brand']").val();

    // Get graphic data
    $('#add-superstar .share-character').trigger('click').removeClass('selected');
    $('#add-superstar .share-character-code-container').hide();
    let graphicData = $('#add-superstar .share-character-code-input').val();
    let addGraphic = parent.find("select[name='superstar-graphic-option']").val() === '1';

    // Get traits
    let selectedTraits = Array.from(parent.find('.superstar-trait-item-container.selected'), function (x) {
        return $(x).text().trim().replace(/\s+/g, " ");
    });

    // Validate
    if (name.length <= 0) {
        notie.alert({type: 3, text: "Enter a name for the Superstar"});
        return false;
    }
    if (age.length <= 0 || !age) {
        notie.alert({type: 3, text: "Enter a number for the Superstar's Age"});
        return false;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await addSuperstar(name, age, pronoun, alignment, partTimer, charisma, workrate, fullTimeManager,
        brandName, graphicData, addGraphic, selectedTraits);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showAddSuperstarData(data);
}

function showAddSuperstarData(data) {
    if (!data['error']) {
        playSoundEffect('success');
        let html = '<span class="display-block">' +
            data['superstarName'] + ' added to the Main Roster' +
            '</span>';
        notie.alert({
            type: 4, text: html
        });

        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Go back to view roster/managers
        setTimeout(function () {
            if ($('#add-superstar').data('element') === 'view-managers-container') {
                $('#view-managers-menu-button').trigger('click');
            } else {
                $('#view-roster-menu-button').trigger('click');
            }
        }, 800);
    } else {
        playSoundEffect('error');
        if (data['error'] === 'not-enough-points') {
            notie.alert({type: 3, text: 'You do not have enough Creative Points to add a Superstar'})
        }
        if (data['error'] === 'managers-paid') {
            notie.alert({type: 3, text: 'Managers are only available in JoW Paid'})
        }
        if (data['error'] === 'brands-paid') {
            notie.alert({type: 3, text: 'Brands are only available in JoW Paid'})
        }
        if (data['error'] === 'brand-not-found') {
            notie.alert({type: 3, text: 'That brand could not be found. Please try again.'})
        }
        if (data['error'] === 'already-exists') {
            notie.alert({
                type: 3,
                text: 'A Superstar with that name already exists in your ' + data['existsRoster'] + ' Roster'
            })
        }
        if (data['error'] === 'owner-name') {
            notie.alert({type: 3, text: 'The Superstar\'s name cannot be the same as the owner\'s name'})
        }
        if (data['error'] === 'age') {
            notie.alert({type: 3, text: 'Please enter an age between 10 and 100'})
        }
    }
}

async function getReleaseSuperstarRequest() {

    if (globals.requestRunning) {
        return;
    }

    let uid = $('#release-superstar').find(".select-superstar-all").find(':selected').data('uid');
    let type = 'superstar';

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await releaseTalent({uid, type});
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showReleaseSuperstarData(data);
}

function showReleaseSuperstarData(data) {
    if (!data['error']) {
        playSoundEffect('success');
        let overnessDecrease = '<span class="stale-color">' + data['overnessDecrease'] +
            '<span class="margin-left-2">%</span></span>';

        let html = '<span class="display-block">' +
            data['name'] + ' has been released, ' +
            'lowering ' + data['possessivePronoun'] + ' Overness by ' + overnessDecrease +
            '</span>';
        notie.alert({
            type: 4, text: html
        });

        // Select next superstar
        let selected = $('#release-superstar').find(".select-superstar-all").find(":selected");
        selected.next().prop('selected', true);

        // Remove released superstar
        selected.remove();
    } else {
        playSoundEffect('error');
        if (data['error'] === 'not-found') {
            notie.alert({type: 3, text: 'Talent not found in your roster'});
        } else if (data['error'] === 'champion') {
            notie.alert({type: 3, text: 'Champions cannot be released'});
        } else if (data['error'] === 'trade-deal') {
            notie.alert({type: 3, text: 'Talent belonging to other Companies cannot be released'});
        } else if (data['error'] === 'martian') {
            notie.alert({type: 3, text: 'Markus won\'t put through the release of any Martians'});
        } else if (data['error'] === 'pow-person') {
            notie.alert({type: 3, text: '\"What? No, we need that talent!\" - Hank Hughes'});
        } else if (data['error'] === 'booked') {
            notie.alert({type: 3, text: 'Talent booked in a match cannot be released'});
        }
    }
}

function updateCustomSuperstarCost() {
    // Update cost with superstar attribute change
    let cost = 100;
    let addSuperstarElement = $('#add-superstar');
    let workrate = addSuperstarElement.find("select[name='custom-superstar-workrate']").val();
    let charisma = addSuperstarElement.find("select[name='custom-superstar-charisma']").val();
    let selectedTraits = addSuperstarElement.find('.superstar-trait-item-container.selected');
    cost += (workrate - 1) * 75;
    cost += (charisma - 1) * 75;
    cost += selectedTraits.length * 50;
    $('.add-superstar-cost').text(cost);
    return cost;
}

function selectSuperstarTraitElement(element) {
    let traitName = element.text().trim().replace(/\s+/g, " ");
    let validationFailed = false;
    let parentContainer = element.closest('.superstar-trait-items-container');
    let superstarTraitInformationElement = parentContainer.siblings('.superstar-traits-selection-container').find('.superstar-traits-information');
    let selectedTraitsTextElement = parentContainer.siblings('.superstar-traits-selection-container').find('.superstar-traits-selection-text');

    if (element.hasClass('selected')) {
        // Deselect trait
        element.removeClass('selected');
        superstarTraitInformationElement.text('Select a trait to display its details here');
    }
    else {
        // Check if less than max traits selected
        let selectedTraits = parentContainer.find('.superstar-trait-item-container.selected');
        if (selectedTraits.length >= gameLimits.maxTraits) {
            notie.alert({type: 4, text: `You cannot select more than ${gameLimits.maxTraits} Traits`});
            return false;
        }

        // Check for conflicting traits
        selectedTraits.each(function(i, selectedTraitElement) {
            // Convert conflicting traits attribute into list, check if this trait is present in list
            let conflictingTraitsArray = $(selectedTraitElement).attr('data-conflicting-traits').split(',');
            if (conflictingTraitsArray.indexOf(traitName) >= 0) {
                let conflictText = "{0} has a conflict with {1}. Unselect it before selecting this Trait.".format(traitName, $(selectedTraitElement).text());
                superstarTraitInformationElement.html(conflictText);
                validationFailed = true;
            }
        });

        if (validationFailed) {
            return false;
        }

        element.addClass('selected');

        // Show trait information
        let traitInformationText = getSuperstarTraitHelpText(traitName);
        superstarTraitInformationElement.text(traitName + ': ' + traitInformationText);
    }

    let selectedTraitElements = parentContainer.find('.superstar-trait-item-container.selected');

    // Update selected traits text
    let selectedTraitsHtmlArray = Array.from(selectedTraitElements, function (x) {
        let selectedTraitName = $(x).text().trim().replace(/\s+/g, " ");
        return '<span class="help-text" title="' + getSuperstarTraitHelpText(selectedTraitName) + '">' + selectedTraitName + '</span>';
    });
    let selectedTraitsHtml;
    if (selectedTraitsHtmlArray.length > 0) {
        selectedTraitsHtml = selectedTraitsHtmlArray.join(', ');
        selectedTraitsTextElement.addClass('superstar-trait-color');
    }
    else {
        selectedTraitsHtml = 'None';
        selectedTraitsTextElement.removeClass('superstar-trait-color');
    }
    selectedTraitsTextElement.html(selectedTraitsHtml);

    // Update hidden input with trait names
    let selectedTraitsNamesArray = Array.from(selectedTraitElements, function (x) {
        return $(x).text().trim().replace(/\s+/g, " ");
    });
    let selectedTraitsNames;
    if (selectedTraitsNamesArray.length > 0) {
        selectedTraitsNames = selectedTraitsNamesArray.join(', ');
    }
    else {
        selectedTraitsNames = '';
    }
    let hiddenInput = parentContainer.siblings('.superstar-traits-selection-container').find('.superstar-traits-selection-input');
    if (hiddenInput.length > 0) {
        hiddenInput.val(selectedTraitsNames)
    }

    if (element.closest('#add-superstar').length > 0) {
        updateCustomSuperstarCost();
    }
}

function getSuperstarTraitHelpText(trait) {

    function getTraitChangeHtml(change) {
        return (change >= 0) ? ('+' + change) : '-' + (change * -1);
    }

    function getTraitChangeWord(change) {
        return (change >= 1.0) ? ('Multiplies') : ('Reduces');
    }

    if (!traitsData) {
        return ''
    }

    let helpTexts = [];
    let traitData = traitsData[trait];
    if (traitData) {
        if (traitData['gimmick_match_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['gimmick_match_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} gimmick match rating boost {1} {2}x'.format(changeWord, changeVerb, traitData['gimmick_match_multiplier']))
        }
        if (traitData['holy_shit_moment_chance_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['holy_shit_moment_chance_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} holy shit moment chance in gimmick matches {1} {2}x'.format(changeWord, changeVerb, traitData['holy_shit_moment_chance_multiplier']))
        }
        if (traitData['holy_shit_moment_pure_chance_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['holy_shit_moment_pure_chance_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} holy shit moment chance in non-gimmick matches in \'pure\' companies {1} {2}x'.format(changeWord, changeVerb, traitData['holy_shit_moment_pure_chance_multiplier']))
        }
        if (traitData['injury_chance_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['injury_chance_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} chance to get injured {1} {2}x'.format(changeWord, changeVerb, traitData['injury_chance_multiplier']))
        }
        if (traitData['cause_injury_chance_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['cause_injury_chance_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} chance to injure an opponent {1} {2}x'.format(changeWord, changeVerb, traitData['cause_injury_chance_multiplier']))
        }
        if (traitData['add_blood_to_opponent_chance_boost']) {
            let change = getTraitChangeHtml(traitData['add_blood_to_opponent_chance_boost']);
            helpTexts.push('Changes chance to make opponent bleed by {0}%'.format(change))
        }
        if (traitData['positive_match_rating_boost_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['positive_match_rating_boost_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} positive match rating effect chance {1} {2}x'.format(changeWord, changeVerb, traitData['positive_match_rating_boost_multiplier']))
        }
        if (traitData['negative_match_rating_boost_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['negative_match_rating_boost_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} negative match rating effect chance {1} {2}x'.format(changeWord, changeVerb, traitData['negative_match_rating_boost_multiplier']))
        }
        if (traitData['monthly_event_match_rating_boost']) {
            let change = getTraitChangeHtml(traitData['monthly_event_match_rating_boost']);
            helpTexts.push('Changes match ratings by {0} on monthly events'.format(change))
        }
        if (traitData['weekly_show_match_rating_boost']) {
            let change = getTraitChangeHtml(traitData['weekly_show_match_rating_boost']);
            helpTexts.push('Changes match ratings by {0} on weekly shows'.format(change))
        }
        if (traitData['hot_match_chance_boost']) {
            let change = getTraitChangeHtml(traitData['hot_match_chance_boost']);
            helpTexts.push('Changes hot match chance by {0}%'.format(change))
        }
        if (traitData['no_morale_change_except_rank']) {
            helpTexts.push('Mostly happy to lose to anyone except {0}s'.format(traitData['no_morale_change_except_rank']))
        }
        if (traitData['no_morale_change_rank']) {
            helpTexts.push('Mostly happy to lose to {0}s'.format(traitData['no_morale_change_rank']))
        }
        if (traitData['loss_affects_morale_chance']) {
            helpTexts.push('{0}% chance for losses to lower morale'.format(traitData['loss_affects_morale_chance']))
        }
        if (traitData['win_affects_morale_chance']) {
            helpTexts.push('{0}% chance for wins to raise morale'.format(traitData['win_affects_morale_chance']))
        }
        if (traitData['leaving_chance_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['leaving_chance_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} chance to leave if unhappy {1} {2}x'.format(changeWord, changeVerb, traitData['leaving_chance_multiplier']))
        }
        if (traitData['training_xp_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['training_xp_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} training XP gain {1} {2}x'.format(changeWord, changeVerb, traitData['training_xp_multiplier']))
        }
        if (traitData['skill_xp_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['skill_xp_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} skill XP gain in matches and segments {1} {2}x'.format(changeWord, changeVerb, traitData['skill_xp_multiplier']))
        }
        if (traitData['retirement_chance_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['retirement_chance_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} retirement chance {1} {2}x'.format(changeWord, changeVerb, traitData['retirement_chance_multiplier']))
        }
        if (traitData['retirement_age_change']) {
            let change = getTraitChangeHtml(traitData['retirement_age_change']);
            helpTexts.push('Changes retirement age by {0}'.format(change))
        }
        if (traitData['turn_part_timer_age_change']) {
            let change = getTraitChangeHtml(traitData['turn_part_timer_age_change']);
            helpTexts.push('Changes age of turning part-timer by {0}'.format(change))
        }
        if (traitData['overness_increase_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['overness_increase_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} overness increases {1} {2}x'.format(changeWord, changeVerb, traitData['overness_increase_multiplier']))
        }
        if (traitData['overness_decrease_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['overness_decrease_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} overness decreases {1} {2}x'.format(changeWord, changeVerb, traitData['overness_decrease_multiplier']))
        }
        if (traitData['silly_segment_rating_boost']) {
            let change = getTraitChangeHtml(traitData['silly_segment_rating_boost']);
            helpTexts.push('Changes silly segment ratings by {0}'.format(change))
        }
        if (traitData['hot_segment_chance_boost']) {
            let change = getTraitChangeHtml(traitData['hot_segment_chance_boost']);
            helpTexts.push('Changes hot segment chance by {0}%'.format(change))
        }
        if (traitData['face_alignment_hype_boost']) {
            let change = getTraitChangeHtml(traitData['face_alignment_hype_boost']);
            helpTexts.push('Changes face alignment hype boost for matches and feuds by {0}'.format(change))
        }
        if (traitData['heel_alignment_hype_boost']) {
            let change = getTraitChangeHtml(traitData['heel_alignment_hype_boost']);
            helpTexts.push('Changes heel alignment hype boost for matches and feuds by {0}'.format(change))
        }
        if (traitData['face_alignment_penalty']) {
            let change = getTraitChangeHtml(traitData['face_alignment_penalty']);
            helpTexts.push('Adds hype penalty of {0} when aligned as a face'.format(change))
        }
        if (traitData['heel_alignment_penalty']) {
            let change = getTraitChangeHtml(traitData['heel_alignment_penalty']);
            helpTexts.push('Adds hype penalty of {0} when aligned as a heel'.format(change))
        }
        if (traitData['fantasy_gimmick_character_boost']) {
            let change = getTraitChangeHtml(traitData['fantasy_gimmick_character_boost']);
            helpTexts.push('Changes gimmick effectiveness for fantasy characters by {0}%'.format(change))
        }
        if (traitData['non_fantasy_gimmick_character_boost']) {
            let change = getTraitChangeHtml(traitData['non_fantasy_gimmick_character_boost']);
            helpTexts.push('Changes gimmick effectiveness for non-fantasy characters by {0}%'.format(change))
        }
        if (traitData['bad_combination_gimmick_boost']) {
            let change = getTraitChangeHtml(traitData['bad_combination_gimmick_boost']);
            helpTexts.push('Changes gimmick effectiveness for bad combination gimmicks by {0}%'.format(change))
        }
        if (traitData['gimmick_boost']) {
            let change = getTraitChangeHtml(traitData['gimmick_boost']);
            helpTexts.push('Changes gimmick effectiveness for all gimmicks by {0}%'.format(change))
        }
        if (traitData['gimmick_interview_superstar_chance']) {
            helpTexts.push('Adds {0}% chance to be in the Gimmick Interview random event'.format(traitData['gimmick_interview_superstar_chance']))
        }
        if (traitData['hot_feud_chance_boost']) {
            let change = getTraitChangeHtml(traitData['hot_feud_chance_boost']);
            helpTexts.push('Changes hot feud chance by {0}%'.format(change))
        }
        if (traitData['feud_staleness_limit_boost']) {
            let change = getTraitChangeHtml(traitData['feud_staleness_limit_boost']);
            helpTexts.push('Changes feud staleness limit by {0}'.format(change))
        }
        if (traitData['feud_boosted_feud_chance']) {
            helpTexts.push('Adds {0}% chance to be in the Feud Boosted random event'.format(traitData['feud_boosted_feud_chance']))
        }
        if (traitData['feud_ignored_feud_chance']) {
            helpTexts.push('Adds {0}% chance to be in the Feud Ignored random event'.format(traitData['feud_ignored_feud_chance']))
        }
        if (traitData['feud_hype_change_boost']) {
            let change = getTraitChangeHtml(traitData['feud_hype_change_boost']);
            helpTexts.push('Adds {0} to feud hype change in matches and segments'.format(change))
        }
        if (traitData['gimmick_effectiveness_increase_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['gimmick_effectiveness_increase_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} gimmick effectiveness change {1} {2}x'.format(changeWord, changeVerb, traitData['gimmick_effectiveness_increase_multiplier']))
        }
        if (traitData['morale_boost_helper_chance']) {
            helpTexts.push('Adds {0}% chance to be in the Morale Boost random event'.format(traitData['morale_boost_helper_chance']))
        }
        if (traitData['wrestler_court_judge_chance']) {
            helpTexts.push('Adds {0}% chance to be a judge in the Wrestlers Court random event'.format(traitData['wrestler_court_judge_chance']))
        }
        if (traitData['wrestler_court_defendant_chance']) {
            helpTexts.push('Adds {0}% chance to be a defendant in the Wrestlers Court random event'.format(traitData['wrestler_court_defendant_chance']))
        }
        if (traitData['backstage_fight_starter_chance']) {
            helpTexts.push('Adds {0}% chance to be in the Backstage Fight random event'.format(traitData['backstage_fight_starter_chance']))
        }
        if (traitData['drug_abuse_superstar_chance']) {
            helpTexts.push('Adds {0}% chance to be in the Drug Abuse random event'.format(traitData['drug_abuse_superstar_chance']))
        }
        if (traitData['tag_match_workrate_boost']) {
            let change = getTraitChangeHtml(traitData['tag_match_workrate_boost']);
            helpTexts.push('Changes workrate by {0} in tag matches'.format(change))
        }
        if (traitData['lose_trait_chance_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['lose_trait_chance_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} chance to lose traits with age {1} {2}x'.format(changeWord, changeVerb, traitData['lose_trait_chance_multiplier']))
        }
        if (traitData['add_blood_chance_boost']) {
            let change = getTraitChangeHtml(traitData['add_blood_chance_boost']);
            helpTexts.push('Changes chance to bleed by {0}%'.format(change))
        }
        if (traitData['months_to_unlearn_traits_boost']) {
            let change = getTraitChangeHtml(traitData['months_to_unlearn_traits_boost']);
            helpTexts.push('Changes number of months needed to unlearn traits by {0}'.format(change))
        }
        if (traitData['weekly_show_match_fatigue_change']) {
            let change = getTraitChangeHtml(traitData['weekly_show_match_fatigue_change']);
            helpTexts.push('Changes match fatigue by {0} on weekly shows'.format(change))
        }
        if (traitData['monthly_event_match_fatigue_change']) {
            let change = getTraitChangeHtml(traitData['monthly_event_match_fatigue_change']);
            helpTexts.push('Changes match fatigue by {0} on monthly events'.format(change))
        }
        if (traitData['gimmick_match_fatigue_multiplier']) {
            let changeWord = getTraitChangeWord(traitData['gimmick_match_fatigue_multiplier']);
            let changeVerb = (changeWord === 'Multiplies') ? 'by' : 'to';
            helpTexts.push('{0} gimmick match fatigue change {1} {2}x'.format(changeWord, changeVerb, traitData['gimmick_match_fatigue_multiplier']))
        }
        if (traitData['remove_fatigue_age_penalty']) {
            helpTexts.push('Removes fatigue penalty normally added past the age of 40')
        }
    }

    let helpText = helpTexts.join('. ');
    helpText += '.';

    return helpText;
}

function showRosterMemberNameData({data, uid, type} = {}) {
    const $changeNameContainer = $('#change-name-container');
    $('.change-name-member-name').text(data['name']);
    $('#change-name-container .change-name-input').val(data['name']);
    $changeNameContainer.data('uid', uid);
    $changeNameContainer.data('type', type);
    $changeNameContainer.fadeIn();
}

function showRosterMemberPronounData({data, uid} = {}) {
    const $changePronounContainer = $('#change-pronoun-container');
    $('.change-pronoun-member-name').text(data['name']);
    $('#change-pronoun-container .change-pronoun-select').val(data['pronoun']);
    $changePronounContainer.data('uid', uid);
    $changePronounContainer.fadeIn();
}

function showRosterMemberAppearanceData({data, uid} = {}) {
    const $changeAppearanceGraphic = $('#change-appearance-graphic');
    $('.change-appearance-superstar-name').text(data['name']);
    $changeAppearanceGraphic.data('key', JSON.stringify(data['graphic']));
    $changeAppearanceGraphic.data('uid', uid);
    $('input:radio[name="radio-change-appearance-option"][value="change"]').trigger('change').trigger('click');
    $('#change-appearance-container').fadeIn();

    if (data['graphic']) {
        $('.change-appearance-cost').text('15');
    }
    else {
        $('.change-appearance-cost').text('0');
    }
}

function showRosterMemberAlignmentData({data, uid, type} = {}) {
    if (!data['error']) {
        const $changeAlignmentContainer = $('#change-alignment-container');
        $('.change-alignment-member-name').text(data['name']);
        $('#change-alignment-container .change-alignment-select').val(data['alignment']);
        $changeAlignmentContainer.data('uid', uid);
        $changeAlignmentContainer.data('type', type);
        $changeAlignmentContainer.fadeIn();
    }
    else {
        if (data['error'] === 'different-alignments') {
            notie.alert({
                type: 3,
                text: "To change a Team's Alignment, all Team Members need to have the same Alignment"
            });
        }
    }
}

function showRosterMemberBrandData({data, uid, type} = {}) {
    const $changeBrandContainer = $('#change-brand-container');
    $('.change-brand-member-name').text(data['name']);
    let brandNamesOptions = '<option value="">None</option>';
    data['brandNames'].forEach(function (brandName) {
        if (brandName === data['brandName']) {
            brandNamesOptions += '<option selected value="' + brandName.replace(/"/g, "&quot;") + '">' + brandName + '</option>'
        }
        else {
            brandNamesOptions += '<option value="' + brandName.replace(/"/g, "&quot;") + '">' + brandName + '</option>'
        }
    });
    $('#change-brand-container .change-brand-select').html(brandNamesOptions);
    $changeBrandContainer.data('uid', uid);
    $changeBrandContainer.data('type', type);
    $changeBrandContainer.fadeIn();
}

function showRosterMemberGimmickData({data, uid, $el} = {}) {

    // Personalities
    let personalitiesHtml = '';
    let personalities = [...personalitiesData];
    personalities.sort(predicateBy('name'));
    personalities.forEach(function (obj, i) {
        let objClass = '';

        // Remove bottom border for elements in last row
        if (data.length >= 5) {
            // If even items, remove bottom border from last 2 elements
            if (data.length % 2 === 0) {
                if ((i === data.length - 1 || i === data.length - 2)) {
                    objClass += ' border-bottom-0'
                }
            }
            // If odd items, remove bottom border from last element
            else {
                if (i === data.length - 1) {
                    objClass += ' border-bottom-0'
                }
            }
        }

        if (i % 2 !== 0) {
            objClass += ' border-right-0'
        }
        personalitiesHtml += '<div class="gimmick-selection-item personality-item' + objClass + '" data-tag="' + obj['tag'] + '">' +
            obj['name'] + '</div>'
    });
    $('.personalities-container').html(personalitiesHtml);

    // Characters
    let charactersHtml = '';
    let lockedText = ' (JoW Paid)';
    if (globalUser.paid) {
        lockedText = ''
    }

    data['characters'].sort(predicateBy('name'));
    data['characters'].forEach(function (obj, i) {
        let level = '';
        if (obj['level'] === 2) {
            level = '<i class="fa fa-star silver-light margin-left-5"></i>'
        }
        else if (obj['level'] === 3) {
            level = '<i class="fa fa-star gold-light margin-left-5"></i>'
        }
        let objClass = '';

        if (data.length >= 5) {
            if (data.length % 2 === 0) {
                if ((i === data.length - 1 || i === data.length - 2)) {
                    objClass += ' border-bottom-0'
                }
            }
            else {
                if (i === data.length - 1) {
                    objClass += ' border-bottom-0'
                }
            }
        }

        if (i % 2 !== 0) {
            objClass += ' border-right-0'
        }

        let helpText = '';
        if (obj['locked']) {
            objClass += ' locked help-text';
            let unlockedBy = getCharacterUnlockedBy(obj['name']);
            helpText = ' title="' + ' Unlocked by using the \'' + unlockedBy +
                '\' Gimmick to get a Superstar Over' + lockedText + '"';
        }

        // Combinations
        let goodCombinationsData = '';
        let badCombinationsData = '';
        let okayCombinationsData = '';

        if (obj['combinations']) {
            let goodCombinations = obj['combinations']['easy'];
            let badCombinations = obj['combinations']['hard'];
            let okayCombinations = obj['combinations']['okay'];
            if (goodCombinations.length > 0) {
                goodCombinationsData = " data-good-combinations='" + JSON.stringify(goodCombinations) + "'"
            }
            if (badCombinations.length > 0) {
                badCombinationsData = " data-bad-combinations='" + JSON.stringify(badCombinations) + "'"
            }
            if (okayCombinations.length > 0) {
                okayCombinationsData = " data-okay-combinations='" + JSON.stringify(okayCombinations) + "'"
            }
        }

        // Times used
        let timesUsed = obj['timesUsed'];
        let timesUsedData = '';
        if (timesUsed !== undefined && timesUsed > 0) {
            timesUsedData = " data-times-used='" + JSON.stringify(timesUsed) + "'"
        }

        // Easy Combinations
        let easyCombinationsTotal = obj['easyCombinationsTotal'];
        let easyCombinationsTotalData = '';
        if (easyCombinationsTotal !== undefined) {
            easyCombinationsTotalData = " data-easy-combinations-total='" + JSON.stringify(easyCombinationsTotal) + "'"
        }
        // Unlocked
        let easyCombinationsUnlocked = obj['easyCombinationsUnlocked'];
        let easyCombinationsUnlockedData = '';
        if (easyCombinationsUnlocked !== undefined) {
            easyCombinationsUnlockedData = " data-easy-combinations-unlocked='" + JSON.stringify(easyCombinationsUnlocked) + "'"
        }

        // Hard Combinations
        let hardCombinationsTotal = obj['hardCombinationsTotal'];
        let hardCombinationsTotalData = '';
        if (hardCombinationsTotal !== undefined) {
            hardCombinationsTotalData = " data-hard-combinations-total='" + JSON.stringify(hardCombinationsTotal) + "'"
        }
        // Unlocked
        let hardCombinationsUnlocked = obj['hardCombinationsUnlocked'];
        let hardCombinationsUnlockedData = '';
        if (hardCombinationsUnlocked !== undefined) {
            hardCombinationsUnlockedData = " data-hard-combinations-unlocked='" + JSON.stringify(hardCombinationsUnlocked) + "'"
        }

        let objHtml = '<div class="gimmick-selection-item character-item' + objClass + '" data-tag="' + obj['tag'] + '"' +
            goodCombinationsData + badCombinationsData + okayCombinationsData + timesUsedData +
            easyCombinationsTotalData + easyCombinationsUnlockedData +
            hardCombinationsTotalData + hardCombinationsUnlockedData +
            helpText + '>' +
            obj['name'] + level + '</div>';

        charactersHtml += objHtml;
    });
    $('.characters-container').html(charactersHtml);

    // Gimmick
    if (data['gimmick']) {
        $('.create-gimmick-superstar-name').text(data['name'] + ' (' + data['gimmick'] + ')')
    }
    else {
        $('.create-gimmick-superstar-name').text(data['name'])
    }
    $('#gimmick-graphic').data('key', JSON.stringify(data['graphic']));
    $('#gimmick-graphic').data('uid', uid);
    $('#create-gimmick-container .change-name-input').val(data['name']);
    $('#create-gimmick-container .change-alignment-select').val(data['alignment']);
    if (globals.game.story === 'mars') {
        $('#create-gimmick-container .change-name-input').parent().parent().hide();
    }
    $('#create-gimmick-container').fadeIn();

    // New gimmick available
    if (data['nextGimmickBoost']) {
        $('.next-gimmick-boost').html('<span class="help-text green" ' +
            'title="Due to an Important Moment, a Gimmick change is available for free ' +
            'with an Effectiveness Boost.">+ 20% Eff.</span>');
        $('.create-gimmick-cost').text('0');
    }
    else {
        $('.next-gimmick-boost').text('');
    }

    // Add cost
    if ($el.text() === 'Create Gimmick') {
        $('.create-gimmick-cost').text('0');
        $('.create-gimmick-label').text('Create Gimmick');
        $('#remove-gimmick-button').hide();
    }
    else {
        $('.create-gimmick-cost').text('30');
        $('.create-gimmick-label').text('Change Gimmick');
        $('#remove-gimmick-button').show();
    }

    // Reset
    $('.gimmick-item-custom-name').val('');
    $('.character-selected').text('');
    $('.personality-selected').text('');
    $('.custom-gimmick-value').text('');
    $('.default-gimmick-label').show();
    $('.create-gimmick-combination').html('None');
    $('input:radio[name="radio-gimmick-appearance-option"][value="existing"]').trigger('click');
    allowGenerateGimmick = true;
    $('.gimmick-times-used').text('');
    $('.gimmick-penalty').text('');
    $('.personality-easy-combinations-unlocked').text('');
    $('.personality-easy-combinations-total').text('');
    $('.personality-hard-combinations-unlocked').text('');
    $('.personality-hard-combinations-total').text('');
    $('.combinations-count-divider').text('');
    $('.gimmick-item-filter').removeClass('selected');
}

function showChangeNameData({data, type, memberName} = {}) {
    if (!data['error']) {
        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Update faction name
        if (type === 'faction') {
            $('.faction-details-name').text(data['name'])
        }
        // Update roster member name
        else {
            $('.roster-member-name').text(data['name']);

            // Update name in roster view
            $('.roster-member:contains(' + data['previousName'] + ')').text(data['name']);
        }

        // Go back to superstar info
        $('#change-name-container').hide();
        if (type === 'faction') {
            $('.faction-details-container').fadeIn('fast');
        } else {
            $('#roster-member-details').fadeIn('fast');
        }

        notie.alert({type: 4, text: "Name changed"});
    } else {
        if (data['error'] === 'not-enough-points') {
            notie.alert({type: 3, text: "You do not have enough Creative Points to change this {0}'s Name".format(memberName)});
        } else if (data['error'] === 'same-name') {
            notie.alert({type: 3, text: "Enter a different Name from the {0}'s current Name".format(memberName)});
        } else if (data['error'] === 'mars') {
            notie.alert({type: 3, text: "You cannot change Talent Names in Wrestling on Mars"});
        } else if (data['error'] === 'pow-person') {
            notie.alert({type: 3, text: "\"Why change their name? That's who the fans know them as.\" - Hank Hughes"});
        } else if (data['error'] === 'owner-name-change') {
            notie.alert({type: 3, text: "You cannot change the Owner's Name"});
        } else if (data['error'] === 'same-name-as-owner') {
            notie.alert({type: 3, text: "You cannot change a Talent's Name to the Owner's Name"});
        } else if (data['error'] === 'name-exists') {
            notie.alert({type: 3, text: "A {0} with that name already exists on your Roster".format(memberName)});
        }
    }
}

function showChangeGraphicData({data, appearanceOption} = {}) {
    if (!data['error']) {
        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Update roster member graphics data
        $('#roster-member-details').data('graphic', [data['graphic']]);

        // Update unread messages
        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }

        // Go back to superstar info
        $('#change-appearance-container').find('#back-to-roster-member').trigger('click');

        if (appearanceOption === 'change') {
            notie.alert({type: 4, text: "Appearance changed"});
        } else {
            notie.alert({type: 4, text: "Graphic removed"});
        }
    } else {
        if (data['error'] === 'not-enough-points') {
            notie.alert({
                type: 3,
                text: "You do not have enough Creative Points to change this Superstar's Appearance"
            });
        }
    }
}

function showChangeAlignmentData({data, memberName} = {}) {
    if (!data['error']) {
        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Update alignment
        let rosterMemberAlignmentHtml = getRosterMemberAlignmentHtml(data);
        $('.roster-member-alignment').html(rosterMemberAlignmentHtml);

        // Go back to superstar info
        $('#change-alignment-container').hide();
        $('#roster-member-details').fadeIn();

        if (memberName === 'Team') {
            notie.alert({type: 4, text: "Alignments changed"});
        } else {
            notie.alert({type: 4, text: "Alignment changed"});
        }
    } else {
        if (data['error'] === 'not-enough-points') {
            notie.alert({
                type: 3,
                text: "You do not have enough Creative Points to change this {0}'s Alignment".format(memberName)
            });
        } else if (data['error'] === 'same-alignment') {
            notie.alert({
                type: 3,
                text: "Select a different Alignment from the {0}'s current Alignment".format(memberName)
            });
        }
    }
}

function showChangePronounData({data} = {}) {
    if (!data['error']) {
        $('.roster-member-pronoun').text(toTitleCase(data['pronoun']));

        // Go back to superstar info
        $('#change-pronoun-container').hide();
        $('#roster-member-details').fadeIn('fast');

        notie.alert({type: 4, text: "Pronoun changed"});
    } else {
        if (data['error'] === 'mars') {
            notie.alert({type: 3, text: "You cannot change Talent Pronouns in Wrestling on Mars"});
        }
        if (data['error'] === 'passion') {
            notie.alert({type: 3, text: "You cannot change Talent Pronouns in Passion of Wrestling"});
        }
    }
}

function showChangeBrandData({data} = {}) {
    if (!data['error']) {
        let rosterMemberBrandNameHtml = '<span class="medium-grey">None</span>';
        if (data['brandName']) {
            rosterMemberBrandNameHtml = data['brandName'];
        }
        $('.roster-member-brand').html(rosterMemberBrandNameHtml);

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Update unread messages
        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }

        // Go back to superstar info
        $('#change-brand-container').hide();
        $('#roster-member-details').fadeIn('fast');

        notie.alert({type: 4, text: "Brand changed"});
    }
    else {
        if (data['error'] === 'not-paid') {
            notie.alert({type: 3, text: "Brands are only available in JoW Paid."});
        }
        if (data['error'] === 'mars') {
            notie.alert({type: 3, text: "You cannot change Brands in Wrestling on Mars"});
        }
        else if (data['error'] === 'passion') {
            notie.alert({type: 3, text: "You cannot change Brands in Passion of Wrestling"});
        }
        else if (data['error'] === 'roster-member-not-found') {
            notie.alert({type: 3, text: "That talent could not be found. Please try again."});
        }
        else if (data['error'] === 'brand-name-not-found') {
            notie.alert({type: 3, text: "That brand could not be found. Please try again."});
        }
        else if (data['error'] === 'not-enough-points') {
            notie.alert({type: 3, text: "You do not have enough Creative Points to change this Superstar\'s Brand."});
        }
    }
}

function showAddGimmickData({data, personality, character} = {}) {
    if (!data['error']) {
        let html = '';
        let notificationText;

        switch (data['combinationResult']) {
            case 'easy':
                html = '<span class="green">Easy</span>';
                notificationText = '{0} is excited to debut {1} new "{2}" Gimmick!';
                break;
            case 'hard':
                html = '<span class="red">Hard</span>';
                notificationText = '{0} is uncertain about {1} new "{2}" Gimmick.';
                break;
            case 'okay':
                html = '<span class="dark-yellow">Okay</span>';
                break;
            default:
                html = '<span class="dark-grey">None</span>';
                break;
        }

        // Show combination result
        $('.create-gimmick-combination').html(html).hide().fadeIn();
        if (notificationText) {
            let gimmickName = '<span class="character-label">' + personality + ' ' + character + '</span>';
            let formattedText = notificationText.format(
                data['superstarName'], data['superstarPossessivePronoun'], gimmickName
            );
            notie.alert({
                type: 4,
                text: '<span class="display-block">' + formattedText + '</span>',
                stay: true
            });
        } else {
            notie.alert({type: 4, text: "Gimmick added"});
        }

        // Add new gimmick
        let gimmickDescription = getGimmickDescription(data['gimmick']);
        $('.roster-member-gimmick').html(gimmickDescription);
        $('#edit-gimmick-button').text('Change Gimmick');

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Update name if changed
        if (data['previousName']) {
            $('.roster-member-name').text(data['superstarName']);
            // Update name in roster view
            $('.roster-member:contains(' + data['previousName'] + ')').text(data['superstarName']);
        }

        // Update alignment if changed
        if (data['alignment'] !== undefined) {
            let rosterMemberAlignmentHtml = getRosterMemberAlignmentHtml(data);
            $('.roster-member-alignment').html(rosterMemberAlignmentHtml);
        }

        // Update roster member graphics data
        $('#roster-member-details').data('graphic', [data['graphic']]);

        // Update unread messages
        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }

        // Go back to superstar info
        $('#create-gimmick-container').find('#back-to-roster-member').trigger('click');
    } else {
        if (data['error'] === 'not-enough-points') {
            notie.alert({type: 3, text: "You do not have enough Creative Points to create this Gimmick"});
        } else if (data['error'] === 'same-name') {
            notie.alert({
                type: 3,
                text: "The new Gimmick cannot have the same name as the current Gimmick"
            });
        } else if (data['error'] === 'pow-person') {
            notie.alert({type: 3, text: "\"Why change their name? That's who the fans know them as.\" - Hank Hughes"});
        }
    }
}

function showRemoveGimmickData({data} = {}) {
    if (!data['error']) {
        $('.roster-member-gimmick').html('<span class="medium-grey">None</span>');
        $('#edit-gimmick-button').text('Create Gimmick');

        notie.alert({type: 4, text: "Gimmick removed"});

        // Go back to superstar info
        $('#create-gimmick-container').find('#back-to-roster-member').trigger('click');
    } else {
        if (data['error'] === 'superstar-not-found') {
            notie.alert({
                type: 3,
                text: "That Superstar could not be found. Please try again."
            });
        } else if (data['error'] === 'no-gimmick-present') {
            notie.alert({
                type: 3,
                text: "That Superstar does not have a Gimmick assigned."
            });
        }
    }
}

function generateGimmick() {
    playSoundEffect('success');

    // Unselect everything
    $('.character-selected').text('');
    $('.personality-selected').text('');
    $('.custom-gimmick-value').text('');
    $('.character-item.selected').removeClass('selected');
    $('.personality-item.selected').removeClass('selected');
    $('.gimmick-times-used').text('');
    $('.gimmick-penalty').text('');
    $('.personality-easy-combinations-unlocked').text('');
    $('.personality-easy-combinations-total').text('');
    $('.personality-hard-combinations-unlocked').text('');
    $('.personality-hard-combinations-total').text('');
    $('.combinations-count-divider').text('');

    let choice = getRandomInt(0, 100);
    if (choice < 60) {
        let selectedCharacter = getRandomChoice($('.character-item:not(.locked)'));
        $(selectedCharacter).trigger('click');
        let selectedPersonality = getRandomChoice($('.personality-item'));
        $(selectedPersonality).trigger('click');
        $('.gimmick-item-custom-name').val('');
    }
    else {
        let randomGimmicks = ['Legend Killer', 'Grim Reaper', 'Rock Star', 'Crime Boss', 'General Manager', 'Demon Hunter',
            'Secret Service', 'Career Killer', 'Unleashed Animal', 'Wrestling God', 'Parole Officer',
            'Crazy Russian', 'Country Singer', 'Outdoorsman', 'Little Dog', 'Bulldog', 'Brawler',
            'Romantic', 'Hugger', 'Lovesick', 'Royalty', 'Comic-book Hero', 'Comic-book Villain',
            'Supermodel', 'Hacker', 'Redneck', 'Bodyguard', 'Rebel', 'Monk', 'Hypocrite',
            'Hustler', 'Butcher', 'Surfer', 'Skater', 'Ninja', 'Iceman', 'Dancer',
            'Poser', 'Hoser', 'Lumberjack'];
        $('.gimmick-item-custom-name').val(getRandomChoice(randomGimmicks)).trigger('input');
    }
}

function formatGimmickItemsGrid() {
    let items = $('.character-item:visible');
    items.each(function (i, e) {
        formatGridItemBorder(e, i, items)
    });
    items = $('.personality-item:visible');
    items.each(function (i, e) {
        formatGridItemBorder(e, i, items)
    });
}

function formatGridItemBorder(item, i, items) {
    $(item).removeClass('border-bottom-0 border-right-0');

    // Remove bottom border for elements in last row
    if (items.length >= 5) {
        if (items.length % 2 === 0) {
            if ((i === items.length - 1 || i === items.length - 2)) {
                $(item).addClass('border-bottom-0')
            }
        }
        else {
            if (i === items.length - 1) {
                $(item).addClass('border-bottom-0')
            }
        }
    }

    if (i % 2 !== 0) {
        $(item).addClass('border-right-0')
    }
}

function updateGimmickNameText() {
    $('.character-selected').show();
    $('.personality-selected').show();
    // If nothing selected, show default gimmick label
    if (!$('.character-selected').text() && !$('.personality-selected').text()) {
        $('.default-gimmick-label').show()
    }
    $('.custom-gimmick-value').text('');
}

function updateCombinationText() {
    // Custom gimmick
    if ($('.gimmick-item-custom-name').val() && $('.gimmick-item-custom-name').is(":focus")) {
        $(".create-gimmick-combination").html('None');
        return false;
    }

    let el = $('.personality-item.selected');
    if (el.length > 0) {
        if (el.hasClass('green')) {
            $(".create-gimmick-combination").html('<span class="green">Easy</span>');
        }
        else if (el.hasClass('red')) {
            $(".create-gimmick-combination").html('<span class="red">Hard</span>');
        }
        else if (el.hasClass('dark-yellow')) {
            $(".create-gimmick-combination").html('<span class="dark-yellow">Okay</span>');
        }
        else {
            if ($('.character-item.selected').length > 0) {
                $(".create-gimmick-combination").html('???')
            }
            else {
                $(".create-gimmick-combination").html('None')
            }
        }
    }
    else {
        $(".create-gimmick-combination").html('None')
    }
}

function getCharacterUnlockedBy(name) {
    let unlockedByName;
    switch (name) {
        case 'Abstainer':
            unlockedByName = 'Punk';
            break;
        case 'Degenerate':
            unlockedByName = 'Rich Person';
            break;
        case 'Enigma':
            unlockedByName = 'Spot Monkey';
            break;
        case 'Rapper':
            unlockedByName = 'Singer';
            break;
        case 'Rockstar':
            unlockedByName = 'Musician';
            break;
        case 'Cult Leader':
            unlockedByName = 'Occultist';
            break;
        case 'Drug Lord':
            unlockedByName = 'Big Shot';
            break;
        case 'Royalty':
            unlockedByName = 'VIP';
            break;
        case 'Undead':
            unlockedByName = 'Demon';
            break;
        case 'Game Dev.':
            unlockedByName = 'Philosophist';
            break;
        case 'Martian':
            unlockedByName = 'Game Dev.';
            break;
    }
    return unlockedByName;
}

function showReleaseTalentData({data, memberVerb} = {}) {
    if (!data['error']) {
        // Go back
        setTimeout(function () {
            let element = $('#roster-member-details').data('element');

            if (element === '#view-managers-container') {
                $('.view-managers-company-select').trigger('change')
            }
            else {
                // Go back to booking
                if (element === '#booking-container') {
                    if ($('#book-tag-team-menu-button').hasClass('selected')) {
                        $('.tag-match-options').find('.selected').trigger('click')
                    }
                    else {
                        $('#booking-menu').find('.selected').trigger('click')
                    }
                }
                else {
                    // Go back to view teams
                    if ($(element).attr('id') === 'view-teams-container') {
                        $('.view-teams-company-select').trigger('change');
                    }
                    // Go back to view roster
                    else {
                        $('.select-company-for-view-roster').trigger('change');
                    }
                }
            }
        }, 1300);

        let overnessDecrease = '<span class="stale-color">' + data['overnessDecrease'] +
            '<span class="margin-left-2">%</span></span>';

        let html = '<span class="display-block">{0} {1} been released, lowering {2} Overness by {3}</span>'.format(data['name'],
            memberVerb, data['possessivePronoun'], overnessDecrease);
        notie.alert({
            type: 4, text: html
        });
    } else {
        if (data['error'] === 'not-found') {
            notie.alert({type: 3, text: 'Talent not found in your roster'});
        } else if (data['error'] === 'champion') {
            notie.alert({type: 3, text: 'Champions cannot be released'});
        } else if (data['error'] === 'trade-deal') {
            notie.alert({type: 3, text: 'Talent belonging to other Companies cannot be released'});
        } else if (data['error'] === 'martian') {
            notie.alert({type: 3, text: 'Markus won\'t put through the release of any Martians'});
        } else if (data['error'] === 'pow-person') {
            notie.alert({type: 3, text: '\"What? No, we need that talent!\" - Hank Hughes'});
        } else if (data['error'] === 'booked') {
            notie.alert({type: 3, text: 'Superstars booked in a match cannot be released'});
        }
    }
}

function showDisbandTagTeamData({data} = {}) {
    if (!data['error']) {
        let html = '<span class="display-block">' +
            data['name'] + " have disbanded" +
            '</span>';

        if (data['feudPotential']) {
            let feudPotentialHtml = getFeudPotentialHtml(data['feudPotential']);
            html += '<span class="display-block">' + feudPotentialHtml + '</span>';
        }

        // Update unread messages
        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }

        notie.alert({type: 4, text: html, stay: true});

        // Go back to roster view
        setTimeout(function () {
            let element = $('#roster-member-details').data('element');

            // Go back to booking
            if (element === '#booking-container') {
                if ($('#book-tag-team-menu-button').hasClass('selected')) {
                    $('.tag-match-options').find('.selected').trigger('click')
                }
                else {
                    $('#booking-menu').find('.selected').trigger('click')
                }
            } else {
                // Go back to view teams
                if ($(element).attr('id') === 'view-teams-container') {
                    $('.view-teams-company-select').trigger('change');
                }
                // Go back to view roster
                else {
                    $('.select-company-for-view-roster').trigger('change');
                }
            }

            // Tutorial action check
            if (data['nextTutorialState']) {
                globals.game.tutorialState = data['nextTutorialState']
            }

            // Tutorial action check
            setTimeout(function () {
                checkTutorialStepAction('disband_team');
            }, 100);
        }, 1300);

    } else {
        if (data['error'] === 'not-found') {
            notie.alert({type: 3, text: "That team could not be found. Please try again."});
        } else if (data['error'] === 'champion') {
            notie.alert({type: 3, text: "Champions cannot be disbanded."});
        } else if (data['error'] === 'booked') {
            notie.alert({type: 3, text: "Teams booked at the upcoming event cannot be disbanded."});
        }
    }
}

function getTimesUsedPenalty(timesUsed) {
    if (timesUsed >= 8) {
        return 'Large Penalty'
    } else if (timesUsed >= 5) {
        return 'Medium Penalty'
    } else if (timesUsed >= 2) {
        return 'Small Penalty'
    } else {
        return ''
    }
}

export {loadViewRosterPage, loadViewIndiesPage, loadViewTeamsPage, loadViewManagersPage, loadMakeTradeOfferPage,
    loadViewRankingsPage, loadViewFactionsPage, addCompaniesDataToSelectElement, showRosterMemberNameData,
    loadAddStaffTaskPage, showViewRosterMemberPageData, loadViewRosterMemberPage, selectSuperstarTraitElement}